const messagesEN = {
    code: "en",
    messages: {
        zoho: {
            SETTING_GROUP: "Settings",
            usermapping: "User Mapping",
        },
        chatWindow: {
            thereIsNoChatContent: "No chat content available.",
            thereIsNoChatContentDsc: "You can view the chat content and send messages here.",
            interactions: "Interactions:",
            departments: "Departments",
            channels: "Channels",
            date: "Date",
            lastChatStatus: "Last Chat Status",
            all: "All",
            queued: "Queued",
            open: "Open",
            closed: "Closed",
            private: "Private",
            chatbot: "Chatbot",
            lostMissed: "Lost / Missed",
            interaction: "Interaction",
            myActiveInbox: "My Active Inbox",
            activeQueueInbox: "Active + Queue Inbox",
            chatbotActiveInbox: "Chatbot Active Inbox",
            myDepartmentsActiveInbox: "My Departments Active Inbox",
            notInteractedYesterday: "No interactions yesterday",
            queueInbox: "Queue Inbox",
            whatsappActiveInbox: "WhatsApp Active Inbox",
            socialMediaActiveInbox: "Social Media Active Inbox",
            missedThisMonth: "Missed Chats This Month",
            chooseAFileOrDragItHere: "Choose a file or drag it here!",
            watching: "Watching",
            selectFilter: "Select Filter",
            clearAll: "Clear All",
            me: "Me",
            today: "Today",
            yesterday: "Yesterday",
            thisWeek: "This Week",
            lastWeek: "Last Week",
            last7Days: "Last 7 Days",
            last30Days: "Last 30 Days",
            thisMonth: "This Month",
            lastMonth: "Last Month",
            last24h: "Last 24 Hours",
            custom: "Custom",
            startMessage: "Start Message",
            goToAgentReport: "Go to Agent Report",
            agentDetail: "Agent Detail",
            agentList: "Agent List",
            selectedFilter: "Selected Filter",
            groupBy: "Group",
            owner: "Owner",
            none: "No Group",
            agent: "Agent",
            department: "Department",
            tag: "Tag",
            website: "Website",
            channel: "Channel",
            platform: "Platform",
            answerStatus: "Answer Status",
            sortBy: "Sort",
            lastPostAbove: "Last Post Above",
            newChatsAbove: "New Chats Above",
            oldChatsAbove: "Old Chats Above",
            live: "Live",
            systemStatus: "System Status",
            refresh: "Refresh",
            close: "Close",
            totalCustomers: "Total Customers",
            totalAnswered: "Total Answered",
            waitingAnswer: "Waiting Answer",
            totalAgentInChat: "Total Agent In Chat",
            onlineAgentCount: "Online Agent Count",
            totalCustomer: "Total Customer",
            answered: "Answered",
            unanswered: "Unanswered",
            noContactWasFoundMatchingTheCurrentFilters: "No contact was found matching the current filters.",
            you: "You",
            others: "Others",
            queue: "Queue",
            chatbotContact: "Chatbot",
            closedContact: "Closed",
            myInteractions: "My Interactions",
            special: "Özel",
            allInteractions: "All Contacts",
            waiting: "Wating",
            departmentToWhichItIsAffiliated: "Department to which it is affiliated",
        },
        form: {
            title: {
                titleSettings: "Title Settings",
                fullNameSettings: "Full Name Settings",
                emailSettings: "Email Settings",
                addressSettings: "Address Settings",
                phoneSettings: "Phone Settings",
                datePickerSettings: "Date Picker Settings",
                shortTextSettings: "Short Text Settings",
                longTextSettings: "Long Text Settings",
                dropDownListSettings: "Drop Down List Settings",
                singleChoiceSettings: "Single Choice Settings",
                multipleSelectionSettings: "Multiple Selection Settings",
                numberSettings: "Number Settings",
                hourSettings: "Hour Settings",
                spinnerSettings: "Spinner Settings",
                sendSettings: "Send Settings",
                starRatingSettings: "Star Rating Settings",
                ratingScaleSettings: "Rating Scale Settings",
                separationElementSettings: "Separation Element Settings",
                fileUploadSettings: "File Upload Settings",
                imageSettings: "Image Settings"
            },
            lineColor: "Line Color",
            separatorColorInfo: "Select or enter the color of the separator (e.g., #RRGGBB)",
            separatorHeight: "Separator Height",
            separatorHeightInfo: "Enter the height of the separator",
            bottomSpace: "Bottom Space",
            bottomSpaceInfo: "Add space below the separator",
            topSpace: "Top Space",
            topSpaceInfo: "Add space above the separator",
            sideSpace: "Side Space",
            sideSpaceInfo: "Add space to the left and right of the separator",
            onlyImageUpload: "You can only upload an image!",
            imageSizeLimit: "Your image size must be at most 5MB!",
            image: "Image",
            size: "Size",
            width: "Width",
            height: "Height",
            imageAlignment: "Image Alignment",
            wide: "Wide",
            small: "Small",
            textAlignment: "Text Alignment",
            chooseHorizontalAlignment: "Choose how to align this title horizontally.",
            headerSize: "Header Size",
            addSmallTextBelowHeader: "Add a smaller text below the header",
            subHeaderText: "Subheader Text",
            subLabel1: "Sub Label(1)",
            subLabel2: "Sub Label(2)",
            validPhoneNumber: "Please enter a valid phone number",
            masked: "Masked",
            copyField: "Copy Field",
            copyFieldDescription: "Create a copy of this field while keeping all its saved settings",
            enterQuestion: "Enter a question",
            notRequired: "Not Required",
            addDescriptionBelowField: "Add a short description below the field",
            setDefault: "Set as Default",
            pleaseSelect: "Please Select",
            placeholder: "Placeholder",
            required: "Required",
            fieldEmptyError: "Do not allow the form to be submitted if this field is empty",
            subLabels: "Sub Labels",
            addressLine1: "Address Line 1",
            addressLine2: "Address Line 2",
            postalCode: "Postal Code",
            stateProvince: "State / Province",
            chooseLabelAlignment: "Choose how to align the label text horizontally",
            right: "RIGHT",
            left: "LEFT",
            top: "TOP",
            labelAlignment: "Label Alignment",
            fieldLabel: "Field Label",
            read: "Read",
            itemsPerPage: "items/page",
            downloadAllDataAsPDF: "Download All Data as PDF",
            downloadAllDataAsExcel: "Download All Data as Excel",
            downloadSelectedDataAsPDF: "Download Selected Data as PDF",
            downloadSelectedDataAsExcel: "Download Selected Data as Excel",
            selectItemToViewDetails: "Select an item to view details.",
            deleteFormConfirm:
                "If you delete this form, all data associated with the form will be permanently deleted. Are you sure you want to continue?",
            redicetFormAnswer: "FORWARD FORM ANSWERS",
            redicetFormAnswerDesc:
                "When forwarding form answers to the ticket system, please make sure to request a phone number or e-mail address from the user in the form. This information is important for faster and more effective communication with the user.",
            redicetFormAnswerDesc2: "Form answers are routed to the system as tickets",
            rediectAnswersToTicket: "Redirect Incoming Answers to Ticket",
            errorTicketMode: "Error updating ticket mode:",
            formView: "View Form",
            formEdit: "Update Form",
            totalResponse: "Total Response",
            totalUnreadResponse: "Total Unread Response",
            singleChoice: "Single Choice",
            totalReadResponse: "Total Read Responses",
            totalArchivedResponse: "Total Archived Response",
            _delete: "Delete",
            inbox: "Inbox",
            edit: "Edit",
            forms: "Forms",
            formsDesc: "You can manage your forms here.",
            createaForm: "Create Form",
            allForms: "All Forms",
            formPublish: {
                shareFast: "SHARE FAST",
                shareFastDesc: "Direct form link and social sharing",
                add: "ADD",
                addDesc: "Various web page embed options",
                assignForm: "ASSIGN FORM",
                assignFormDesc: "Assign your forms to others",
                emails: "EMAILS",
                emailsDesc: "Reminders and instant sharing",
                prefill: "PREFILL",
                prefillDesc: "Pre-populate your forms",
                pdf: "PDF",
                pdfDesc: "Download fillable PDF",
                platforms: "PLATFORMS",
                platformsDesc: "Third-party publish options",
                linkToYour: "LINK TO YOUR FORM",
                linkToYourDesc: "Your form has been securely published and is ready for use at this address.",
                shareWithLink: "SHARE WITH LINK",
                publicForm: "Public Form",
                copyLink: "COPY LINK",
                openInNewTab: "OPEN IN NEW TAB",
                linkCopied: "Link Copied",
                codeCopied: "Code Copied",
                iframe: "IFRAME",
                iframeDesc: "Add the form to your page with iFrame",
                openWindow: "OPEN WINDOW",
                openWindowDesc: "Link to a popup form",
                formAddDesc: "Copy and paste this snippet into your code and embed your form on your website.",
            },
            formSettings: {
                enterNameForm: "Enter a name for this form",
                selectStatusForm: "Select the status of your form",
                disabled: "Disabled",
                disableSpecifiedTime: "Disable at a specified time or when the response limit is reached",
                disableFormResponse: "Disable when Form Response limit is reached",
                pageShownAfterForm: "The page shown after the form is submitted",
                formNotFound: "Form not found.",
                errorLoadingform: "An error occurred while loading the form.",
                formUpdated: "The form title was updated successfully.",
                formErrorUpdated: "An error occurred while updating the form header",
                formSettings: "FORM SETTINGS",
                changeFormStateAndProperties: "Change form state and properties",
                title: "Title",
                newFormSettings: "New Form Settings",
                formStatus: "Form Status",
                activateOrDeactivate: "Activate or deactivate your form",
                effective: "EFFECTIVE",
                yourFromIsVisible: "Your form is currently visible and can receive form responses",
                emails: "EMAILS",
                emailsDesc: "Send autoresponder emails and notification emails",
                conditions: "CONDITIONS",
                conditionsDesc: "Conditional logic section that triggers actions based on form inputs",
                thankYouPage: "THANK YOU PAGE",
                thankYouPageDesc: "The page shown after submitting the form",
                integretions: "INTEGRATIONS",
                integretionsDesc: "Connect your form to other applications",
            },
            clickToDeleteYourLogo: "Click to delete your logo",
            create: "Create",
            settings: "Settings",
            load: "Publish",
            insertFormField: "Insert Form Field",
            addYourLogo: "Add Your Logo",
            surveyElements: {
                surveyElements: "Survey Elements",
                dataTable: "Data Table",
                starRating: "Star Rating",
                evaluationScale: "Evaluation Scale",
            },
            pageElements: {
                pageElements: "Page Elements",
                separationElement: "Separation Element",
                partitionCollapse: "Partition Collapse",
                pageBreak: "Page Break",
            },
            basicElements: {
                basicElements: "Basic Elements",
                shortText: "Short Text",
                longText: "Long Text",
                paragraph: "Paragraph",
                dropDownList: "Dropdown List",
                singleChoice: "Signle Choice",
                multipleSelection: "Multiple Selection",
                number: "Number",
                image: "İmage",
                fileUpload: "File Upload",
                hour: "Hour",
                spinner: "Spinner",
                send: "Send",
            },
            formElements: {
                formElements: "Form Elements",
                title: "Title",
                fullName: "Full Name",
                email: "Email",
                address: "Address",
                phone: "Phone",
                datePicker: "Date Picker",
                appointment: "Appointment",
                signature: "Signature",
                productList: "Product List",
            },
            startWithaBlankForm: "Start with a blank form",
            startFromScratch: "Start From Scratch",
            createOrTransferaForm: "Create or transfer a form to start collecting data",
            createForm: "Create a Form",
        },
        automation: {
            calendarEventCreated: "Event created in the calendar",
            calendarEventUpdated: "Event updated in the calendar",
            calendarEventDeleted: "Event deleted in the calendar",
            reservationCreated: "Reservation created",
            reservationDateChanged: "Reservation date changed",
            reservationDeleted: "Reservation deleted",
            chatLost: "When chat is lost",
            webchatCompleted: "When web chat is completed",
            instagramCompleted: "When chat from Instagram channel is completed",
            messengerCompleted: "When chat from Messenger channel is completed",
            whatsappCompleted: "When chat from WhatsApp channel is completed",
            telegramCompleted: "When chat from Telegram channel is completed",
            chatAssignedToAgent: "When chat is assigned to an agent",
            profileButtonClicked: "When the automation button is clicked from the profile",
            operatedTask: "Task being run",
            tableSelection: "Table Selection",
            selectTable: "Select Table",
            whichTableAutomationAddRecords:
                "Which table do you want to run the automation when a record is added? Please select.",
            whichTableAutomationUpdateRecords:
                "When a record is updated in which table do you want to run the automation? Please select.",
            whichTableAutomationDeletedRecords:
                "From which table do you want to run the automation when a record is deleted? Please select.",
            whichTableAutomationClickRecords:
                "In which table do you want to run the automation when the automation button on a record is clicked? Please select.",
            planStatus: "Plan Status",
            scheduled: "Scheduled",
            completed: "Completed",
            cancelled: "Canceled",
            startTest: "Start Test",
            unpublish: "Unpublish",
            whenMessagePicked: "When a message is selected via the chat interface",
            whenTaskCompleted: "When a task is completed",
            whenTaskDeleted: "When a task is deleted",
            whenTaskAssigneeChanged: "When a task assignee is changed",
            whenTaskPriorityChanged: "When a task priority is changed",
            whenTaskDueDateChanged: "When the due date of a task is changed",
            whenTaskStatusChanged: "When a task status is changed",
            whenTaskArchived: "When a task is archived",
            whenTagAdded: "When a tag is added to the task",
            whenTagRemovedTask: "When a tag is removed from a task",
            whenTagChecklist: "When a task checklist is completed",
            whenReminderActivated: "When a reminder is activated",
            whenTicketCreated: "When Ticket Created",
            whenTicketStageChanged: "When a ticket stage is changed",
            whenTicketAssigneeChanged: "When a ticket assignee is changed",
            whenTicketClosed: "When a ticket is closed",
            whenTicketUpdated: "When a ticket is updated",
            archivingDate: "Archiving Date",
            autoPlanAndTaskHistory: "Automation Plan and Task History",
            automation: "Automation",
            botScenario: "Bot Scenario",
            nameSurname: "First Name Last Name",
            phone164: "*Enter in E164 format. For example: 905396667744",
            whichWpChannels: "Which Whatsapp Channels to Add?",
            findContact: "Find Contact",
            findContacts: "Find Contacts",
            offsetDesc: "Skip the first N contacts. Default value is '0'. Use this to scroll through the contacts.",
            limitDesc: "Maximum number of contacts to return after offset. Default value is '10'. Use this to paginate",
            contact: "Contact",
            selectAction: "Select Action",
            addMethod: "Add Method",
            selectField: "Select Field",
            schedulerRunningPlanEx: "Scheduler Running Plan Example",
            schedulerPlanner: "Scheduler Planner",
            taskCreated: "Task Created?",
            taskStatus: "Task Statuses",
            terminateReason: "Termination Reason",
            taskDuration: "Task Duration",
            taskWakeUpCount: "Task WakeUp Count",
            completedAt: "Completed",
            cancelledAt: "Canceled",
            nextRunAt: "Next Run",
            configSchedulerAuto: "Configure Timer for Automation",
            saveChanges: "Save Changes",
            catchAllWebhooks: "Catch All Webhooks from this URL",
            webhookDataExPreview: "Webhook Data Sample Preview (will be shown after sending request)",
            webhookUrlCopied: "Webhook URL copied to clipboard",
            selectAnBlock: "Select a Block",
            dataFormats: "Data Formats",
            whenRecordCreated: "When a record is created",
            whenRecordUpdated: "When a record is updated",
            whenRecordDelete: "When a record is deleted",
            whenRecordAutomation: "When a record automation button  is clicked",
            whenWebhookTriggered: "When a webhook is triggered",
            whenChatCreated: "When a chat is created",
            whenChatClosed: "When a chat is closed",
            whenChatRated: "When a chat is rated",
            whenNewContactCreated: "When a new contact is created",
            whenContactUpdate: "When a contact update",
            whenContactPropUpdate: "When a contact-property update",
            whenNewTagAdded: "When a new tag added",
            whenTagRemoved: "When a tag is removed",
            whenNewEmailReceived: "When a new email is received",
            whenNewTaskCreated: "When a new task is created",
            whenNewMetaleadCreated: "When a new meta-lead is created",
            whenNewAgentCreated: "When a new agent is created",
            whenNewInvoiceCreated: "When a new invoice is created",
            whenNewWpReceived: "When a new whatsapp message is received",
            whenNewReservationCreated: "When a new reservation is created",
            whenNewChatbotReceived: "When a new chatbot message is received",
            chatWebhookAutomation: "Catch a Webhook And Run an Automation",
            automationName: "Automation Name",
            supsisObject: "Supsis Object",
            selectModule: "Select Module",
            bodyType: "Body Type",
            selectBodyType: "Select Body Type",
            selectMethod: "Select Method",
            trigger: "Trigger",
            published: "Published",
            createdAt: "Created At",
            action: "Action",
            type: "Type",
            view: "View",
            createTimerAutomation: "Create Timer Automation",
            createEventBasedAutomation: "Create Event Based Automation",
            createWebhookAutomation: "Create Webhook Automation",
            automationsDeletedSuccessfully: "Automations Deleted Successfully",
            createAnEventAutomation: "Create an Event Automation",
            automationsCouldNotBeDeleted: "Automations Could Not Be Deleted",
            timerAutomationCreatedSuccessfully: "Timer Automation Created Successfully",
            eventAutomationCreatedSuccessfully: "Event Automation Created Successfully",
            webhookAutomationCreatedSuccessfully: "Webhook Automation Created Successfully",
            automationsCouldNotBeFetched: "Automations Could Not Be Fetched ",
            automationPublishedStateUpdatedSuccessfully: "Automation Published State Updated Successfully",
            automationPublishedStateCouldNotBeUpdated: "Otomasyon Yayın Durumu Güncellenemedi",
            automations: "Automations",
            allAutomations: "All Automations",
            scheduledAutomations: "Scheduled Automations",
            eventBasedAutomations: "Event Based Automations",
            buttonAutomations: "Button Automations",
            webhookAutomations: "Webhook Automations",
            blocks: {
                START_POINT: "START POINT",
                AI_ASSISTANT: "AI ASSISTANT",
                FEEDBACK_AI_ASSISTANT: "FEEDBACK AI ASSISTANT",
                BOT_RESPONSE: "BOT RESPONSE",
                AI_BOT_RESPONSE: "AI RESPONSE (GPT-4o)",
                AI_CLASSIFICATION: "AI CLASSIFICATION",
                AI_MENU_FLOW: "AI MENU",
                OTP_WHATSAPP_FLOW: "OTP Whatsapp",
                OTP_SMS_FLOW: "OTP SMS",
                OTP_MAIL_FLOW: "OTP MAIL",
                AI_INSTAGRAM_FLOW: "AI INSTAGRAM COMMENT",
                PLATFORM_FLOW: "PLATFORM",
                DEFAULT_FALLBACK: "DEFAULT FALLBACK",
                DEFAULT_TIMEOUT: "DEFAULT TIMEOUT",
                AI_FUNCTIONS: "AI FUNCTIONS",
                FILTER: "FILTER",
                FLOW: "FLOW",
                ATTACHMENT_INPUT: "ATTACHMENT INPUT",
                USER_INPUT: "USER INPUT",
                GO_TO_STEP: "GO TO STEP",
                WEBHOOK: "WEBHOOK",
                SET_ATTRIBUTE: "SET ATTRIBUTE",
                ASSIGN_OWNER: "ASSIGN OWNER",
                QUESTION: "QUESTION",
                CLOSE_CHAT: "CLOSE CHAT",
                CREATE_TICKET: "CREATE TICKET",
                TICKET_UPDATE: "UPDATE TICKET",
                TRANSFER_CHAT: "TRANSFER CHAT",
                TRANSFER_TO_CHATBOT: "FORWARD TO CHATBOT",
                TAG_CHAT: "ADD TAG",
                REMOVE_TAG: "REMOVE TAG",
                SET_DEPARTMENT: "SET DEPARTMENT",
                SEND_TRANSCRIPT: "SEND TRANSCRIPT",
                SEND_SMS: "SEND SMS",
                SEND_MAIL: "SEND MAIL",
                CREATE_EVENT: "CREATE EVENT",
                CREATE_RESERVATION: "CREATE RESERVATION",
                RESERVATION_OPEN_URL: "Reservation Open Url",
                RESERVATION_SELECT_DAY: "Select reservation day",
                RESERVATION_EVENT_LIST: "Reservation list visitor",
                RESERVATION_SELECT_TIME: "Select reservation time",
                CREATE_TASK: "CREATE TASK",
                UPDATE_TASK: "UPDATE TASK",
                SHOPIFY_SHOW_PRODUCTS: "SHOPIFY SHOW PRODUCTS",
                SHOPIFY_PRODUCT_AVAILABILITY: "SHOPIFY PRODUCT AVAILABILITY",
                SHOPIFY_ORDER_STATUS: "SHOPIFY ORDER STATUS",
                AKINON_SHOW_PRODUCTS: "AKINON SHOW PRODUCTS",
                AKINON_FIND_PRODUCT: "AKINON FIND PRODUCT",
                AKINON_ORDER_STATUS: "AKINON ORDER STATUS",
                AKINON_SELECT_ORDER: "AKINON SELECT ORDER",
                AKINON_SELECT_SIZE: "AKINON SELECT SIZE",
                AKINON_FIND_NEAREST_STOCK: "SHOW STORE STOCK",
                AKINON_FIND_NEAREST_STORES: "SHOW NEAREST STORES",
                AKINON_SHOW_DISCOUNT_CODES: "SHOW DISCOUNT CODES",
                SUPPRESSION_ADD: "BLOCK CONTACT",
                SUPPRESSION_REMOVE: "UNBLOCK CONTACT",
                ADD_TO_SEGMENT: "SEGMENTE EKLE",
                REMOVE_FROM_SEGMENT: "SEGMENTTEN KALDIR",

                IDEASOFT_SELECT_ORDER: "SELECT ORDER",
                IDEASOFT_ORDER_STATUS: "GET ORDER STATUS",
                IDEASOFT_GET_MEMBER_INFO: "FILL MEMBER INFO",

                GET_LOCATION: "GET LOCATION",
                FALLBACK: "FALLBACK",
                TIMEOUT: "TIMEOUT",
                SUCCESS: "SUCCESSFUL",
                FAILURE: "FAIL",

                PROBEL_SELECT_BRANCH: "Select Branch",
                PROBEL_SELECT_CLINIC: "Select Polyclinic",
                PROBEL_SELECT_DAY: "Select Appointment Day",
                PROBEL_SELECT_HOUR: "Select Appointment Time",
                PROBEL_MAKE_APPOINTMENT: "Make Appointment",
                PROBEL_CANCEL_APPOINTMENT: "Appointment Cancellation",
                PROBEL_GET_PATIENT_TOKEN: "Get Patient Token",
                PROBEL_FILL_INFO: "Get MERNIS Information",
                PROBEL_SELECT_APPOINTMENT: "Select Appointment",

                SEND_WP_BUSINESS_MESSAGE: "SEND WHATSAPP MESSAGE",
                INSTAGRAM_COMMENT_REPLY: "REPLY COMMENT",
                INSTAGRAM_COMMENT_DELETE: "DELETE COMMENT",
                INSTAGRAM_COMMENT_SHOW: "SHOW COMMENT",
                INSTAGRAM_COMMENT_HIDE: "HIDE COMMENT",
                INSTAGRAM_COMMENT_REPLY_AS_PRIVATE: "REPLY AS PRIVATE",

                ASSIGN_OWNER: "Assign Owner",
                LOOP: "Loop",
                LOOP_NEXT: "Loop Next Item",
                LOOP_BREAK: "Break Loop",
                LOOP_CONTINUE: "Continue Next Loop",
                LOOP_FINISH: "Finish Loop",
                REPLY_TRENDYOL_QUESTION: "Reply Trendyol Question",
                SLEEP: "Sleep",
                NOOP: "Noop",
                CATCH_WEBHOOK: "Catch Webhook",
                TERMINATE_AUTOMATION: "Terminate Automation",
                OPEN_AI: "OPEN_AI",
                CREATE_CONTACT: "Create Contact",
                UPDATE_CONTACT: "Update Contact",
                FIND_CONTACTS: "Find Contacts",
                FIND_CONTACT: "Find Contact",
                FIND_CHATS: "Find Chats",
                FIND_CHAT: "Find Chat",
                WAIT_FOR: "Wait For",
                STRING_FORMAT: "Format String",
                NUMBER_FORMAT: "Format Number",
                DATE_FORMAT: "Format Date",
                RECORDS_FROM_CSV: "Records From CSV",
                MESSAGE_RECEIVED: "Message Received",
                ASK_AI: "Artificial Intelligent",

                TABLE_CREATE_RECORD: "Create Record",
                TABLE_DELETE_RECORD: "Delete Record",
                TABLE_UPDATE_RECORD: "Update Record",
                TABLE_FIND_RECORD: "Find Record",
                TABLE_FIND_RECORDS: "Find Records",

                ZOHO_FIND_RECORDS_BY_PHONE: "Zoho Find Record (with Phone)",
                ZOHO_ADD_ATTACHMENT_TO_RECORD: "Zoho Add Attachment",
                ZOHO_UPLOAD_IMAGE_TO_RECORD_FIELD: "Zoho Upload Image to Field",
                ZOHO_CREATE_RECORD: "Zoho Create Record",

                GET_SUPSIS_RECORD_BY_ID: "Get Supsis Record By ID",
            },
        },
        modules: {
            createFailed: "Module creation failed",
            createSuccess: "Module created successfully",
            moduleDeletedSuccessfully: "Module deleted successfully.",
            deleteModuleTitle: "Delete Module",
            deleteModuleContent: "Are you sure you want to delete this module?",
            modules: "Modules",
            modulesSettings: "Module Settings",
            displayName: "Display Name",
            description: "Description",
            table: "Table",
            menuApiSettings: "Menu and API Settings",
            icon: "Icon",
            save: "Save",
            exampleIcon: "Ex: extension, home",
            newModule: "New Module",
            moduleName: "Module Name",
            apiName: "API Name",
            type: "Type",
            apiAccess: "API Access",
            actions: "Actions",
            module: "Module",
            relation: "Relation",
            moduleRelationName: "Module/Relation Name",
            moduleRelationTable: "Module/Relation Table",
            showInMainMenu: "Show in Main Menu",
            apiEnabled: "API Enabled",
            settings: "Settings",
            createModule: "Create Module",
            relationType: "Relation Type",
            standartModule: "Standart Module",
            customTable: "Custom Table",
            localField: "Local Field",
            showingRemoteFieldInList: "Showing Remote Field In List",
            relationSettings: "Relation Settings",
            remoteField: "Remote Field",
            localFieldType: "Local Field Type",
            standart: "Standart",
            custom: "Custom",
            contact: "Contact",
            viewRecord: "View Record",
            recordDetail: "Record Detail",
            recordNotFound: "Record or table information not found",
            relatedLists: "Related Lists",
            recordViewer: "Record Viewer",
        },
        tables: {
            today: "Today",
            month: "Month",
            week: "Week",
            day: "Day",
            table: "Table",
            kanban: "Kanban",
            calendar: "Calendar",
            calendarSettings: "Calendar Settings",
            colorBy: "Color By",
            startDateField: "Start Date Field",
            endDateField: "End Date Field (Optional)",
            eventCardFields: "Event Card Fields",
            selectColorField: "Select Color Field",
            selectStartDateField: "Select Start Date Field",
            selectEndDateField: "Select End Date Field",
            cancel: "Cancel",
            save: "Save",
            kanbanNotAvailable: "Kanban View Not Available",
            needDropdownField:
                "To use the Kanban view, you need at least one static dropdown field in your table. You can add a new field or edit an existing one from the table settings.",
            notAvailable: "Calendar View Not Available",
            needDateField:
                "You need at least one date field in your table to use calendar view. You can add a new field or edit an existing one from table settings.",
            switchToTable: "Switch to Table View",
            calendarSettings: "Calendar Settings",
            operator: "Operator",
            conditionalColor: "Conditional Color",
            groupField: "Group Field",
            selectDirection: "Select Direction",
            showEmptyGroups: "Show Empty Groups",
            clearGrouping: "Clear Grouping",
            applyGrouping: "Apply Grouping",
            sortDirection: "Sort Direction",
            downloadSelectedRecords: "Download Selected Records",
            viewName: "View Name",
            enterViewName: "Enter View Name",
            enterDesc: "Enter Description",
            viewNameRequired: "View Name Required.",
            runWebhookAutomation: "Run Webhook Automation",
            downloadAllRecords: "Download All Records",
            deleteRecords: "Delete Records",
            editRecords: "Update Records",
            duplicateRecords: "Duplicate Records",
            selected: "Selected",
            sureDeleteRecords: "Are you sure you want to delete records?",
            selectedRecordSucs: "Selected records were deleted successfully.",
            errorDeletingRecords: "An error occurred while deleting records.",
            sureCopyRecords: "Are you sure you want to copy the records?",
            copyRecords: "Copy Records",
            recordsCopiedSucs: "The selected records were copied successfully.",
            recordsCopiedError: "An error occurred while copying the selected records.",
            viewSucsCreated: "The view was created successfully.",
            editMultipleRecords: "Edit Multiple Records",
            importRecords: "Import Records",
            importHasStarted:
                "Import has started. It may take a few minutes depending on the size of your data. Please wait...",
            anErrorImport: "An error occurred during import.",
            recordCreated: "Create Record",
            recordUpdated: "Update Record",
            recordDeleted: "Delete Record",
            noAutomationDefined: "No automation defined yet",
            nameTheAutomationAdd: "Name the automation that will run when a record is added to this table:",
            nameTheAutomationUpdate: "Name the automation that will run when a record in this table is updated:",
            nameTheAutomationDelete: "Name the automation that will run when a record is deleted from this table:",
            editField: "Edit Field",
            sort: "Sort",
            ascending: "Ascending",
            descending: "Descending",
            createField: "Create Field",
            insertBefore: "Insert Before",
            insertAfter: "Insert After",
            goToRelatedAuto: "Go to Related Automation",
            permission: "Permission",
            lockField: "Lock Field",
            hideField: "Hide Field",
            deleteField: "Delete Field",
            watchVideo: "Watch Video",
            uploadError: "Upload Error",
            updateError: "Update Error",
            invalidValue: "Invalid value. Please use the correct format.",
            errorUpdatingRecord: "An error occurred while updating the record.",
            errorCreatingView: "An error occurred while creating the view.",
            datetimeOptions: "Date Time Options",
            numberOptions: "Number Options",
            currencyOptions: "Currency Options",
            dropdownOptions: "Dropdown Options",
            automationButtonOptions: "Automation Button Options",
            defaultLabel: "Default Label",
            disableWhenClicked: "Disable When Clicked",
            fieldSucsCreate: "Field Created Successfully",
            fieldCreatingFailed: "An error occurred while creating the field",
            fieldSucsUpdate: "Field Updated Successfully",
            fieldUpdatingFailed: "An error occurred while updating the field",
            showAll: "Show All",
            hideAll: "Hide All",
            searchFields: "Search Fields",
            firstRowHeader: "First Row Contains Header",
            separatorCharacter: "Separator Character",
            comma: "Comma",
            semicolon: "Semicolon",
            tableFieldOrFileColumns: "Table Field / File Columns Mapping",
            exampleResultPreview: "Example Result Preview",
            newView: "New View",
            selectedMenuItem: "Selected menu item:",
            deleteTable: "Delete Table",
            sureDeleteTable: "Are you sure you want to delete this table?",
            deleteTableSucs: "The table was deleted successfully.",
            deleteTableError: "Error deleting table:",
            editTable: "Edit Table",
            createNewField: "Create New Field",
            tables: "Tables",
            tableName: "Table Name",
            description: "Description",
            createTable: "Create Table",
            createNewTable: "Create New Table",
            allTables: "All Tables",
            myTables: "My Tables",
            myFavorites: "My Favorites",
            errorCreatingTable: "Error creating table:",
            customerTable: "Customer Table",
            customerTableDesc: "Default customer table",
            leadTracking: "Lead Tracking",
            leadTrackingDesc: "Lead tracking table",
            todoList: "Todo List",
            todoListDesc: "List for tracking tasks",
            approvalReq: "Approval Request",
            approvalReqDesc: "Management of approval requests",
            eventSchedule: "Event Schedule",
            eventScheduleDesc: "Planning upcoming events",
            inventoryList: "Inventory List",
            inventoryListDesc: "Keeps track of product stocks",
            bookingForm: "Reservation Form",
            bookingFormDesc: "Tracking reservations",
            bugTracker: "Bug Tracker",
            bugTrackerDesc: "Tracking software bugs",
            employeeDirectory: "Employee Guide",
            employeeDirectoryDesc: "Includes employee information",
            errorPullTable: "Error pulling table data.",
            newRecordSucs: "New record created successfully.",
            failedNewRecord: "Failed to create a new record:",
            newRecordCreateError: "An error occurred while creating a new record.",
            recordCount: "Record Count",
            increaseLimit: "Increase Limit",
            newRecord: "New Record",
            imports: "Import",
            exports: "Export",
            download: "Download",
            automateYourData: "Automate Your Data",
            recordUpdatedSucs: "Record Updated Successfully",
            failedToUpdateRecord: "Failed to Update Record",
            recordUpdatingError: "Error updating record",
            mainTable: "Main Table",
            filter: "Filter",
            hideFields: "Hide Fields",
            saveAsView: "Save As View",
            search: "Search",
            create: "Create",
            left: "Left",
            center: "Center",
            right: "Right",
            selectTimezone: "Select time zone",
            createFieldSucs: "Field created successfully.",
            failedCreateField: "Failed to create field:",
            createFieldError: "An error occurred while creating the field.",
            addCondition: "Add Condition",
            applyFilter: "Apply Filter",
            fieldType: "Field Type",
            alignment: "Alignment",
            blankTable: "Blank Table",
            templates: "Templates",
            timezone: "Time Zone",
            timeFormat: "Time Format",
            includeTime: "Include Time",
            decimalFormat: "Decimal Format",
            currencySymbol: "Currency Symbol",
            mode: "Mode",
            statics: "Static",
            dynamic: "Dynamic",
            multipleSelection: "Multiple Selection",
            addOption: "Add Option",
            text: "Text",
            longText: "Long Text",
            number: "Number",
            currency: "Currency",
            datetime: "Date & Time",
            dropdown: "Dropdown List",
            checkbox: "Checkbox",
            email: "Email",
            phone: "Phone",
            file: "File",
            image: "Image",
            video: "Video",
            audio: "Audio",
            color: "Color",
            automationButton: "Automation Button",
        },
        plans: {
            manageWithChatbot: "Manage with Chatbot",
            manageInbox: "Manage Inbox",
            commentManagement: "Manage Comments",
            privateReplyMessage: "Private Reply Comments",
            mentionTicket: "Convert Mentions to Tickets",
            week: "Week",
            readyContents: "Ready Contents",
            webhookIntegration: "Webhook Integration",
            businessChannel: "WhatsApp Business Channel",
            confirmationFeature: "Confirmation Feature",
            specialReporting: "Special Reporting",
            aiAssistant: "AI Assistant",
            flexibleBilling: "Flexible Billing",
            automaticReservation: "Automatic Reservation",
            taskManagement: "Task Management",
            calendarIntegration: "Calendar Integration",
            activeChatbot: "Active Chatbot",
            smsIntegration: "SMS Integration",
            mailIntegration: "Mail Integration",
            startChatWithVisitor: "Start Chat With Visitor",
            whatsappManaging: "Whatsapp Management",
            automaticChatbotButton: "Automatic Button/Chatbot",
            personalizedBroadcasts: "Personalized Broadcasts",
            chatWithNonContacts: "Chat With Non-Contacts",
            broadcastMessaging: "Broadcast Messaging",
            perBroadcast: "Per Broadcast",
            extraPricePerMessage: "Extra Price Per Message",
            smartTrigger: "Smart Trigger",
            telegramIntegration: "Telegram Integration",
            instagramIntegration: "Instagram Integration",
            ticketFeature: "Ticket Feature",
            storage: "Storage",
            onePanelManagement: "One Panel Management",
            isolatedDatabaseConnection: "Isolated Database Connection",
            removeLogo: "Remove Supsis Logo",
            chatBaloonCustomization: "Chat Balloon Customization",
            chatAndNotifications: "Chat and Notifications",
            unlimited: "Unlimited",
            specialCustomerSupport: "Special Customer Support",
            softwareSupport: "Software Support",
            standardSupport: "Standard Support",
            teamChatIntegration: "Team Chat Integration",
            fileAndVoiceShare: "File and Voice Share",
            instantVisitor: "Instant Visitor Tracking",
            detailedReporting: "Detailed Reporting",
            normalreporting: "Normal Reporting",
            noExtraCosts: "No Extra Costs",
            accessibleToAllAgents: "Accessible to All Agents",
            dataSecurity: "Data Security",
            autoTranslate: "Auto Translate",
            chatbotVersionHistory: "Chatbot Version History",
            chatbotStory: "Chatbot Story",
            freeAgent: "Free Agent",
            stableAgentCount: "Stable Agent Count",
            stableChannelCount: "Stable Channel Count",
            chipPlans: "Affordable Plans",
            generalPlan: "General Plan",
            specialPlan: "Special Plan",
            currentPlan: "Current Plan",
            selected: "Selected",
            popular: "Popular",
            trialPkg: "Trial Package",
            support: "24/7 Support",
            flexiblePricing: "Flexible Pricing",
            rightToCancel: "Right to Cancel Anytime",
            unlimitedCBScenario: "Unlimited Chatbot Scenarios",
            freeFirstScenario: "Free First Scenario",
            unlimitedLearn: "Unlimited Chatbot Training",
            allPlatformIntegration: "Integration with All Platforms",
            detailedReports: "Detailed Reports",
            aiSupport: "AI Support",
            creativeAI: "Fast and Realistic AI Chat Assistant",
            unlimitedSession: "Unlimited Sessions Simultaneously",
            assistantFromWebsite: "Creating Assistant from Website",
            assistantFromDoc: "Creating Chatbot from Document",
            mobileApp: "Mobile App",
        },

        messenger: {
            channel: "Messenger Channel",
            manageChannel: "Manage Channel",
            channelDetail: "Channel Detail",
            integrationTitle: "Messenger Integration",
            deleteDesc: "Are you sure you want to delete the Messenger channel?",
            channels: "Messenger Channels",
            connectMessenger: "Connect to Messenger",
            detail: "Detail",
            visibility: "Visibility",
            settings_group: "Settings",
            commentsettings: "Comment Management",
            commentSettingsTitle: "Messenger Comment Management",
            commentSettingsDesc: "Manage your Messenger comments",
        },
        instagram: {
            channel: "Instagram Channel",
            detail: "Detail",
            visibility: "Visibility",
            settings_group: "Settings",
            commentsettings: "Comment Management",
            commentSettingsTitle: "Instagram Comment Management",
            commentSettingsDesc: "Manage your Instagram comments",
            commentSettingsTicket: "Ensures that incoming comments are recorded in the system as tickets.",
            commentSettingsChatbot: "Select which chatbot scenario incoming comments should be directed to.",
            leads: "Leads",
            forms: "Forms",
            showAllInstagramChannels: "Show All Instagram Channels",
        },
        calendar: {
            calendarsDesc: "Avoid schedule conflicts.",
            generalAvailability: "General Availability",
            generalAvailabilityDesc: "Specify the times when you are regularly available for appointments.",
            appointDuration: "Appointment duration",
            appointDurationDesc: "How long should each appointment last?",
            customDuration: "Custom Duration",
            descriptionDesc:
                "Add a note describing your service. Your note will appear on your booking page and in confirmation emails.",
            resForm: "Booking Form",
            resFormDesc: "Customize the form that people will use to book an appointment.",
            addField: "Add Field",
            addAnItem: "Add an Item",
            saveItem: "Save Item",
            planningTimeframe: "Planning Timeframe",
            planningTimeframeDesc: "Limit the time frame in which an appointment can be made.",
            availableAtMoment: "Available Now",
            startAndEndDate: "Start and end dates",
            maxNumberAppoint: "Maximum number of days after which an appointment can be made",
            howLongMinAppoint: "How long before the start of the appointment a minimum appointment can be booked",
            planningIntervalStartEnd: "Planning interval start and end dates",
            startTime: "Start Time",
            done: "Done",
            receivedAppointInterval: "Received Appointment Interval",
            receivedAppointIntervalDesc: "Manage received appointments to appear in your calendar.",
            interimTime: "Interim time",
            interimTimeDesc: "Add time between meeting intervals",
            dayMaxRes: "Maximum number of reservations per day",
            dayMaxResDesc: "Limit the number of booked appointments that can be accepted in a single day",
            customize: "Set Custom",
            noAvatar: "No Avatar",
            organizationName: "Organization Name",
            enterFullAdress: "Enter Full Address",
            noCoverPhoto: "No cover photo",
            enterAboutInfo: "Enter about information",
            service: "Service",
            deleteService: "Delete Service",
            enterGoogleMapsUrl: "Enter Google Maps URL",
            enterLatitude: "Enter latitude",
            enterLongitude: "Enter longitude",
            enterNumber: "Enter phone number",
            uploadAvatar: "Upload Avatar",
            teamMemberDeleteError: "Error deleting team member:",
            setupBookingWebsite: "Setup Booking Website",
            bookingLandingPageBuilder: "Booking Landing Page Builder",
            coverPhoto: "Cover Photo",
            enterOrganizationName: "Enter the organization name",
            about: "About",
            services: "Services",
            deleteServices: "Delete Service",
            selectReservationPlan: "Select Reservation Plan",
            addNewService: "Add New Service",
            addNewMember: "Add New Member",
            fullAddress: "Full Address",
            latitude: "Latitude",
            longitude: "Longitude",
            contactDetails: "Contact Details",
            emailAddress: "Email Address",
            enterEmail: "Enter email address",
            websiteURL: "Website URL",
            enterWebsiteURL: "Enter website URL",
            reservationPolicy: "Reservation Policy",
            enterResPolicy: "Enter booking policy",
            workingHours: "Working Hours",
            selectEndHour: "Select End Time",
            addNewHour: "Add New Hour",
            updateMemberInfo: "Update Member Information",
            errorRecevingData: "Error retrieving data:",
            anonymService: "Anonymous Service",
            unknownPlan: "Unknown Plan",
            errorCreatingMockPage: "Error creating mock page:",
            failedToCreateBookingPage: "Failed to create the booking page",
            fileSizeToolLarge: "File size too large",
            errorLoadingTheLogo: "Error loading the logo:",
            failedToLoadLogo: "Failed to load the logo",
            errorUpdating: "Error updating:",
            failedToUpdate: "Failed to update",
            newMember: "New Member",
            errorLoadingAvatar: "Error loading avatar:",
            avatarFailedToLoad: "Failed to load avatar",
            teamMemberSuccessfullyDeleted: "Team member successfully deleted",
            teamMemberNotDelete: "Failed to delete team member",
            yesDelete: "Yes, Delete",
            sureResDelete: "Are you sure you want to delete this booking?",
            resDetails: "Reservation Details",
            infoPersonMakingRes: "Booking Person's Information",
            appointmentProgram: "Appointment Schedule",
            goToAppointSettings: "Go to Appointment Schedule Settings",
            resPlanCreateSuccess: "Reservation plan created successfully",
            pleaseEnterTitle: "Please enter title",
            sureContinueSaving: "Are you sure you want to continue without saving?",
            appointProgram: "RESERVATION PROGRAM",
            everyMonth: "Every month",
            firstEveryMonth: "First of each month",
            dayOf: "Day",
            notRepeat: "Does not repeat",
            daily: "Everyday",
            weekly: "Once a week",
            monthly: "Once a month",
            annually: "Once a year",
            custom: "Special",
            eventSaved: "Event saved",
            createAppoint: "Create appointment",
            calendarSetting: "Callendar Settings",
            notAuthezord: "You are not authorized to do this",
            reservationWebPage: "Reservation Web Page",
            reservationPrograms: "Reservation Programs",
            addReservationProgram: "Add Reservation Program",
            resPlanError: "Error receiving reservation plans:",
            resDeleteSure: "Are you sure you want to delete this booking program?",
            resDeleteSuccess: "The reservation program was successfully deleted.",
            resDeleteError: "Error deleting the reservation program:",
            unkownUser: "Unknown User",
            eventNotFound: "Event Not Found",
            reservations: "Rezervetions",
            events: "Events",
            upcoming: "Upcoming",
            past: "Past",
            setting: "Settings",
            delete: "Delete",
            cancel: "Cancel",
            save: "Save",
            close: "Close",
            deleteRepeatEvent: "Delete Repeating Event",
            thisEvent: "This Event",
            thisAndOtherEvent: "This and Following Events",
            allEvent: "All Events",
            ok: "OK",
            googleCalendarLink: "Add to Google Calendar",
            yahooCalendarLink: "Add to Yahoo Calendar",
            subject: "Subject",
            visitor: "Visitor",
            allDay: "All Day",
            title: "Title",
            deleteEvent: "Delete Event",
            deleteEvents: "Delete Events",
            deleteEventsSure: "Are you sure you want to delete events associated with this calendar?",
            deleteEventConfirm: "Are you sure you want to delete this event?",
            notEmptyTitle: "Title cannot be empty!",
            tasks: "Tasks",
            googleConnect: "Connect Google Integration",
            googleDisconnect: "Disconnect Google Integration",
            sure: "Are you sure?",
            disconnectGoogleSure: "Are you sure you want to remove the Google connection?",
            yes: "Yes",
            no: "No",
            customRepeat: "Custom Repeat",
            recurrenceFrequency: "Repeat Frequency:",
            repeatDays: "Repeat on these days:",
            never: "Never",
            thisDate: "On This Date:",
            recurrenceCount: "Recurrence Count:",
            end: "End",
            event: "Event",
            calendars: "Calendars",
            newCalendar: "Create New Calendar",
            changeColor: "Change Color",
            addCalendar: "Add Calendar",
            nameCalendar: "Calendar Name",
            description: "Description",
            change: "Change",
            deleteCalendar: "Delete Calendar",
            deleteCalendarSure: "Are you sure you want to delete the calendar?",
            notEmptyCalendarName: "Calendar name cannot be empty",
            myEvents: "My Events",
            everyoneEvents: "All Events",
            haveEvent: " 's events",
            goCalendar: " Go to Calendar",
            goReservation: " Create Reservation",
            agents: " Agents",
            today: "Today",
            month: "Month",
            week: "Week",
            day: "Day",
            list: "List",
        },
        ticimax: {
            segment: "Segment",
            settings_group: "Settings",
            waitDayFromLastSend: "Wait Day Count from Last Sent Message Per Member",
            automationRuleName: "Automation Rule Name",
            time: "Time",
            year: "Year",
            month: "Month",
            dayOfMonth: "Day of Month",
            day: "Day",
            bySecond: "By Second",
            byMinute: "By Minute",
            byHour: "By Hour",
            byWeekNo: "By Week No",
            byYearDay: "By Year Day",
            byMonthDay: "By Month Day",
            byMonth: "By Month",
            december: "December",
            november: "November",
            october: "October",
            september: "September",
            august: "August",
            july: "July",
            june: "June",
            may: "May",
            april: "April",
            march: "March",
            february: "February",
            january: "January",
            byWeekDay: "By WeekDay",
            interval: "Interval",
            seconds: "Seconds",
            minutes: "Minutes",
            hourly: "Hourly",
            daily: "Daily",
            weekly: "Weekly",
            monthly: "Monthly",
            yearly: "Yearly",
            frequency: "Frequency",
            attributes: {
                vip: "VIP",
                segment: "Segment",
                province: "Province",
                country: "Country",
                phone: "Phone",
                email: "Email",
                fullname: "Full Name",
                couponPercent: "Coupon %",
                lastOrderDate: "Last Order",
                firstOrderDate: "First Order",
                county: "County",
                lastSource: "Last Source",
                firstSource: "First Source",
                lastPaymentType: "Last Payment Method",
                firstPaymentType: "First Payment Method",
                maxOrderAmount: "Maximum Order Amount",
                minOrderAmount: "Minimum Order Amount",
                totalOrderAmount: "Total Order Amount",
                totalOrderCount: "Total Order Count",
                usedCouponAmount: "Coupon Amount",
                usedCouponCount: "Coupon Count",
                tookDayFromLastOrder: "Days Since Last Order",
                isCouponUser: "Is Coupon User",
            },
            createAutomation: "Create Automation",
            previous: "Previous",
            createAutomationDesc: "Create and manage your message automations",
            newTicimaxChannel: "New Ticimax Channel",
            connextToTicimaxXml: "Connect to Ticimax XML Service",
            connectTicimax: "Connect to Ticimax",
            examplePreview: "Example Preview",
            completeAutomationRule: "Complete Automation Rule",
            configureMessage: "Configure Message",
            automationTimer: "Automation Timer",
            findTargetMembers: "Find Target Members",
            createAutomationRule: "Create Automation Rule",
            action: "Action",
            status: "Status",
            triggeredUserCount: "Triggered User Count",
            nextScheduled: "Next Scheduled",
            timerRule: "Timer Rule",
            automationRules: "Automation Rules",
            apply: "Apply",
            searchAMember: "Search a Member",
            segmentedMembersDesc: "List and automate your segmented members",
            manageVisibilityDesc: "Manage who can see the channel",
            xmlOrderListURL: "XML Order List URL",
            manageIntegrationDesc: "Manage your Ticimax integration",
            detail: "Detail",
            ticimaxChannelsTitle: "Ticimax Channels",
            ticimaxDetail: "Ticimax Detail",
            settingsGroup: "Settings",
            visibility: "Visibility",
            members: "Members",
            automation: "Automation",
            integrationChannel: "Integration Channel",
            channelUpdated: "Channel updated successfully",
            channelUpdateFailed: "Failed to update channel",
        },
        notification: {
            contactOwner: "Change Chat Owner, Assign Owner, and Remove Owner",
            mobileApp: "Mobile App",
            webPanel: "Web Panel",
            notifications: "Notifications",
            whatsappActions: "Whatsapp Actions",
            chatbotActions: "Chatbot Actions",
            companyActions: "Company Actions",
            crmActions: "SUPSIS CRM ACTIONS",
            basicActions: "Basic Actions",
            notificationSettingsDesc:
                "Choose which notifications you want to receive and where you want to receive them.",
            noNotificationDesc2:
                "Here you will see all notifications related to the jobs, candidates, and talent pools you are following. You can customize notifications by adjusting settings.",
            noNotificationTitle2: "No notifications yet.",
            noNotificationTitle1: "No notifications. Enjoy the silence.",
            adjustSettings: "Adjust settings",
            showAll: "Show all",
            showOnlyUnread: "Show only unread",
            mailWasSent: "Email was sent.",
            mailAdressRemoved: "Email address removed.",
            chatbotPublished: "Version <b>{version}</b> of the chatbot was published by <b>{user}</b>.",
            chatbotDeleted: "<b>{chatbot}</b> chatbot was deleted by <b>{user}</b>.",
            settingsUpdatedWoDetail: "Settings were updated by <b>{user}</b>.",
            noActivityDesc: "There is currently no activity in the system. A few events need to occur",
            noActivityTitle: "No activity yet",
            actionType: "Action Type",
            dateBetween: "Date Between",
            selectActor: "Select User",
            activities: "Activities",
            chatbotCreated: "Chatbot named <b>{chatbot}</b> was created by <b>{user}</b>.",
            taskStageChanged:
                "The stage of task <b>{task}</b> was changed from <b>{oldStage}</b> to <b>{newStage}</b> by <b>{user}</b>.",
            taskCreated: "<b>{task}</b> task was created by <b>{user}</b>.",
            contactPropRemoved: "<b>{prop}</b> visitor property was removed by <b>{user}</b>.",
            contactPropAdded: "<b>{prop}</b> visitor property was added by <b>{user}</b>.",
            userRemoved: "<b>{oldUser}</b> user was removed by <b>{user}</b>.",
            loginFormUpdated: "Visitor login form was updated by <b>{user}</b>.",
            loginFormDeactivated: "User login form was deactivated by <b>{user}</b>.",
            loginFormActivated: "User login form was activated by <b>{user}</b>.",
            invoiceRefunded: "Refund process was made by <b>{user}</b>.",
            paymentMethodAdded: "A new payment method was added by <b>{user}</b>.",
            invoicePaymentFailed: "Invoice payment was not accepted by <b>{user}</b>.",
            invoicePaymentReceived: "Invoice payment received by <b>{user}</b>.",
            planStarted: "<b>{user}</b> User started the subscription for <b>{title}</b> (<b>{altTitle}</b>).",
            planStartedAgent:
                "<b>{user}</b> User started the subscription for <b>{title}</b> <b>{altTitle}</b> (<b>{details} Representative</b>).",
            planStartedChatbot:
                "<b>{user}</b> User started the subscription for <b>{title}</b> <b>{altTitle}</b> (<b>{chatbot} Session</b>).",
            planStartedWhatsapp:
                "<b>{user}</b> User started the subscription for <b>{title}</b> <b>{altTitle}</b> (<b>{whatsapp} Whatsapp Channels</b>).",
            planStartedWhatsappApi:
                "<b>{user}</b> User started the subscription for <b>{title}</b> <b>{altTitle}</b> (<b>{whatsappApi} Whatsapp Business Channels</b>).",
            PlanCanceled: "<b>{user}</b> User canceled the subscription for <b>{title}</b> (<b>{altTitle}</b>).",
            planCanceledAgent:
                "<b>{user}</b> User canceled the subscription for <b>{title}</b> <b>{altTitle}</b> (<b>{details} Representative</b>).",
            planCanceledChatbot:
                "<b>{user}</b> User canceled the subscription for <b>{title}</b> <b>{altTitle}</b> (<b>{chatbot} Session</b>).",
            planCanceledWhatsapp:
                "<b>{user}</b> User canceled the subscription for <b>{title}</b> <b>{altTitle}</b> (<b>{whatsapp} Whatsapp Channels</b>).",
            planCanceledWhatsappApi:
                "<b>{user}</b> User canceled the subscription for <b>{title}</b> <b>{altTitle}</b> (<b>{whatsappApi} Whatsapp Business Channels</b>).",
            invoiceCreated: "Invoice was created by <b>{user}</b>.",
            billingAddressUpdated: "Address information was updated by <b>{user}</b>.",
            taskWorkflowDeleted: "Workflow <b>{workflow}</b> was deleted by <b>{user}</b>.",
            whatsappBroadcastFailed: "Sending of broadcast message titled <b>{title}</b> failed.",
            whatsappBroadcastCancelled: "Sending of broadcast message titled <b>{title}</b> has been cancelled.",
            whatsappBroadcastCompleted:
                "A broadcast message titled <b>{title}</b> has been successfully sent to <b>{numbers}</b> recipients.",
            whatsappBroadcastCreated:
                "A broadcast message titled <b>{title}</b> has been sent to <b>{numbers}</b> recipients by <b>{user}</b>.",
            ticketAssigned: "A ticket has been assigned to <b>{user2}</b> by <b>{user1}</b>.",
            userLoggedIn: "<b>{user}</b> logged into SUPSIS.",
            chatJoined: "<b>{agent}</b> joined the chat with <b>{visitor}</b>.",
            chatForwarded: "Chat with <b>{visitor}</b> was forwarded to <b>{agent}</b> by <b>{user}</b>.",
            chatAssigned: "Chat with <b>{visitor}</b> was assigned to <b>{agent}</b> by the system.",
            customerGroupUpdated: "The group named <b>{group}</b> was updated by <b>{user}</b>.",
            customerGroupRemoved: "The group named <b>{group}</b> was removed by <b>{user}</b>.",
            customerGroupAdded: "The group named <b>{group}</b> was created by <b>{user}</b>.",
            contentRemoved: "Ready content <b>{content}</b> was removed by <b>{user}</b>.",
            contentAdded: "Ready content <b>{content}</b> was added by <b>{user}</b>.",
            channelVisibilityChanged:
                "Visibility of integration channel <b>{channel}</b> was changed by <b>{user}</b>.",
            taskDeleted: "<b>{task}</b> task was deleted by <b>{user}</b>.",
            userRemovedToDepartment:
                "<b>{user2}</b> user removed from <b>{department}</b> department by <b>{user1}</b>.",
            userAddedToDepartment: "<b>{user2}</b> user added to <b>{department}</b> department by <b>{user1}</b>.",
            mailAddressAdded: "<b>{email}</b> email address added by <b>{user}</b>",
            settingUpdate: "Updated by <b>{user}</b>:",
            taskWFlowCreated: "<b>{Wflow}</b> task workflow created by <b>{user}</b>.",
            bannedWordRemoved: "<b>{bWord}</b> banned word removed by <b>{user}</b>.",
            bannedWordCreated: "<b>{bWord}</b> banned word created by <b>{user}</b>.",
            welcomeMessageRemoved: "<b>{welcome}</b> welcome message removed by <b>{user}</b>.",
            welcomeMessageAdded: "<b>{welcome}</b> welcome message created by <b>{user}</b>.",
            tagRemoved: "<b>{tag}</b> tag removed by <b>{user}</b>.",
            tagAdded: "<b>{tag}</b> tag added by <b>{user}</b>.",
            roleRemoved: "<b>{role}</b> role removed by <b>{user}</b>.",
            roleAdded: "<b>{role}</b> role added by <b>{user}</b>.",
            departmentRemoved: "<b>{department}</b> department removed by <b>{user}</b>.",
            departmentAdded: "<b>{department}</b> department added by <b>{user}</b>.",
            triggerUpdated: "A trigger updated by <b>{user}</b>.",
            triggerRemoved: "A trigger removed by <b>{user}</b>.",
            triggerAdded: "A new trigger created by <b>{user}</b>.",
            webhookRemoved: "The webhook belonging to <b>{user1}</b> was removed by <b>{user2}</b>",
            webhookAdded: "<b>{user1}</b> added the webhook, which was added by <b>{user2}</b>",
            chatClosed: "Chat with <b>{visitor}</b> was ended by <b>{agent}</b>.",
            chatOwnerUpdated: "<b>{agent}</b> reassigned <b>{visitor}</b> from <b>{oldOwner}</b> to <b>{newOwner}</b>.",
            customerOwnershipRemoved:
                "<b>{actor}</b> removed the ownership of <b>{visitor}</b> from <b>{oldOwner}</b>, leaving them unowned.",
            customerOwnershipAssigned:
                "<b>{actor}</b> assigned the ownership of <b>{visitor}</b> from unowned to <b>{newOwner}</b>.",
            customerOwnershipReassigned:
                "<b>{actor}</b> reassigned the ownership of <b>{visitor}</b> from <b>{oldOwner}</b> to <b>{newOwner}</b>.",
            chatOpenedByAgent: "<b>{agent}</b> initiated a <b>{platform}</b> chat with <b>{visitor}</b>.",
            chatOpenedByVisitor: "A <b>{platform}</b> chat was initiated by <b>{visitor}</b>.",
            channelRemoved: "<b>{channel}</b> channel was removed by <b>{agent}</b>.",
            userAdded: "<b>{agent}</b> created a representative named <b>{newAgent}</b>.",
            visitorUnblocked: "<b>{visitor}</b> visitor unblocked by <b>{agent}</b> user.",
            visitorBlocked: "Visitor <b>{visitor}</b> blocked by <b>{agent}</b>.",
            userStatusChanged: "User <b>{name}</b> changed status from <b>{oldStatus}</b> to <b>{newStatus}</b>.",
            channelCreated: "<b>{channel}</b> channel created by <b>{name}</b>.",
            reservationCreatedPlan:
                "<b>{name}</b> User scheduled the appointment named <b>{title}</b> for <b>{date}</b>.",
            reservationUpdatedPlan: "<b>{name}</b> User updated the appointment named <b>{title}</b>.",
            reservationDeletedPlan: "<b>{name}</b> User deleted the appointment named <b>{title}</b>.",
            reservationCreated: "<b>{name}</b> User and <b>{visitor}</b> Visitor with reservation date <b>{date}</b>.",
            reservationDeleted:
                "Appointment scheduled between <b>{name}</b> User and <b>{visitor}</b> Visitor on <b>{date}</b> has been canceled.",
            chatAssignedMe: "When a chat is assigned to me",
            ticketAssignedMe: "When a ticket is assigned to me",
            taskAssignedMe: "When a task is assigned to me",
            myChatClosed: "When chat that I own is closed",
            tagActionsToVisitor: "Tags added or removed from a contact",
            ticketCreated:
                "Ticket is created by visitor or chatbot. Also, when a send offline message is sent from the chat widget",
            notesActions: "A note was added or removed from a customer.",
            visitorProfileUpdated: "Visitor profile updated",
            chatStartedByAnyPlatform: "Chat is started on any platform by contact or agent",
            userActions: "User is created, updated or deleted",
            departmentActions: "Department is created, updated or deleted",
            settingsActions: "Settings are created, updated or deleted",
            integrationsActions: "Integration channel is created, updated or deleted",
            loginFormActions: "Login form is updated or activated or deactivated",
            bannedWordActions: "Banned word is created, updated or deleted",
            emailActions: "Email account is created or deleted",
            preparedContentActions: "Prepared content is created or deleted",
            roleActions: "Role is created, updated or deleted",
            tagActions: "Tag is created, updated or deleted",
            welcomeMessageActions: "Welcome message is created, updated or deleted",
            webhookActions: "Webhook is created, updated or deleted",
            billingEvents: "Billing Events",
            workflowCreated: "When the workflow is created",
            workflowDeleted: "When the workflow is deleted.",
            createdTask: "When the task is created.",
            taskStatusChanged: "When the task status changes",
            deletedTask: "When the task is deleted",
            taskWorkflowCrud: "Task workflow is created, updated or deleted",
            taskCrud: "Task is created, updated or deleted",
            systemStatus: "System online or offline status changes",
            chatbotStoryCrud: "Chatbot story is created, updated or deleted",
            chatbotForwardAgent: "Chatbot forwards a chat to agent",
            userSegmentCrud: "User segment is created, updated or deleted",
            chatbotCreditLow: "When chatbot credit is low",
            wpCreditLow: "When Whatsapp credit is low",
            wpCustomerGroupCrud: "When Whatsapp customer group is created, updated or deleted",
            wpBroadcastMessageStatus: "When Whatsapp broadcast message is sent, completed or cancelled",
            wpTemplateMesssageCrud: "When Whatsapp template message is created, updated or deleted",
            reservationMessageCrud: "Reservation Created, Updated, Canceled",
        },
        search: {
            prefix: {
                jump: "Jump",
                new: "New",
                visitor: "Visitor",
                dm: "DM",
                chatbot: "Chatbot",
                automation: "Automation",
                table: "Table",
                module: "Module",
                message: "Message",
            },
            calendar: "Calendar",
            soundSettings: "Sound Notifications",
            allNotificationSettings: "Notification Settings",
            allNotifications: "All Notifications",
            allActivities: "All Activities",
            workFlow: "Work Flow",
            editTask: "Edit Task",
            tasks: "Tasks",
            todo: "To-Do",
            tapTo: "Press ⇥ for '{prefix}' operations",
            newUsers: "New ⇥ Users",
            newTags: "New ⇥ Tags",
            newRole: "New ⇥ Role",
            newTrigger: "New ⇥ Triggers",
            newDepartment: "New ⇥ Department",
            newTicket: "New ⇥ Ticket",
            jumpSettings: "Jump ⇥ Settings",
            jumpIntegrations: "Jump ⇥ Integrations",
            jumpTeam: "Jump ⇥ Team",
            jumpUsers: "Jump ⇥ Users",
            jumpReport: "Jump ⇥ Report",
            timingSettings: "Timing Settings",
            exampleVisitorMail: "visitor@mail.com",
            languageAndRegion: "Language and Region",
            theme: "Theme",
            appearance: "Appearance",
            color: "Color - Colour",
            background: "Background",
            smart: "Smart",
            teamChat: "Team Chat",
            chatbot: "ChatBot",
            chatbotTraining: "Chatbot Training",
            chatbotUserSegments: "Chatbot User Segments",
            chatbotIntegration: "Chatbot Integrations",
            chatbotEntities: "Chatbot Entities",
            chatbotIntegrationWebHook: "Chatbot Integrations Webhook",
            chatbotArchive: "Chatbot Archive",
            chatbotTemplatesAI: "Chatbot Templates AI",
            chatbotTemplates: "Chatbot Templates",
            chatbotReportsOverall: "Chatbot Reports Overall",
            chatbotReportsAllChats: "Chatbot Reports All Chats",
            chatbotReportsRatingDistribution: "Chatbot Reports Rating Distribution",
            chatbotReportsPaidChats: "Chatbot Reports Paid Chats",
            chatbotReportsBusiestPeriod: "Chatbot Reports Busiest Period",
            chatbotTemplatesAllMessages: "Chatbot Templates All Messages",
            chatbotTemplatesAvarage: "Chatbot Templates Avarage",
            chatbotTemplatesPopularity: "Chatbot Templates Popularity",
            chatbotTemplatesAllUser: "Chatbot Templates All User",

            ticket: "Ticket",
            archives: "Archives",
            tags: "Tags",
            offlineSupportRequests: "Offline Support Requests",
            roles: "Roles",
            users: "Users",
            subjects: "Subjects",
            contents: "Contents",
            welcomeMessages: "Welcome Messages",
            catalog: "Catalog",
            bannedWords: "Banned Words",
            bannedVisitors: "Banned Visitors",
            application: "Application",
            mails: "Mails",
            visitors: "Visitors",
            integrationsWebhook: "Integrations Webhook",
            billing: "Billing",
            reportNew: "Report New",
            integrations: "Integrations",
            chatbotStory: "Chatbot Story",
            searchPlaceHolder: "Search, Jump to or Add...",
            searchAreaTitle: "Search in Supsis",
            searchAreaDesc1: "Search for anything. Just say",
            searchAreaDesc2: "or",
            searchAreaDesc3: "or search anything",
            navigateBtn: "Navigate",
            selectBtn: "Select",
            cancelBtn: "Cancel",
            integration: {
                shouldByInstaPack:
                    "You should buy an Instagram package to create an Instagram channel. Affordable prices are available now.",
                createInstaLimitMax: "You have reached the Instagram channel creation limit. Maximun",
                createInstaContinue:
                    "You can create an Instagram Channel. To continue, upgrade your package or delete some of your Instagram channels.",
                privatePolicy: "Private Policy",
                termsAndCondition: "Terms and Conditions",
                readAndAgree: "I have read and agree",
                shouldByMessengerPack:
                    "You must purchase a Messenger package to create a Messenger channel. You can access the packages with affordable prices immediately.",
                createMessengerLimitMax: "You have reached the Messenger channel creation limit. Maximun",
                createMessengerContinue:
                    "You can create a Messenger Channel. To continue, upgrade your package or delete some of your Messenger channels.",
                selectMessengerAccount: "Select Messenger Account",
                forwardLiveAgents: "👉 Forward Live Agents",
                allDepartments: "All Departments",
                deleteAll: "Delete All",
                wpBusinessAPI: "Integrations - Whatsapp Business API Channels",
                wpV1: "Integrations - Multi Whatsapp Channels",
                instagram: "Integrations - Instagram",
                instagramContactList: "Integrations - Instagram Contact List",
                mail: "Integrations - Mail",
                whatsapp: "Integrations - Whatsapp",
                whatsappContactList: "Integrations - Whatsapp Contact List",
                wpBCRequests: "Integrations - Whatsapp Broadcast Requests",
                wpBCCustomerGroups: "Integrations - Whatsapp Broadcast Customer Groups",
                wpBCTemplates: "Integrations - Whatsapp Broadcast Message Templates",
                chatbot: "Integrations - ChatBot",
            },
            settings: {
                settings: "Settings",
                features: "Settings - Features",
                languageAndRegion: "Settings - Language and Region",
                bubbleSettings: "Settings - Bubble Settings",
                bubbleActions: "Settings - Bubble Actions",
                themeSettings: "Settings - Theme Settings",
                visitorLoginForm: "Settings - Visitor Login Form",
                visitorAttribute: "Settings - Visitor Attributes",
                talkSettings: "Settings - Talk Settings",
                autoAssign: "Settings - Auto Assign",
                chatTimingSettings: "Settings - Chat Timing Settings",
                availability: "Settings - Availability",
                websiteIntegration: "Settings - Website Integration",
                developer: "Settings - Developer",
            },
        },
        mail: {
            broadcastCreatedSuccess: "Broadcast created successfully",
            confirmArchive: "Are you sure you want to archive this broadcast?",
            archive: "Archive",
            cancel: "Cancel",
            archiveSuccess: "Broadcast archived successfully",
            archiveError: "Error archiving broadcast",
            empty: "Empty",
            summerDiscounts: "Summer Discounts",
            opportunities: "Opportunities",
            newMailTemplateCreated: "Create New Email Template.",
            dateRange: "Date Range",
            templateName: "Template Name",
            category: "Category",
            templateUpdateSucs: "The template was updated successfully.",
            templateUpdateError: "An error occurred while updating the template.",
            marketing: "Marketing",
            operational: "Operational",
            custom: "Special",
            pleaseEnterTemplateName: "Please enter the template name",
            pleaseEnterTemplateSubject: "Please enter the template subject",
            pleaseSelectTemplateCategories: "Please select the template category",
            representMails: "Representative Mails",
            otherRepresentMails:
                "You can track incoming and outgoing e-mails to and from other representatives' e-mail addresses.",
            signatureAutoAdd: "Signature auto-add status changed successfully",
            autoAdd: "Automatic Add",
            forwardEmailAddSucs: "Forward email address added successfully.",
            errorAddingForwardEmail: "An error occurred while adding a forward email address.",
            mailAddForward: "Manual Add (forward completed)",
            mailAddForwarding: "Manual Add (I completed forwarding)",
            broadcast: "Publications",
            templates: "Templates",
            composeNewEmail: "Compose new email",
            couldNotUserMail: "Could not send mail because there is no user mail",
            mailAddressReq: "Mail Address Required.",
            emailAddressInvalid: "Mail address invalid.",
            departmentIsNotValid: "Department not valid",
            mailSendNotValid: "Not valid from mail address",
            newMailArrived: "New mail arrived.",
            mailSentSucs: "Mail sent successfully.",
            representativeMails: "Representative Mail",
            routingSteps: "Routing Steps",
            owner: "Owner",
            whereHeDirected: "Where He Directed",
            forwardingEmailAddress: "Forwarding Email Address",
            deleteMailDesc: "This action cannot be undone.",
            deleteMailTitle: "Are you sure you want to delete this email address?",
            gmailForwardMail: "Gmail Mail Forwarding",
            senderMailAddressDesc: "Please Enter Sender Mail Address",
            verified: "Verified",
            notForwarded: "Not Forwarded",
            notVerified: "Not Verified",
            default: "Default",
            isVerified: "Verified",
            forwarding: "Forwarding",
            mailAdress: "Mail Address",
            addSenderAddress: "Add Sender Address",
            outlookForward: "Microsoft (Outlook/Exchange) Forward",
            gmailForward: "Google (Gmail) Forward",
            senderMail: "Sender Mail",
            mailDetail: "Mail Detail",
            mailNotFound: "Mail not found",
            mailSelecting: "Selecting Mail",
            newMail: "New Email",
            myMails: "My Emails",
            inbox: "Inbox",
            sent: "Sent",
            departmentMails: "Department Emails",
            newTemplate: "New Template",
            unread: "Unread",
            unreply: "Unanswered",
            reply: "Reply",
            attachments: "Mail Attachments",
            To: "To",
            From: "From",
            FromName: "From Name",
            placeHolders: "Placeholders",
            attacheFiles: "Attach Files",
            replyAll: "Reply All",
            forward: "Forward",
            deleteThread: "Delete Thread",
            markAsRead: "Mark as Read",
            markAsAllRead: "Mark All as Read",
            emailEditor: "Email Editor",
            integrateYourMail: "Integrate Your Email",
            connect: "Connect",
            departmentMail: "Department Email",
            createMailAddress: "Create Email Address",
            createNewMail: "Create New Email",
        },
        visitor: {
            downloadAll: "Download All",
            saveAsCustomerGroup: "Save as Customer Group",
            saveSearchFavorite: "Save search as favorite",
            mail: "Mail",
            visitorDetail: "Visitor Details",
            selectedUser: "{selectedUser} out of {totalUsers} users selected",
            uncheck: "Uncheck All",
            checkAll: "Check All",
            matchedUsers: "{checkedCount} users matched",
            more: "More",
            exportUsers: "Export Selected Users",
            exportAllUsers: "Export All Users",
            addSegment: "Add Segment",
            deleteCheckedUser: "Delete Selected Users",
            deleteAllUser: "Delete All Users",
            matchedFilter: "Match All Filters",
            visitor: "Visitor",
            deleteUser: "Delete User",
            userData: "User Data",
            lastSession: "Last Session",
            notUserData: "No user data found",
            segments: "Segments",
            tags: "Tags",
            addTag: "Add Tag",
            userChats: "User Chats",
            seeAll: "See All",
            confirm: "Confirm",
            manageSegments: "Manage Segments",
            search: "Search",
            manageTags: "Manage Tags",
            allAttributes: "View All Attributes",
            noData: "No data",
            noEmail: "No email",
            noIpAddress: "IP address not found.",
            noWpNumber: "Number not found.",
            filterName: "filter name..",
            matchedContacts: "{chechkedCount} contacts matched",
        },
        chatbotv2: {
            typeStoryTitle: "Write a Story Title",
            setUpYourChatbot: "Set Up Your Chatbot",
            setUpYourChatbotDesc: "Train your chatbot with data, use our ready-to-use templates or start from scratch.",
            blankBot: "Blank Bot",
            blankBotDesc: "Create a blank chatbot that you can train and customize later.",
            websiteDesc: "Scan your website content to get answers to popular user questions.",
            yourNeedEnterYourOpenAi:
                "You need to enter your OpenAI API key to create an automated chatbot that crawls your website.",
            createOpenAiKey: "Create API Key",
            aiKnowledge: "Artificial Intelligence Knowledge",
            modalUsage: "Modal Usage",
            usedContentSources: "Content Sources Used",
            websites: "Websites",
            articles: "Articles",
            faq: "FAQ",
            files: "Files",
            functions: "Functions",
            settings: "Settings",
            disableAi: "Disable AI",
            enableAi: "Enable Artificial Intelligence",
            lastEdited: "Last Edited",
            state: "Status",
            frequentlyAskedQuestions: "Frequently Asked Questions (FAQ)",
            faqIsCreated: "FAQ Created",
            selectKnowEnabled: "Enabling the selected knowledge bases...",
            selectKnowDisabled: "Disabling the selected knowledge bases...",
            selectKnowNotEnabled: "The selected knowledge bases are not enabled.",
            selectKnowNotDisabled: "The selected knowledge bases are not disabled.",
            answered: "Answered",
            answer: "Answer",
            addFile: "Add File",
            fileDeleted: "Files deleted",
            fileDeletedFailed: "There was a problem deleting files",
            noFileAdded: "No file added",
            aiFunctions: "AI Functions",
            addFunction: "Add Function",
            parameterCount: "Parameter Count",
            auto: "Auto",
            usedByAI: "Used by AI",
            Zoho_Actions: "Zoho Actions",
            File_Actions: "File Actions",
            Data_Formatters: "Data Formatters",
            Loop_Actions: "Loop Actions",
            usedByAi: "Used by AI",
            notUsed: "Not in use",
            saveAndClose: "Save and Close",
            contentPreview: "Content Preview",
            addContent: "Add Content",
            populerUserQuestion: "Scan your website content to get answers to popular user questions.",
            enterUrlAddress: "Enter a URL address",
            sharingYourUrl: "By sharing your URL, you confirm that you have the necessary rights to share its content.",
            pageSelected: "Selected Pages",
            trainChatbot: "Train the chatbot",
            thereAreOnePages: "There is 1 page inside",
            categoryDesc: "Category. Choose which one to use to train your AI model.",
            scarpOrAddContent: "Scrap or add content, which AI Assist can use to respond to your customers' queries",
            noContentAdded: "No Content Added",
            howItWorks: "How It Works",
            editEntries: "Edit Entries",
            newEntries: "New Entries",
            chatbotManagement: "Chatbot Manegement",
            chatbotScenarioList: "Chatbot Scenario List",
            exportDiagramToClipboard: "Export Diagram To Clipboard",
            selectedStory: "{count} story selected",
            B2Cargo_Actions: "B2Cargo Actions",
            Holiday_Plus_Actions: "Holiday+ Actions",
            Instagram_Actions: "Instagram Actions",
            b2cargo_login_user: "Login User",
            b2cargo_product_status: "Product Status",
            HOLIDAY_PLUS_GET_ROOMS: "LIST ROOMS",
            HOLIDAY_PLUS_GET_HOTELS: "LIST HOTELS",
            ZOHO_CREATE_RECORD: "Zoho Create Record",
            suppressionRemoved: "Suppression Removed",
            suppressionAdded: "Suppression Added",
            didntSuppression: "You didn't make any suppression.",
            whatsappIntegrationTitle: "Whatsapp V1 and Whatsapp V2 Integration",
            whatsappApiIntegrationTitle: "Whatsapp Business API Integration",
            ReadyTemplateBadge: "Ready Template",
            readyTemplates: "Ready Templates",
            regex: "Regex",
            regexDescription: "Regex ile herşeyi yakala",
            chatbotLogo: "Chatbot Logo",
            chatbotName: "ChatBot Name",
            allSecnario: "Chatbot Scenario List",
            ChatbotScenarioList: "Chatbot Scenario List",
            Scenario: "Scenario",
            filters: {
                equal: "is equal to",
                not_equal: "isn't equal",
                contain: "contain",
                not_contain: "not contain",
                starts_with: "starts with",
                ends_with: "ends with",
                empty: "is empty",
                non_empty: "non empty",
                longer_than: "longer than",
                shorter_than: "shorter than",
                less_than: "less than",
                less_or_equal: "less or equal",
                greater_than: "greater than",
                greater_or_equal: "greater or equal",
            },
            planRequired: "{integratable} Plan Required",
            noDefaultStoryTitle: "Default Story",
            noDefaultStory: "There is no default story.\n Would you like to make default this story?",
            noMessage: "No Message",
            loading: "Loading",
            loadMore: "Load More",
            hostname: "Host name",
            goToStory: "go to story",
            noResultFound: "No results found",
            checkYourFilterCombination: "Check your filter combination",
            clearYourSearch: "clear your search",
            andTryAgain: "and try again",
            allTemplates: "All Templates",
            allAITemplates: "All AI Templates",
            templatesFromTheIndustry: "Templates from the Industry",
            basicTemplate: "Basic Template",
            proTemplate: "Advanced Template",
            withBot: "& Bot",
            userWithBot: "User & Bot",
            chatDetail: "Chat details",
            allUserDetail: "See all user details",
            sessionData: "Session data",
            supsisChatWidget: "Supsis Chat Widget",
            integratedWith: "Integrated with :   ",
            botStory: "Bot story",
            integration: "Integration",
            Users: "Users",
            user_id: "User ID",
            categories: "Categories",
            worksWith: "Works with",
            importBot: "Import bot",
            keyFeatures: "Key features",
            importing: "importing",
            comingSoon: "Coming Soon",
            pickStory: "Pick a story",
            conversationId: "Chat ID",
            integrateStoryWithSupsisWidget: "Integrate Supsis Widget With Chatbot Story",
            integrateStoryWithWhatsapp: "Integrate Whatsapp With Chatbot Story",
            integrateStoryWithInstagram: "Integrate Instagram with Chatbot Story",
            selectIntegratingStory: "Select the story that will be integrated",
            install: "Install",
            attr: {
                owner: "Owner",
                trendyol_question: "Product Question",
                trendyol_question_id: "Product Question ID",
                trendyol_product_id: "Product ID",
                trendyol_product: "Product Data",
                weekday: "Weekday",
                email: "E-mail",
                phone: "Phone",
                language: "Language",
                timezone: "Timezone",
                gender: "Gender",
                country: "Country",
                referrer: "Referrer",
                department: "Department",
                url: "URL",
                id: "ID",
                conversationId: "Conversation ID",
                channelId: "Channel ID",
                ip: "IP",
                last_seen: "Last Seen",
                name: "Name",
                user_id: "User ID",
                message: "Message",
                akinon_brand: "Brand",
                akinon_order_id: "Order Id",
                akinon_product_id: "Product Id",
                akinon_user_id: "User Id",
                akinon_user_name: "User Name",
                akinon_user_email: "User Email",
                akinon_invoice_url: "Invoice Url",
                akinon_order_status: "Order Status",
                akinon_order_price: "Order Price",
                akinon_shipper_name: "Shipper Name",
                akinon_product_size: "Product Size",
                akinon_sku: "Sku",
                akinon_product_url: "Product Url",
                akinon_product_title: "Product Title",
                akinon_product_image: "Product Image",
                akinon_product_stock: "Product Stock",
                akinon_order_date: "Order Date",
                akinon_track_number: "Track Number",
                akinon_track_url: "Track Url",
                akinon_latitude: "Latitude",
                akinon_longitude: "Longitude",

                ideasoft_user_id: "Member Id",
                ideasoft_invoice_url: "Invoice Url",
                ideasoft_order_id: "Order ID",
                ideasoft_order_status: "Order Status",
                ideasoft_order_price: "Order Price",
                ideasoft_shipper_name: "Shipper Name",
                ideasoft_product_size: "Product Size",
                ideasoft_sku: "Sku",
                ideasoft_product_url: "Product Url",
                ideasoft_product_title: "Product Title",
                ideasoft_product_image: "Product Image",
                ideasoft_product_stock: "Product Stock",
                ideasoft_order_date: "Order Date",
                ideasoft_track_number: "Track Number",
                ideasoft_track_url: "Track Url",

                offline_mode: "Offline Mode",
                available_agents: "Available Agents",
                platform: "Platform",
                probel_sube_kodu: "Branch Code",
                probel_brans_adi: "Branch Name",
                probel_brans_kodu: "Branch Code",
                probel_doktor_adi: "Doctor Name",
                probel_doktor_kodu: "Doctor Code",
                probel_poliklinik_adi: "Polyclinic Name",
                probel_poliklinik_kodu: "Polyclinic Code",
                probel_randevu_tarihi: "Appointment Date",
                probel_date: "Appointment Date",
                probel_randevu_saati: "Appointment Time",
                probel_randevu_id: "Appointment ID",
                probel_hasta_token: "Patient Token",
                probel_kimlik_tipi: "Identity Type",
                probel_kimlik_no: "Identity No",
                probel_hasta_adi: "Patient Name",
                probel_hasta_soyadi: "Patient Surname",
                probel_hasta_cinsiyet: "Gender",
                probel_hasta_dogum_tarihi: "Date of Birth",
                probel_hasta_telefon: "Phone",
                hour: "Hour",
                segments: "Segments",
                tags: "Tags",
                ticket: "Ticket",
                metaReferrals: "Meta Referrals",
                idleUserTime: "User Last Action (Second)",
                ai_class_result: "YZ Sınıf Sonuç",
                meta_comment_id: "Meta Comment ID",
                meta_comment: "Meta Comment",
                meta_post_id: "Meta Post ID",
                visitor_trigger_type: "Visitor Trigger Type",
                visitor_trigger_name: "Visitor Trigger Name",
                b2cargo_companyCode: "Company Code",
                b2cargo_takipNo: "Tracking Number",
                b2cargo_takipseri: "Tracking Serial",
                b2cargo_evrakdurum: "Order Status",
                b2cargo_teslimtar: "Delivery Date",
                b2cargo_gonderen: "Sender Name",
                b2cargo_aliciAdi: "Receiver Name",
                b2cargo_cikisIl: "Province of Departure",
                b2cargo_varisIl: "Province of Arrival",
                b2cargo_teslim: "Product Status",
                b2cargo_urun: "Product Type",
                b2cargo_atfTarih: "Product ATF Date",
                b2cargo_palet: "Product Palette",
                b2cargo_koli: "Product Parcel",
                b2cargo_kg: "Product WEIGHT",
                b2cargo_desi: "Product DESI",
                b2cargo_zimmetno: "Debit No",
                b2cargo_varissube: "Arrival Branch",
                b2cargo_atfDurum: "ATF State",
                holiday_plus_room_id: "Room ID",
                holiday_plus_room_title: "Room Title",
                holiday_plus_room_description: "Room Description",
                holiday_plus_room_size: "Room Size",
                holiday_plus_room_price: "Room Price",
                holiday_plus_room_price_offer: "Room Price Offer",
                holiday_plus_room_discount_price: "Room Discount Price",
                holiday_plus_selected_hotel_id: "Selected Hotel ID",
                holiday_plus_checkin: "Check In",
                holiday_plus_checkout: "Check Out",
                holiday_plus_child_count: "Child Count",
                holiday_plus_adult_count: "Adult Count",
                holiday_plus_child_dates: "Child Dates",
                reservation_time: "Reservation Time",
                reservation_day: "Reservation Day",
            },
            storyList: "Story List",
            douYouWannaDeleteItem: "Do you want to delete this item?",
            douYouWannaDeleteWithChildren: "Do you want to delete this item with its children?",
            stories: "Stories",
            templates: "Templates",
            aitemplates: "AI Templates",
            integrations: "Integrations",
            all: "All",
            installed: "Installed",
            installationOK: "Installed",
            uninstall: "Uninstall",
            remainingMessageDesc: "Remaining free messages : ",
            openAISiteRoutingDescStart: "You can click the link ",
            openAISiteRoutingDescEnd: "to get an api key.",
            integrationOK: "Integrated",
            chatWidget: "Supsis Chat Widget",
            artificialIntelligence: "Artificial Intelligence",
            integratePlatform: "Chatbot can be integrated with {integretable}.",
            integrateOpenAIWithChatbot: "Integrate Chat GPT-4o With Chatbot",
            integrateChatBotWithChatGPT3: "Integration of ChatBot With Chat GPT-4o",
            integrateStoryWithTelegram: "Integrate Story With Telegram",
            webhooks: "Webhooks",
            archive: "Archive",
            reports: "Reports",
            uncheckAll: "Uncheck all",
            userSegments: "User Segments",
            addSegment: "Add Segment",
            addToSegment: "Add To Segment",
            removeFromSegment: "Remove From Segment",
            plansVTippyContent:
                "Billing for this package will be done at the beginning of each month, and in case you wish to cancel, your usage will be charged until the beginning of the month and your package will expire.<br><br>The package price is exclusive of VAT.<br><br>Package changes are reflected in the invoice the next day.",
            segmentName: "Segment Name",
            sameSegment: "There is a segment with the same name!",
            usersInSegment: "Users In Segment",
            noUsersAdded: "No users added",
            updateSegment: "Update Segment",
            newSegment: "New Segment",
            selectAll: "Select all",
            queriesSelected: "queries selected",
            noBlocksFound: "No blocks found!",
            userQuery: "User Query",
            date: "Date",
            unmatched: "Unmatched",
            goToChat: "Go to Chat",
            selectStory: "Select Story",
            selectBlock: "Select Block",
            training: "Training",
            trainingAlert:
                "To implement the changes you made on the bot training page, you need to publish the new version of the scenario you modified",
            unmatchedPhrases: "Unmatched Phrases",
            ignored: "Ignored",
            story: "Story",
            timePeriod: "Time Period",
            wholeTimeSpan: "Whole time span",
            selectAStory: "Select a story",
            searchUserQuery: "Search user query",
            time: {
                today: "Today",
                yesterday: "Yesterday",
                last7: "Last 7 Days",
                last30: "Last 30 Days",
                "this-month": "This Month",
                "last-month": "Last Month",
                "last-3-month": "Last 3 Month",
                "this-year": "This Year",
                "last-year": "Last Year",
                custom: "Choose a Different Date",
            },
            emailProvider: "Email provider",
            triggerFromAnywhere: "Trigger from anywhere",
            allIntegrations: "All Integrations",
            integrateYourCBwithChatWidget: "Integrate your chatbot with Chat Widget.",
            integrateYourCBwithChatGpt3: "Chatbot can be integrated with GPT-4o. GPT-4o api key required.",
            integrateYourCBwithWebHook: "Pass chat information between ChatBot and your web services with ease.",
            integrateYourCBwithIntegratable: "Pass chat information between ChatBot and {integratable} with ease.",
            addWebhook: "Add Webhook",
            editWebhook: "Edit Webhook",
            newWebhook: "New Webhook",
            webhookTitle: "Webhook Title",
            webhookUrl: "Webhook Url",
            webhookToken: "Webhook Token",
            webhookUsername: "Webhook Username",
            webhookPassword: "Webhook Password",
            editBlock: "Edit",
            moveBlock: "Move",
            copyBlock: "Copy",
            addFilter: "Add Filter",
            addFilterGroup: "Add Filter Group",
            clearFilter: "Clear Filter",
            in: "in",
            and: "and",
            or: "or",
            chatbot: "Chatbot",
            allStories: "All Stories",
            addBot: "Create Bot",
            testBot: "Test Your Bot",
            publish: "Publish",
            editName: "Edit Name",
            search: "Search in your story…",
            typeMoreThan3Char: "Type in at least 3 character",
            expand: "Expand",
            expandAll: "Expand All",
            noMatchingItem: "No matching item",
            hint: "Hint",
            select: "Select",
            navigate: "Navigate",
            dismiss: "Dismiss",
            choseAttribute: "Chose Attribute",
            selectReply: "Select Reply",
            preview: "Preview",
            draft: "Draft",
            lastUpdate: "Last Update",
            published: "Published",
            newStory: "New Story",
            updateStory: "Update Story",
            storyDescription: "Story Description",
            storyTitle: "Story Title",
            deleteSingleBlock: "Delete Single Block",
            deleteWithChildren: "Delete With Children",
            startTestFromHere: "Start Test From Here",
            copyBlockId: "Copy Block Id",
            gotoLiveLink: "Go to Live Link",
            copyBlockIdSuccessfull: "Block Id copied to clipboard",
            collapse: "Collapse",
            collapseAll: "Collapse All",
            snDelay: "{delay} sec delay",
            blockUpdated: "Block Updated",
            addPayload: "Add Payload",
            previewModeCaution:
                "You're now previewing one of your story's versions. You can't save changes in the preview mode!",
            enterText: "Enter text...",
            trackpad: "Trackpad",
            navigation: "Navigation",
            navigationDesc: "Please choose your navigation mode.It is up to you if it will be trackpad or mouse.",
            botSetting: "Bot Setting",
            botSettingDesc:
                "Please set confidence level. This is a percentage between 0 and 100. The level defines correctness of chatbot interprets which are related to user inputs.",
            languageSettingsDesc: "Please make sure that Bot's language which it responses is your preferred language.",
            mouse: "Mouse",
            Interactions: "Interactions",
            Actions: "Actions",
            Supsis_Actions: "Supsis Actions",
            Table_Actions: "Table Actions",
            Shopify_Actions: "Shopify Actions",
            Akinon_Actions: "Akinon Actions",
            IdeaSoft_Actions: "Ideasoft Actions",
            START_POINT: "START POINT",
            API_REQUEST: "API REQUEST",
            AI_ASSISTANT: "AI ASSISTANT",
            FEEDBACK_AI_ASSISTANT: "FEEDBACK AI ASSISTANT",
            BOT_RESPONSE: "BOT RESPONSE",
            AI_BOT_RESPONSE: "AI RESPONSE (GPT-4o)",
            AI_CLASSIFICATION: "AI CLASSIFICATION",
            Templates: "Template Blocks",
            AI_MENU_FLOW: "AI MENU",
            OTP_WHATSAPP_FLOW: "OTP Whatsapp",
            OTP_SMS_FLOW: "OTP SMS",
            OTP_MAIL_FLOW: "OTP MAIL",
            AI_INSTAGRAM_FLOW: "AI INSTAGRAM COMMENT",
            PLATFORM_FLOW: "PLATFORM",
            DEFAULT_FALLBACK: "DEFAULT FALLBACK",
            DEFAULT_TIMEOUT: "DEFAULT TIMEOUT",
            AI_FUNCTIONS: "AI FUNCTIONS",
            FILTER: "FILTER",
            addNewFilter: "Add new filter",
            FLOW: "FLOW",
            ATTACHMENT_INPUT: "ATTACHMENT INPUT",
            USER_INPUT: "USER INPUT",
            GO_TO_STEP: "GO TO STEP",
            WEBHOOK: "WEBHOOK",
            SET_ATTRIBUTE: "SET ATTRIBUTE",
            QUESTION: "QUESTION",
            CLOSE_CHAT: "CLOSE CHAT",
            CREATE_TICKET: "CREATE TICKET",
            TRANSFER_CHAT: "TRANSFER CHAT",
            TRANSFER_TO_CHATBOT: "FORWARD TO CHATBOT",
            TAG_CHAT: "ADD TAG",
            REMOVE_TAG: "REMOVE TAG",
            SET_DEPARTMENT: "SET DEPARTMENT",
            SEND_TRANSCRIPT: "SEND TRANSCRIPT",
            SEND_SMS: "SEND SMS",
            SEND_MAIL: "SEND MAIL",
            CREATE_EVENT: "CREATE EVENT",
            CREATE_RESERVATION: "CREATE RESERVATION",
            RESERVATION_OPEN_URL: "Reservation Open Url",
            RESERVATION_SELECT_DAY: "Select reservation day",
            RESERVATION_EVENT_LIST: "Reservation list visitor",
            RESERVATION_SELECT_TIME: "Select reservation time",
            CREATE_TASK: "CREATE TASK",
            SHOPIFY_SHOW_PRODUCTS: "SHOPIFY SHOW PRODUCTS",
            SHOPIFY_PRODUCT_AVAILABILITY: "SHOPIFY PRODUCT AVAILABILITY",
            SHOPIFY_ORDER_STATUS: "SHOPIFY ORDER STATUS",
            AKINON_SHOW_PRODUCTS: "AKINON SHOW PRODUCTS",
            AKINON_FIND_PRODUCT: "AKINON FIND PRODUCT",
            AKINON_ORDER_STATUS: "AKINON ORDER STATUS",
            AKINON_SELECT_ORDER: "AKINON SELECT ORDER",
            AKINON_SELECT_SIZE: "AKINON SELECT SIZE",
            AKINON_FIND_NEAREST_STOCK: "SHOW STORE STOCK",
            AKINON_FIND_NEAREST_STORES: "SHOW NEAREST STORES",
            AKINON_SHOW_DISCOUNT_CODES: "SHOW DISCOUNT CODES",
            SUPPRESSION_ADD: "BLOCK CONTACT",
            SUPPRESSION_REMOVE: "UNBLOCK CONTACT",
            IDEASOFT_SELECT_ORDER: "SELECT ORDER",
            IDEASOFT_ORDER_STATUS: "GET ORDER STATUS",
            IDEASOFT_GET_MEMBER_INFO: "FILL MEMBER INFO",
            SEND_WP_BUSINESS_MESSAGE: "SEND WHATSAPP MESSAGE",
            INSTAGRAM_COMMENT_REPLY: "REPLY COMMENT",
            INSTAGRAM_COMMENT_DELETE: "DELETE COMMENT",
            INSTAGRAM_COMMENT_SHOW: "SHOW COMMENT",
            INSTAGRAM_COMMENT_HIDE: "HIDE COMMENT",
            INSTAGRAM_COMMENT_REPLY_AS_PRIVATE: "REPLY AS PRIVATE",
            TABLE_CREATE_RECORD: "Create Record",
            TABLE_DELETE_RECORD: "Delete Record",
            TABLE_UPDATE_RECORD: "Update Record",
            TABLE_FIND_RECORD: "Find Record",
            TABLE_FIND_RECORDS: "Find Records",
            followingAttributesFilled: "The following attributes will come filled.",
            GET_LOCATION: "GET LOCATION",
            FALLBACK: "FALLBACK",
            TIMEOUT: "TIMEOUT",
            SUCCESS: "SUCCESS",
            FAILURE: "FAILURE",
            message: "Message",
            condition: "Condition",
            score: "Score",
            equal: "Equal",
            not_equal: "isn't equal",
            contain: "Contain",
            not_contain: "Not contain",
            starts_with: "starts with",
            ends_with: "ends with",
            empty: "empty",
            longer_than: "longer than",
            shorter_than: "shorter than",
            less_than: "less than",
            less_than_equal: "less than equal",
            greater_than: "greater than",
            greater_than_equal: "greater than equal",
            value: "Value",
            failures: "Failures",
            email: "Email",
            name: "Name",
            username: "Username",
            source: "Source",
            language: "Language",
            timezone: "TimeZone",
            region: "Region",
            country: "Country",
            referrer: "Referrer",
            url: "Url",
            ip: "Ip",
            city: "City",
            lastSeen: "Last seen",
            userId: "User ID",
            selectStep: "Select Step",
            keywords: "Keywords",
            userSays: "User Says",
            addKeyword: "Add Keyword",
            addUserMessage: "Add User Message",
            set: "Set",
            to: "To",
            gender: "Gender",
            go_to_failure: "Go to failure",
            go_to_success: "Go to success",
            untilFilled: "Until Filled",
            time1: "Once",
            time2: "2 times",
            time3: "3 times",
            time4: "4 times",
            time5: "5 times",
            any: "Any",
            anytext: "Any Text",
            anytextDescription: "Matches only words + spaces",
            alphanumeric: "Alphanumeric",
            integer: "Integer",
            no: "No",
            number: "Number",
            phone: "Phone",
            yes: "Yes",
            yesNo: "Yes - No",
            anyDescription: "Matches anything that is non-empty.",
            alphanumericDescription: "Matches both letters and numerals",
            integerDescription: "Matches an integer number",
            noDescription: "Matches no synonyms",
            numberDescription: "Matches ordinal and cardinal number",
            phoneDescription: "Matches phone number",
            yesDescription: "Matches yes synonyms",
            yesNoDescription: "Matches yes and no synonyms",
            emailDescription: "Matches e-mail",
            urlDescription: "Matches URL",
            temperature: "Temperature",
            askWhenInvalid: "Ask When Invalid",
            applyFilter: "Apply Filter",
            RANDOM_TEXT: "Random Text",
            AI_RANDOM_TEXT: "AI Random Text",
            AI_IMAGE: "AI Image",
            QUICK_REPLY: "Quick Reply",
            FILE: "File",
            notificationMessageStartSuccess: "The block ",
            notificationMessageEndSuccess: " has been added",
            notificationMessageStartError: "An error occurred, the block ",
            notificationMessageEndError: " has not been added",
            blockChangedWannaUpdate: "Wanna update changed",
            responses: "Responses",
            TEXT: "Text",
            IMAGE: "Image",
            GALLERY: "Gallery",
            BUTTON: "Button",
            flow: "Flow",
            active: "Active",
            passive: "Passive",
            chooseAttributeType: "Choose Attribute Type",
            imageAttachment: "Image Attachment",
            audioAttachment: "Audio Attachment",
            videoAttachment: "Video Attachment",
            documentAttachment: "Document Attachment",
            anyAttachment: "Any Attachment",
            typeAttributeValue: "Type Attribute Value",
            typeSearchValue: "Type Search Value",
            addAttribute: "Add Attribute",
            addAttributeDescription:
                "The attribute’s name can only contain alphanumeric characters which are letters A-Z, numbers 0-9, dash or underscore.",
            male: "Male",
            USER_DATA: "User Data",
            CUSTOM_ATTRIBUTES: "CUSTOM ATTRIBUTES",
            enterBotResponseHere: "Enter Bot Response Here...",

            addCard: "Add Card",
            addButton: "Add Button",
            typeCardTitle: "Type Card Title",
            typeCardDescription: "Type Card Description",
            dragAndDropBrowse: "Drag And Drop Browse",
            dragAndDropBrowseFile: "Upload File",
            button: "Button",
            enterYourMessage: "Enter Your Message",
            imageView: "Image View",
            imageUploading: "Image Uploading",
            fileUploading: "File Uploading...",
            clickToChooseNewImage: "Click To Choose New Image",
            clickToChooseNewFile: "Click To Choose New File",
            removeTheExistingOne: "Remove The Existing One",

            validateResponseWithEntity: "Validate Response With Entity",
            actionOnFailureInput: "Action On Failure Input",
            askNextQuestion: "Ask the next question",
            goToSuccessBlock: "Go To Success Block",
            goToFailureBlock: "Go To Failure Block",
            saveResposeToAttribute: "Save Respose To Attribute",
            selectReplyType: "Select Reply Type",
            questionVariants: "Question Variants",
            systemEntities: "System Entities",
            delay: "delay",
            retrySectionTextPart: "Ask ",
            retrySectionText: " , if user's response is invalid",
            addNextQuestion: "Add Next Question",
            typeBlockTitle: "Type block title",
            versionHistory: "Version History",
            restore: "Restore",
            versionName: "Version Name",
            restoreModalText:
                "This action will restore the selected version. Are you sure you want to restore this version?",
            restoreVersion: "Restore Version",
            newVersion: "New Version",
            synonymMustBeUnique: "Synonym Must Be Unique",
            save: "Save",
            entries: "Entries",
            youHaveNoEntries: "You Have No Entries",
            inputsCantBeEmpty: "Inputs Can't Be Empty",
            entryNamesMustBeUnique: "Entry Names Must Be Unique",

            entityNameMustBeUnique: "Entity Name Must Be Unique",
            synonyms: "Synonyms",
            entities: "Entities",
            title: "Title",
            entryName: "Entry Name",

            entityhasbeenUpdatedSuccessfully: "Entity Has Been Updated Successfully",
            emptyError: "Entries Can't Be Empty",
            entityNameCantBeEmpty: "Entity Can't Be Empty",

            allChats: "All Chats",
            paidChats: "Paid Chats",
            busiestPeriod: "Busiest Period",
            ratingDistribution: "Rating Distribution",
            allMessages: "All Messages",
            avarageMessages: "Avarage Messages",
            popularity: "Popularity",
            allUsers: "All Users",
            interactionName: "Interaction Name",
            numberOfMessage: "Number Of Message",
            ofAllUsersMessage: "% Of All Users Message",
            totalData: "Total Data",
            avgData: "Avg Data",
            exportToCsv: "Export To CSV",
            exportToExcel: "Export To Excel",
            inMaintenance: "In Maintenance",
            ADD_TO_SEGMENT: "Add to Segment",
            REMOVE_FROM_SEGMENT: "Remove from segment",
            users: "Users",
            webhookName: "Webhook Name",
            webHookUrl: "Webhook url",
            webHookToken: "Webhook token",
            delete: "Delete",
            basicAuth: "Basic Auth",
            requiredFieldsCannotBeLeftBlank: "Required Fields Cannot Be Empty",
            headerValue: "Value",
            yourVerificationToken: "Token",
            yourWebHookName: "Your Webhook Name",
            yourWebHookUrl: "Your Webhook Url",
            enterKey: "Enter Key",
            password: "Password",
            saveSuccessfully: "Your transaction has been successfully saved",
            urlTypeError: "Please Fill In The Field Correctly (https://api.example.com/webhook)",
            gpt3: {
                apiKeyRequired: "OpenAI Chat GPT-4 Api Key Required.",
                apiKeyDesc:
                    "Chatbot + Chat GPT-4 integration requires Api Key. Please get your api-key or use the api key below for trial. You can use only 20 message for trial.",
                getApiKey: "Get Open AI Api Key",
                typeApiKey: "Type in Api key",
                ownApiKey: "Own OpenAI Api Key",
                trialApiKey: "Trial Api Key (Restricted as 20 Message)",
                useOurTrial: "Use Our Free Trial",
                twentyMessages: "You can try by using 20 Messages as free.",
                enableChatGpt3: "Enable Chat GPT-4",
            },
        },
        coupon: {
            code: "Code",
            discount: "Discount",
            endDate: "End Date",
            name: "Name",
            email: "Email",
            phone: "Phone",
            add: "Add Coupon",
            coupons: "Coupons",
            couponDeleted: "Coupon Deleted",
            limit: "Limit",
            visitorBan: "Visitor has been blocked.",
            visitorUnBlock: "Block has been removed.",
        },
        instagramTitle: "Click the button below to enable Instagram Features.",
        instegramFunctionActive: "Enable Instagram Feature",
        ChatBOT: "Chat Bot",
        WhatsappContacts: "Whatsapp Contacts",
        InstagramContacts: "Instagram Contacts",
        MessengerContacts: "Messenger Contacts",
        volumeUp: "Volume Up",
        minimize: "Minimize",
        maximize: "Maximize",
        auditLogs: {
            auditLogsTitle: "Audit Logs",
            auditLogsSub:
                "Audit logs allow you to track events that have occurred in your company over the last 30 days.",
        },
        task: {
            priority_lowest: "Lowest",
            priority_low: "Low",
            priority_medium: "Medium",
            priority_high: "High",
            priority_highest: "Highest",
            workflowActions: "Workflow Actions",
            workflowTitle: "Workflow Title",
            deleteTask: "Delete Task",
            selectOption: "Select an Option",
            notAuthorizedCreateTask: "You are not authorized to create a task",
            notAuthorizedCreateTaskDesc: "You are not authorized to perform this task.",
            goToMessage: "Go to message",
            goToChat: "Go to chat",
            showVisitor: "Show Visitor",
            closeTheTask: "Close Task",
            sureAddCompletedList: "Are you sure you want to add the task to the Completed List?",
            success: "Success",
            successDesc: "New field added successfully.",
            moveAndDeleteTask: "Move and Delete Tasks",
            justDelete: "Just Delete",
            selectColumnMoveTask: "Select the column where you want to move the tasks",
            todos: "Things to do",
            inProgress: "In Progress",
            approval: "Approved",
            addAComment: "Add a comment...",
            deleteComment: "Are you sure you want to delete the comment?",
            edited: "Edited",
            comments: "Comments",
            addComment: "Add Comment",
            workflow: "Workflow",
            workflowDetail: "Workflow Detail",
            workflowPerm: "Workflow Permissions",
            perm: "Permissions",
            detail: "Details",
            userPerm: "User Permissions",
            deleteCard: "Delete Card",
            createCard: "Create Card",
            editCard: "Edit Card",
            dragCard: "Drag Card",
            allWorkflow: "All Workflows",
            createworkflow: "Create Workflow",
            deleteWorkflow: "Are You Sure You Want to Delete This Workflow?",
            permEditTask: "You Do Not Have Permission to Edit This Task",
            permEditTaskDes: "Contact Your Administrator for Editing Permissions.",
            createTaskError: "You Do Not Have Permission to Create Tasks",
            createTaskErrorDesc: "Contact Your Administrator for Task Creation Permissions.",
            moveTaskError: "You Do Not Have Permission to Change Task Status",
            moveTaskErrorDesc: "Contact Your Administrator for Task Status Change Permissions.",
            deleteTaskError: "You Do Not Have Permission to Delete Tasks",
            deleteTaskErrorDesc: "Contact Your Administrator for Task Deletion Permissions",
            permissionError: "You do not have permission to create tasks",
            permissionErrorDesc: "Please contact your administrator for task creation permissions",
            whatsappContactProfileTitle: "{name} / {number} Profile",
            createTaskVisitor: "Create Task (Visitor)",
            editWorkflow: "Edit Workflow",
            visitor: "Visitor Profile",
            createTaskMessage: "Create Task (Message)",
            createStage: "Create Stage",
            stagesAndStatuses: "Stages and Statuses",
            workflowCreateDesc: "Workflow Description",
            subTasks: "Subtasks",
            followers: "Followers",
            collaborators: "Collaborators",
            addRelations: "Add Relations",
            relations: "Relations",
            main: "Main",
            name: "Name",
            completedOfCheck: "{completed} of {total} tasks completed",
            workflowUpdateMs: "Workflow Successfully Updated",
            taskUpdateMs: "Task Successfully Updated",
            workflowCreatedMs: "Workflow Successfully Created",
            workflowCreateError: "Workflow Could Not Be Created",
            taskCreatedMs: "Task Successfully Created",
            settingsDesc3:
                "Additionally, the Supsis task module allows you to create your own workflow with customizable automation, enabling you to manage tasks more effectively and enhance collaboration within the team.",
            settingsDesc4:
                "This way, you can track each of your tasks in detail, assign tasks to team members, and overall manage your business processes more efficiently. The Supsis task module provides you with a comprehensive solution for task management and team coordination.",
            settingsDesc2:
                "The Supsis task module leaves no task overlooked. You can filter tasks based on any parameter, track workloads for each workflow stage, and organize your calendar to align with your schedules.",
            settingsDesc1:
                "The Tasks module allows you to organize collaborative work, delegate tasks, and track your team's progress. You can customize your tasks according to your needs by selecting any view and create your own custom workflows with automations.",
            taskModuleSettingsTitle: "Task Module Settings",
            high: "High",
            medium: "Medium",
            low: "Low",
            priority: "Priority",
            addExistsSubtask: "Add Existing Subtask",
            addSubtask: "Add Subtask",
            add: "Add",
            newCheckList: "New Checklist",
            subtaskTitle: "Subtask Title",
            view: "View",
            attachFiles: "Attach Files",
            createTaskDesc: "Task Description",
            title: "Title",
            createWorkflow: "Create Workflow",
            editTask: "Edit Task",
            createTask: "Create Task",
            deleteColumnCont: "Are you sure you want to delete this column?",
            changeStage: "Change Stage",
            assignees: "Assignees",
            owner: "Owner",
            stage: "Stage",
            writeSomething: "Write something",
            selectAssginee: "Select Assignee",
            assignee: "Assignee",
            enterNewTaskDesc: "Enter New Task Description",
            enterNewTaskTitle: "Enter New Task Title",
            task: "Tasks",
            deleteTaskCont: "Are you sure you want to delete these tasks?",
            deleteWorkFlowCont: "Are you sure you want to delete this Workflow?",
            completed: "Completed",
            todo: "ToDo",
            kanbanBoard: "Kanban Board",
            listView: "List View",
        },
        permissionErrors: {
            userCreate: "You do not have permission to add users. Please consult your administrator.",
            userRead: "You do not have permission to view users. Please consult your administrator.",
            userUpdate: "You do not have permission to update users. Please consult your administrator.",
            userDelete: "You do not have permission to delete users. Please consult your administrator.",
            visitorBlock: "You do not have permission to block visitors. Please consult your administrator.",
            visitorUnblock: "You do not have permission to unblock visitors. Please consult your administrator.",
            visitorDetailRead: "You do not have permission to view visitor details. Please consult your administrator.",
            visitorListRead: "You do not have permission to view visitor lists. Please consult your administrator.",
            visitorDelete: "You do not have permission to delete visitors. Please consult your administrator.",
            visitorExcel: "You do not have permission to get Excel output. Please consult your administrator.",
            visitorUpdate: "You do not have permission to update visitors. Please consult your administrator.",
            bannedVisitorRead:
                "You do not have permission to view banned visitors list. Please consult your administrator.",
            bannedWordCreate: "You do not have permission to add banned words. Please consult your administrator.",
            bannedWordRead: "You do not have permission to view banned words. Please consult your administrator.",
            bannedWordDelete: "You do not have permission to delete banned words. Please consult your administrator.",
            chatRead: "You do not have permission to view chats. Please consult your administrator.",
            chatUpdate: "You do not have permission to edit chats. Please consult your administrator.",
            archiveRead: "You do not have permission to view archives. Please consult your administrator.",
            roleCreate: "You do not have permission to add roles. Please consult your administrator.",
            roleRead: "You do not have permission to view roles. Please consult your administrator.",
            roleUpdate: "You do not have permission to update roles. Please consult your administrator.",
            roleDelete: "You do not have permission to delete roles. Please consult your administrator.",
            departmentCreate: "You do not have permission to add departments. Please consult your administrator.",
            departmentRead: "You do not have permission to view departments. Please consult your administrator.",
            departmentUpdate: "You do not have permission to update departments. Please consult your administrator.",
            departmentDelete: "You do not have permission to delete departments. Please consult your administrator.",
            preparedContentCreate:
                "You do not have permission to create prepared content. Please consult your administrator.",
            preparedContentRead:
                "You do not have permission to view prepared content. Please consult your administrator.",
            preparedContentUpdate:
                "You do not have permission to update prepared content. Please consult your administrator.",
            preparedContentDelete:
                "You do not have permission to delete prepared content. Please consult your administrator.",
            welcomeCreate: "You do not have permission to create welcome messages. Please consult your administrator.",
            welcomeRead: "You do not have permission to view welcome messages. Please consult your administrator.",
            welcomeUpdate: "You do not have permission to update welcome messages. Please consult your administrator.",
            welcomeDelete: "You do not have permission to delete welcome messages. Please consult your administrator.",
            settingCreate: "You don't have permission to create settings. Please consult with your administrator.",
            settingRead: "You don't have permission to view settings. Please consult with your administrator.",
            settingUpdate: "You don't have permission to update settings. Please consult with your administrator.",
            settingDelete: "You don't have permission to delete settings. Please consult with your administrator.",
            reportCreate: "You don't have permission to create reports. Please consult with your administrator.",
            reportRead: "You don't have permission to view reports. Please consult with your administrator.",
            reportUpdate: "You don't have permission to update reports. Please consult with your administrator.",
            reportDelete: "You don't have permission to delete reports. Please consult with your administrator.",
            offlineSupportRequestCreate:
                "You don't have permission to create offline support requests. Please consult with your administrator.",
            offlineSupportRequestRead:
                "You don't have permission to view offline support requests. Please consult with your administrator.",
            offlineSupportRequestUpdate:
                "You don't have permission to respond to offline support requests. Please consult with your administrator.",
            offlineSupportRequestDelete:
                "You don't have permission to delete offline support requests. Please consult with your administrator.",
            catalogCreate: "You don't have permission to create catalogs. Please consult with your administrator.",
            catalogRead: "You don't have permission to view catalogs. Please consult with your administrator.",
            catalogUpdate: "You don't have permission to update catalogs. Please consult with your administrator.",
            catalogDelete: "You don't have permission to delete catalogs. Please consult with your administrator.",
            chatbotStoryCreate:
                "You don't have permission to create chatbot stories. Please consult with your administrator.",
            chatbotStoryRead:
                "You don't have permission to view chatbot stories. Please consult with your administrator.",
            chatbotStoryUpdate:
                "You don't have permission to update chatbot stories. Please consult with your administrator.",
            chatbotStoryDelete:
                "You don't have permission to delete chatbot stories. Please consult with your administrator.",
            chatbotTemplateRead:
                "You don't have permission to view chatbot templates. Please consult with your administrator.",
            chatbotTemplateAiRead:
                "You don't have permission to view AI chatbot templates. Please consult with your administrator.",
            chatbotIntegrationsRead:
                "You don't have permission to view chatbot integrations. Please consult with your administrator.",
            chatbotArchiveRead:
                "You don't have permission to view chatbot archives. Please consult with your administrator.",
            chatbotEntitiesRead:
                "You don't have permission to view chatbot entities. Please consult with your administrator.",
            chatbotEntitiesCreate:
                "You don't have permission to create chatbot entities. Please consult with your administrator.",
            chatbotEntitiesUpdate:
                "You don't have permission to update chatbot entities. Please consult with your administrator.",
            chatbotEntitiesDelete:
                "You don't have permission to delete chatbot entities. Please consult with your administrator.",
            chatbotReportRead: "You do not have permission to view Chatbot Reports. Please contact your administrator.",
            chatbotTrainRead: "You do not have permission to view Chatbot Training. Please contact your administrator.",
            chatbotSegmentCreate:
                "You do not have permission to create Chatbot User Segments. Please contact your administrator.",
            chatbotSegmentRead:
                "You do not have permission to view Chatbot User Segments. Please contact your administrator.",
            chatbotSegmentUpdate:
                "You do not have permission to update Chatbot User Segments. Please contact your administrator.",
            chatbotSegmentDelete:
                "You do not have permission to delete Chatbot User Segments. Please contact your administrator.",
            integrationsRead:
                "You do not have permission to view Integrations Page. Please contact your administrator.",
            whatsappIntegrationRead:
                "You do not have permission to view Whatsapp Integration Page. Please contact your administrator.",
            instagramIntegrationRead:
                "You do not have permission to view Instagram Integration Page. Please contact your administrator.",
            telegramIntegrationRead:
                "You do not have permission to view Telegram Integration Page. Please contact your administrator.",
            integrationCreate: "You do not have permission to enable Integrations. Please contact your administrator.",
            triggerCreate: "You do not have permission to create Triggers. Please contact your administrator.",
            triggerRead: "You do not have permission to view Triggers. Please contact your administrator.",
            triggerUpdate: "You do not have permission to update Triggers. Please contact your administrator.",
            triggerDelete: "You do not have permission to delete Triggers. Please contact your administrator.",
            billingRead: "You don't have permission to view the bills. Please contact your administrator.",
            taskCreate: "You don't have permission to create tasks. Please contact your administrator.",
            taskRead: "You don't have permission to view tasks. Please contact your administrator.",
            taskUpdate: "You don't have permission to update tasks. Please contact your administrator.",
            taskDelete: "You don't have permission to delete tasks. Please contact your administrator.",
            calendarCreate:
                "You don't have permission to create calendar/reservation. Please contact your administrator.",
            calendarRead: "You don't have permission to view calendar/reservation. Please contact your administrator.",
            calendarUpdate:
                "You don't have permission to update calendar/reservation. Please contact your administrator.",
            calendarDelete:
                "You don't have permission to delete calendar/reservation. Please contact your administrator.",
            mailCreate: "You don't have permission to create mails. Please contact your administrator.",
            mailRead: "You don't have permission to view mails. Please contact your administrator.",
            mailUpdate: "You don't have permission to update mails. Please contact your administrator.",
            mailDelete: "You don't have permission to delete mails. Please contact your administrator.",
        },
        message: {
            createDepartment: "Create Department",
            goToLink: "Go to Link",
            emailAddressYouProvide: "An account already exists with the email address you provided.",
            channelPrivacyPolicyNotMet: "Channel privacy policy not met",
            userIsNotInDepartment: "User is not in department",
            currentDepartment:"Current Department",
            validDepartment:"Valid Department",
            youCanForwardToThisDepartment:"You can forward to this department",
            goToSettings:"Go to Settings",
            changeDepartmentAndForward:"Change Department and Forward",
            selectDepartmentToForwardAgent:"Please select which department you would like to route the conversation through for the agent named {selectAgentName}.",
            selectDepartmentToForward: "Select Department to Forward",
            packageConfirmationMessage: "Are you sure you want to purchase the package? The package you purchase is subject to real-time charges. You can continue to use it for one year after cancellation. The price of this product is exclusive of 20% VAT.",
            packagePurchaseConfirmation: "Are you sure you want to purchase the package? Monthly packages will be charged at the beginning of each month. The package usage will end after the cancellation date. The price of this product is exclusive of 20% VAT.",
            annualPurchaseDiscount: "Catch the 30% discount offer on annual purchases!",
            customerTables: "Customer Tables",
            formIntegration: "Form Integration",
            automationIntegration: "Automation Integration",
            remainingAutomationTask: "Remaining Automation Task",
            createUserError: "An error occurred while creating the user",
            sendTemplateMessage: "Send Template Message",
            startChatWithDifferentChannel: "Start Chat with Different Channel",
            whatsappChatStarter: "Whatsapp Chat Starter",
            pressEnterToJoin: "Press Enter to join the chat",
            pressEnterToStartChat: "Press Enter to start chat",
            cannotSendMessage: "You cannot send message to this person",
            cannotSendSessionMessage: "You cannot send session message to this person",
            conversationNotInYourDepartments: "This conversation does not belong to any of your departments",
            customizeImage: "If you want to customize the image",
            clickToUpload: "Click here to upload a picture",
            uploadNote: "Following are the file formats and their respective sizes which are accepted for upload",
            imageSize: "The image could not be uploaded because it is more than 2 MB",
            videoSize: "The video could not be uploaded because it is more than 20 MB",
            documentSize: "The document could not be uploaded because it is more than 2 MB",
            uploading: "Image uploading, please wait...",
            uploadSuccess: "Image uploaded successfully",
            note: "Note",
            gridView: "Grid View",
            completedTasks: "Completed Tasks",
            system: "System",
            destroyedBy: "Destroyed By",
            brand: "Brand",
            questions: "Questions",
            channelCreatedSuccess: "Channel created successfully",
            channelCreatedError: "Failed to create channel",
            plans: {
                types: {
                    supsis: "Agent Packages",
                    chatbot: "Chatbot",
                    automation: "Automation",
                    customer_tables: "Customer Table",
                    mail: "Email",
                    tasks: "Tasks",
                    form: "Form",
                    whatsapp: "WhatsApp",
                    whatsapp_business: "WhatsApp Business",
                    instagram: "Instagram",
                    messenger: "Messenger",
                    meta_lead: "Meta Lead",
                    trendyol: "Trendyol",
                    "artificial_intelligence": "Artificial Intelligence",
                    "webhook": "Webhook",
                },
            },
            vipCustomerDescription:
                "Marking this person as a VIP customer moves them to the top of the queue and ensures they receive priority service.",
            switchOn: "On",
            switchOff: "Off",
            ownerDescription:
                "This feature indicates the owner of a person. Regardless of the owner's status (online or offline), opened chats are always assigned to their owner. Owned contacts can only be viewed by their respective owner.",
            permissionError: "You do not have permission to perform this action!",
            copySuccess: "Content copied successfully!",
            unowned: "Unowned",
            jsonPreview: "JSON PREVIEW",
            enterNewValue: "Enter new value",
            updatePreferredLanguage: "Update Preferred Language",
            updateTags: "Update Tags",
            updateEmail: "Update Email",
            enterNewEmail: "Enter new email",
            deleteConfirmation: "Delete Confirmation",
            confirmDelete: "Are you sure you want to delete this feature?",
            yesDelete: "Yes, Delete",
            vipCustomer: "★ VIP Customer",
            takeControlFromChatbot: "Take Control from Chatbot",
            enterJoin: "You can join the chat by pressing the Enter key",
            watchChat: "Watch Chat",
            untitledAutomation: "👉 Untitled Profile Click Automation",
            event: "Event",
            chatbotSettings: "Chatbot Routing Settings",
            chatbotScenarioNotFound: "Chatbot Scenario Not Found",
            noChatbotScenario: "No chatbot scenario found in the system.",
            scenarioNotFound: "Scenario not found",
            descNotAvailable: "Description Not Available",
            lastRegulation: "Last Regulation",
            taskCreator: "Task Creator",
            noPermission: "You do not have permission to create tasks.",
            noPermissionDescription: "You do not have permission to perform this action.",
            notAppointed: "Not Appointed",
            changeStage: "Change Stage",
            selectedCandidates: "1 selected candidate(s)",
            coverPhotoRemove: "Remove Cover Photo",
            coverPhotoSet: "Set as Cover Photo",
            autoTransfer: "Automatically Transfer Your Contacts to Zoho",
            autoTransferDescription:
                "Contacts coming to this channel are automatically transferred to the Zoho CRM Contact Module. Those transferred to Zoho activate Zoho widgets.",
            zohoChannelRequiredTitle: "Zoho CRM Channel Required",
            zohoChannelRequiredContent: "You do not have a Zoho CRM channel. Click here to add one immediately.",
            okText: "Add Zoho CRM Channel",
            cancelText: "Cancel",
            forceQueueForNoOwnerContacts: "Force No Owner Contacts to Wait in Queue",
            autoForwardToOwnerForce: "Force Owned Contacts to Forward to Owner (Even When Chatbot is Active)",
            autoForwardToOwnerForceDescription:
                "In all cases, owned contacts are automatically forwarded to their owner. They are neither kept in queue nor transferred to chatbot. Even if this setting is off, if chatbot is not active in the system, they will still be forwarded to their owner.",
            forceQueueDescription:
                "Only owned contacts are automatically assigned, forcing no owner contacts to wait in the queue. ",
            showNoOwnerContactsToAdmins: "Show No Owner Contacts Only to Admins",
            showNoOwnerContactsDescription: "No owner contacts are visible only to admins.",
            autoAssignOwner: "Automatic Contact Ownership",
            autoAssignOwnerDescription:
                "When the chat is automatically assigned to a representative, it is also assigned as an owner.",
            creator: "Creator",
            hideShow: "Hide / Show",
            url: "URL",
            cannedMessages: "Canned Messages",
            templateMessages: "Template Messages",
            chatbots: "Chatbots",
            noCannedMessages: "No Canned Messages Found",
            filterToFindMore: "You can find more canned messages by changing your filters.",
            runPrompt: "Run Prompt",
            noLeadsFound: "No leads found for this person",
            deals: "Deals",
            noDealsFound: "No deals found for this person",
            loadingDeals: "Loading deals",
            zohoCRM: "Zoho CRM",
            viewContact: "View Contact",
            noNotesAdded: "No notes added yet",
            attachments: "Attachments",
            addNewNote: "Add New Note",
            savingg: "Saving...",
            warningFillFields: "Please fill in the title and content fields.",
            successNoteAdded: "Note added successfully.",
            errorAddingNote: "An error occurred while adding the note.",
            noteTitle: "Note Title",
            noteContent: "Note Content",
            selectPreferredAgent: "Select the preferred agent you want to assign to the visitor.",
            postOperations: "Post Operations",
            loadingPostOperations: "Loading post operations",
            noPostOperations: "No post operations found for this person",
            postOperationDetails: "Post Operation Details",
            noMediaDocuments: "No media or documents available for this person.",
            selectionLimitError: "You can select a maximum of 30 items.",
            showNote: "Show Note to Everyone",
            hideNote: "Hide Note",
            updateNote: "Update Note",
            addUserNote: "Add a note about the user",
            privateNote: "Private Note",
            metaReferrals: "Meta Referrals",
            noMetaReferrals: "No meta ad interactions found.",
            searchPrompt: "Search for something.",
            noRecentResults: "No recent results found.",
            contactInfo: "Contact Information",
            noPropertiesAdded: "No properties added yet.",
            propertyAddedUpdated: "Property successfully added/updated.",
            propertyError: "An error occurred while adding/updating the property.",
            propertyDeleted: "Property successfully deleted.",
            propertyDeleteError: "An error occurred while deleting the property.",
            zohoSynchronization: "Zoho Synchronization",
            zohoSyncConfirmation: "Do you want to make changes to the person in Zoho as well?",
            hideOtherInfo: "Hide Other Information",
            showOtherInfo: "Show Other Information",
            whatsappChatStart: "Start WhatsApp Chat",
            ownership: "Customer Ownership",
            countryAndLanguage: "Country, Language",
            calendarEvent: "Calendar Event",
            reservation: "Reservation",
            contact: "Contact",
            user: "User",
            customerOwnership: "Customer Ownership",
            ownerless: "Ownerless",
            preferredDepartment: "Preferred Department",
            flowluTransfer: "Transfer to Flowlu",
            mergeSuccess: "Merge operation completed successfully.",
            visitorOwnershipWarning: "This visitor is owned by another user.",
            newAutomation: "New Automation",
            automations: "Automations",
            createProfileAutomation: "Create Profile Automation",
            profileButtonClicked: "Profile button clicked",
            profileButtonDescription: "This automation will be triggered when a profile button is clicked.",
            automationName: "Automation name",
            create: "Create",
            dayRange: "Day Range",
            hourRange: "Hour Range",
            last24Hours: "Last 24 Hours",
            today: "Today",
            yesterday: "Yesterday",
            thisWeek: "This week",
            lastWeek: "Last week",
            last7Days: "Last 7 days",
            last30Days: "Last 30 days",
            thisMonth: "This month",
            lastMonth: "Last month",
            startDateTime: "Start Date Time",
            endDateTime: "End Date Time",
            complaint: "Complaint",
            opens: "Opens",
            clicks: "Clicks",
            mockData: "(Mock Data)",
            preferredRepresentative: "Select Preferred Agent",
            forwardToDepartment: "Forward to Department",
            toMobileAgents: "To Mobile Agents",
            noMediaAndDocuments: "This user has no media or documents",
            reportBug: "Report a Bug",
            waitingForReply: "Waiting Answer",
            memorySize: "Storage Size",
            usedMemory: "Used Storage",
            availableMemory: "Available Storage",
            memoryLimit: "Storage Limit",
            memoryLimitPrice: "Price for additional storage",
            telegramBotIsReachable: "Reaching Telegram Bot Service",
            telegramBotIsHealthy: "Telegram Bot Service is healthy",
            telegramBotIsUnhealthy: "Telegram Bot Service has an error",
            pieView: "Pie View",
            chartView: "Chart View",
            tableView: "Table View",
            lastUpdate: "Last Update",
            workflow: "Workflow",
            task: "Task",
            filterBy: "By Filter",
            watchAllLive: "Watch All Live",
            sessionsUnique: "Sessions (Unique Users)",
            sessionsAll: "Sessions (All Users)",
            moreFeaturesDesc:
                "More features, more integrations, more agents! Take action now to better manage your team and grow your business to its maximum potential!",
            metaLeadForms: "Meta Lead Forms",
            metaLeadsConnectedSucs: "Meta Leads connected successfully",
            failedToConnectMetaLeads: "Failed to connect to Meta Leads",
            forbiddenChannel: "Banned Channel",
            forbiddenChannelDesc: "You are not allowed to view this channel",
            firstContact: "First Contact",
            needsAnalysis: "Needs Analysis",
            offerSent: "Offer Sent",
            offerReview: "Offer Review",
            decisionPhase: "Decision Phase",
            personDeleted: "Person Deleted",
            metaLeadsIntegration: "Meta Leads Integration",
            phoneNumberIsInvalid: "Phone number is invalid.",
            owner: "Owner",
            addAnItem: "Add an item",
            saveItem: "Save Item",
            customItem: "Custom Item",
            backgroundPhoto: "Background Image",
            whenYouActivateFeature: "When you activate this feature, it will not appear on the booking page",
            logo: "Logo",
            noLogo: "No Logo",
            addTeamMember: "Add Team Member",
            timezone: "Time Zone",
            selectDayys: "Select Day(s)",
            selectStartHour: "Select Start Time",
            selectEndHour: "Select End Time",
            moveLeft: "Move Left",
            moveRight: "Move Right",
            reply: "Reply",
            replyToAll: "Reply to All",
            deleteThreadMessage: "Delete Thread Message",
            totalEmailsBounced: "Total Emails Bounced",
            totalEmailsComplained: "Total emails complained about",
            untilNowTotalEmailOpens: "Total email opens so far",
            untilNowTotalEmailLinkClicks: "Total email link clicks so far",
            uniqueClicks: "Unique Clicks",
            untilNowTotalUniqueEmail: "Total unique email link clicks so far (per recipient)",
            emailCampaignTimeline: "Email Campaign Timeline",
            receivedBroadcasts: "Received Broadcasts",
            groupDeletedSuccessfully: "Group deleted successfully",
            verify: "Verify",
            done: "Done",
            pleaseSelectAnEmailAddress: "Please select an email address.",
            goBack: "Go Back",
            show: "Show",
            vueEmailEditor: "Vue Email Editor (Demo)",
            saveDesign: "Save Design",
            exportHTML: "Export HTML",
            saveAsEmailCustomerGroup: "Save as Email Customer Group",
            saveAsWhatsappCustomerGroup: "Save as Whatsapp Customer Group",
            deleteModalFormDesc:
                "If you delete this form, all data for the form will be permanently deleted. Are you sure you want to continue?",
            todo: "Things to do",
            inProgress: "In Progress",
            approval: "Approval",
            completed: "Completed",
            transactionType: "Transaction Type",
            previousBalance: "Previous Balance",
            nextBalance: "Next Balance",
            amount: "Amount",
            wpIntegrationChannelRequired: "Whatsapp Web Integration Channel Required.",
            wpIntegrationChannelRequiredDesc:
                "Chatbot + Whatsapp Web integration requires Whatsapp Web Channel. Please create a new channel.",
            wabaIntegrationChannelRequired: "Whatsapp Business Integration Channel Required.",
            wabaIntegrationChannelRequiredDesc:
                "Chatbot + Whatsapp Business API integration requires Whatsapp Web Channel. Please create a new channel.",
            instaIntegrationChannelRequired: "Instagram Integration Channel Required.",
            instaIntegrationChannelRequiredDesc:
                "Chatbot + Instagram integration requires Instagram Channel. Please create a new channel.",
            createWpChannel: "Create Whatsapp Web Channel",
            createWabaChannel: "Create Whatsapp Business API Channel",
            createInstaChannel: "Create Instagram Channel",
            failedToDeleteGroup: "Failed to delete group",
            failedToDeleteGroups: "Failed to delete groups",
            failedToFetchGroupContacts: "Failed to fetch group contacts",
            mailAddressDeletedSuccessfully: "Mail Address Successfully Deleted",
            defaultMailAddressChangedSuccessfully: "The default mail address was changed successfully",
            mailAddressAlreadyRegistered: "The mail address cannot be already registered or empty.",
            pleaseVerifyByClicking: "Please verify by clicking the link sent to your e-mail address.",
            signSucsRegistered: "Signature successfully registered",
            myContacts: "My Contacts",
            unanswered: "Missed",
            emailBroadcasts: "Email Broadcasts",
            monthlyLimit: "Monthly Limit",
            totalShipments: "Total Shipments",
            shippingStatus: "Shipping Status",
            lastAction: "Last Action",
            receiver: "Receiver",
            delivered: "Delivered",
            opened: "Opened",
            clicked: "Clicked",
            bounced: "Feedback",
            clickedLinks: "Clicked Links",
            reason: "Reason",
            timer: "Timer",
            implemented: "Implemented?",
            module: "Module",
            excelDownload: "Download Excel",
            serviceFeatures: "Service Features",
            mailAddressDeletedSucs: "Mail address deleted successfully",
            inputSearchText: "Enter search text",
            createRecord: "Create Record",
            separatorCharacter: "Separator Character",
            exampleResultPreview: "Example Result Preview",
            importRecords: "Import Records",
            equals: "Equal",
            notEquals: "Not Equal",
            startsWith: "Starts with",
            endsWith: "Ends with",
            greaterThan: "More",
            lessThan: "Less than",
            before: "Before",
            after: "After",
            is: "O",
            isNot: "Not",
            empty: "Empty",
            notEmpty: "Not Empty",
            isOneOff: "One Time",
            field: "Field",
            records: "Record",
            addIntegration: "Add Integration",
            chatbotScenarioReleased: "Chatbot Scenario released",
            chatbotScenarioHasBeenCanceled: "Chatbot Scenario has been canceled",
            titleAndDesc: "Title & Description",
            templateAndMailSelection: "Template & Mail Selection",
            peopleToSend: "People to Send To",
            submissionPlans: "Submission Plan",
            summary: "Summary",
            broadcastTitle: "Broadcast Title",
            sentByEmail: "Sent Email",
            emailTemplate: "Email Template",
            onlyPeopleWithEmail: "Only people with an email address are eligible for sending.",
            sendNow: "Send Now",
            plan: "Plan",
            senderEmail: "Sender Email",
            totalBuyer: "Total Buyer",
            estimatedDuration: "Estimated Duration",
            person: "Person",
            shippingIsNowComplete: "Shipping is complete!",
            back: "Back",
            customerName: "Customer's Name",
            customerEmail: "Customer's Email",
            customValue: "Custom Value",
            selectMailTemplate: "You must select a mail template.",
            youMustSelectSendingMailAddress: "You must select the sending mail address.",
            youMustSelectCustomerGroupSend: "You must select the customer group to send to.",
            createBroadcast: "Create Broadcast",
            broadcastDetails: "Broadcast Details",
            youCanCheckYourEmailStatus:
                "You can check your email status by upgrading your plan. You can check your email status by upgrading your plan.",
            sentDetails: "Sent details",
            failed: "It failed",
            total: "Total",
            totalEmailsProcessed: "Total emails processed",
            totalEmailsDelivered: "Total emails sent",
            toAvailableAgents: "For Available Agents",
            toAvailableDepartments: "For Available Departments",
            toWithAgentAndDepartment: "With Agent and Department",
            toMobilAgents: "To Mobile Agents",
            toPreferredAgents: "To Preferred Agents",
            searchAgent: "Search Agent",
            searchDepartment: "Search Department",
            searchMobileAgent: "Search Mobile Agent",
            searchAgentOrDepartment: "Search agent or department",
            searchPreferredAgent: "Search for the preferred Agent",
            noAgentsAvailableToForward: "No agents available to forward",
            noDepartmentsAvailableToForward: "No Departments available to forward",
            noMobileAgentsAvailableToForward: "No Mobile Agents Available to Forward",
            noPreferredAgentsAvailableToForward: "No preferred Agents available to forward",
            ifYouSendThisConversationToTheQueue:
                "If you send this chat to the queue, it will remove you from the chat and place the chat in the queue. If automatic chat assignment is enabled, the chat will be assigned to an appropriate agent and may be transferred back to you.",
            ifAutomaticChatAssignmentIsDisabled:
                "If automatic chat assignment is disabled, the call will remain in the queue. Authorized staff can take the call from the queue.",
            sendQueue: "Send to Queue",
            agentName: "Agent Name",
            departmentName: "Department Name",
            toQueue: "Queue",
            web: "Web",
            mobile: "Mobile",
            noGrouping: "No Grouping",
            groupByThis: "Group By This",
            selectGroupingCriteria: "Select Grouping Criteria",
            activeUsers: "Active Users",
            passiveUsers: "Passive Users",
            noPlatform: "No Platform Specified",
            noRole: "Role Unspecified",
            noDepartment: "No Department Specified",
            noLanguage: "No Language Specified",
            group2: "Group",
            groupedByStatus: "Grouped by Status",
            grouping: "Grouping",
            activeSubjects: "Active Subjects",
            passiveSubjects: "Passive Subjects",
            groupSubjects: "Group Subjects",
            showAll: "Show All",
            onlyActive: "Only Active",
            onlyPassive: "Only Passive Ones",
            groupBy: "Group by State",
            selectTimezone: "Select time zone",
            userFilter: "User Filter",
            confidenceScore: "Confidence Score",
            chatbotLanguage: "Chatbot Language",
            botScenerio: "Bot Scenario",
            selectTemplate: "Select Template",
            importFromReadyTemplates: "Import from Ready Templates",
            classification: "Classification",
            addClassification: "Add Classification",
            expressionClassified: "Expression to be Classified",
            zohoModuleName: "Zoho Module Name",
            selectModule: "Select Module",
            standardFields: "Standard Fields",
            selectStandardField: "Select Standard Field",
            customFields: "Custom Fields",
            selectCustomFields: "Select Custom Field",
            aiFunction: "Artificial Intelligence Function",
            aiFunctionDesc: "Manage AI function to perform actions based on user input.",
            functionName: "Function Name",
            functionDesc: "Function Description",
            addParameter: "Add Parameter",
            chooseAiStory: "Choose an AI story",
            chatbotAiPromptDesc:
                "Artificial intelligence learns and determines how it should behave by being given instructions about a specific task or problem using the 'prompt' feature.",
            enterPrompt: "Enter Prompt.",
            aiParameterTunings: "AI Parameter Tunings",
            aiParameterTuningsDesc:
                "You can tune AI parameters to make the AI more responsive and accurate. These parameters are used to control the behavior of the AI and how it responds to user inputs.",
            temperature: "Temperature",
            temperatureDesc:
                "Which sampling temperature to use, between 0 and 2. Higher values like 0.8 will make the output more random, while lower values like 0.2 will make it more focused and deterministic.",
            topDesc:
                "As an alternative to sampling by temperature, so-called kernel sampling, the model considers the results of tokens with the top_p probability mass. So 0.1 means that only tokens with the top 10% probability mass are considered. We usually recommend changing this or the temperature, but not both.",
            toolChoices: "Tool Options",
            noneDesc: "None means that the model will not invoke any tool and will instead generate a message",
            autoDesc:
                "Automatic mode is the default value and means that the model can choose between generating a message or invoking one or more agents.",
            requiredDesc: "Required mode is that the model must call one or more agents before responding to the user",
            createArticles: "Create Article",
            createArticlesDesc: "Create articles to help your users find answers to their questions.",
            articlesTitle: "Article Title",
            articlesContent: "Article Content",
            createFaq: "Create a Frequently Asked Questions (FAQ)",
            createFaqDesc:
                "Create a new FAQ for your chatbot. This will help your chatbot answer the user's questions.",
            question: "Question",
            saveAndClose: "Save and Close",
            contentPreview: "Content preview",
            updateChannelDesc6: "Update Whatsapp business api channel",
            newWabaChannel: "New Whatsapp Business Channel",
            newWabaChannelDesc: "Create a new channel for Whatsapp business api",
            upgradePackageTitle: "Upgrade your package and avoid limits",
            upgradePackageDescription:
                "More features, more integrations, more agents! Take action now to better manage your team and bring your business to its maximum potential!",
            upgradePackage: "Upgrade",
            deleteSelected: "Delete selected files",
            newFolder: "New Folder",
            newFile: "New File",
            noFilesFound: "No files were found in this folder",
            uploadFile: "Upload File",
            enterFolderName: "Please enter folder name",
            folderName: "Folder Name",
            dropFileHere: "Drop files here",
            createFolder: "Create Folder",
            fileUploadingError: "An error occurred while uploading the file",
            fileUploadingSucs: "Folder created successfully",
            folderNameNotEmpty: "Folder name cannot be empty",
            deleteFolder: "Delete Folder",
            sureDeleteFolder: "Are you sure you want to delete this folder and all files in it?",
            deletionSucs: "Deletion successful",
            deleteFile: "Delete File",
            sureDeleteFile: "Are you sure you want to delete this file?",
            deletionError: "An error occurred during the deletion process",
            selectFile: "Select File",
            moreThanOneSelect: "You can select more than one file",
            selectAnFile: "Select a file",
            bulkSms: "Bulk SMS",
            sendBulkSmsCustomers: "Send bulk SMS to your customers",
            writeYourMessage: "Write Your Message Here.",
            sendSms: "Send SMS",
            sendSmsYourCustomers: "Send sms to your customers",
            manageChannelDetail: "Manage channel information",
            details: "Details",
            teamGramChannels: "TeamGram Channels",
            newTeamGramIntegration: "New TeamGram Integration",
            teamGramIntegration: "TeamGram Integration",
            notMoreThanOneTeamGramChannels: "You cannot create more than one TeamGram Channel",
            teamGramDetail: "TeamGram Detail",
            manageYourTeamGramIntegration: "Manage Your TeamGram Integration",
            trendyolChannels: "Trendyol Channels",
            trendyolStoreIntegration: "Trendyol Store Integration",
            trenyolStoreConnection: "Connect your Trendyol store.",
            deleteTrendyolIntegration: "Delete Trendyol Integration",
            sureDeleteTrendyolIntegration:
                "Are you sure you want to delete Trendyol integration? This action is irreversible.",
            trendyolStoreChannel: "Trendyol Store Channel",
            deleteTrendyolChannel: "Delete Trendyol Channel",
            channelUpdatedSucs: "Channel Updated Successfully.",
            failedUpdateChannel: "Failed to Update Channel.",
            trendyolStoreIntegrationDetail: "Trendyol Store Integration Detail",
            configureTrendyolStoreIntegrationDetail: "Configure Your Trendyol Store Integration",
            trenyolStoreProductQuestManage: "Trendyol Store - Product Inquiry Management",
            trendyolStoreDesc: "You can use the following settings to manage inquiries for Trendyol store products.",
            zohoCrmChannels: "Zoho CRM Channels",
            zohoPersonalChannel: "Zoho Personal Channels",
            connectZoho: "Connect to Zoho CRM",
            updateChannelDesc5: "Update Zoho CRM Channel",
            zohoCrmIntegration: "Zoho CRM Integration",
            sureDeleteZohoChannel: "Are you sure you want to delete the Zoho CRM channel?",
            createNotMoreThanOneZohoChannels: "You cannot create more than one Zoho Channel",
            removeZohoLink: "Remove Zoho Link",
            connectToZoho: "Connect to Zoho",
            chatClosed: "Chat closed",
            scoreChat: "Chat rated",
            createdTicket: "Ticket created",
            updatedTicket: "Ticket updated",
            newUserCreated: "New user created",
            updateUser: "User updated",
            deleteUsers: "User deleted",
            changeStatusRepresent: "The representative's status has been changed",
            incomingMessage: "Incoming message",
            outgoingMessage: "Outgoing message",
            createdNewTicket: "New ticket created",
            bitrix24Channels: "Bitrix24 Channels",
            sureDeleteBitrixChannel: "Are you sure you want to delete the Bitrix24 channel?",
            bitrix24Integrations: "Bitrix24 Integration",
            notCreateMoreThenOneChannel: "You cannot create more than one Ideasoft channel",
            connectToBitrix24: "Connect to Bitrix24",
            connectToBitrix24Api: "Connect to the Bitrix24 API",
            updateChannel: "Update channel",
            updateChannelDesc: "Update the Bitrix24 API channel",
            yourBitrix24Domain: "Your Bitrix24 domain name",
            bitrix24ConnectedSucs: "Bitrix24 successfully connected",
            failedToConnectBitrix24: "Failed to connect to Bitrix24",
            channelCreatedSuccessfully: "Channel created successfully",
            failedToCreateChannel: "Failed to create channel",
            holidayPlusChannels: "Holiday+ Channels",
            newHolidayPlusIntegration: "New Holiday+ Integration",
            holidayPlusIntegrations: "Holiday+ Integrations",
            notCreateMoreThanOneHolidayChannel: "You cannot create more than one Holiday+ channel",
            holidayPlusDetail: "Holiday+ Details",
            manageHolidayPlusIntegration: "Manage your Holiday+ integration",
            ideasoftChannels: "Ideasoft Channels",
            connectToIdeasoft: "Connect to Ideasoft",
            connectToIdeasoftApi: "Connect to the Ideasoft API",
            updateChannelDesc2: "Update the WhatsApp Business API channel",
            ideasoftIntegration: "Ideasoft Integration",
            sureDeleteIdeasoftChannel: "Are you sure you want to delete the Ideasoft channel?",
            moreThanOneChannelError: "You cannot create more than one Ideasoft channel",
            websiteAddress: "Website address",
            ideasoftConnectedSucs: "Ideasoft successfully connected",
            failedToConnectIdeasoft: "Failed to connect to Ideasoft",
            redirectURLcopiedToClipboard: "Redirect URL copied to clipboard",
            openAIChannels: "OpenAI Channels",
            newOpenAiChannel: "New OpenAI Channel",
            createNewChannelOpenAi: "Create a new channel for OpenAI",
            updateChannelDesc3: "Update WhatsApp Business API channel",
            openAiIntegration: "OpenAI Integration",
            sureDeleteOpenAiChannel: "Are you sure you want to delete the OpenAI channel?",
            createMoreThenOneOpenAiChannel: "You cannot create more than one OpenAI channel",
            postaCellChannels: "PostaCell Channels",
            newPostaCellChannel: "New PostaCell Channels",
            createNewPostaCellChannel: "Create a new channel for PostaCell sms provider",
            updateChannelDesc4: "Update Whatsapp business api channel",
            leads: "Leads",
            ensureFacebookAccount: "Make sure you have a Facebook account and page",
            ensureAdAccount: "Make sure you have an advertising account",
            page: "Page",
            leadCount: "Lead Count",
            showLeads: "Show Leads",
            syncLeeds: "Synchronize Leads",
            wpStartChat: "WhatsApp Chat Launcher",
            archivedIn: "Archived?",
            makeSelect: "Make Selection",
            newLead: "New Lead",
            initialContact: "First Contact",
            needsAssessment: "Needs Assessment",
            proposalSent: "Proposal Sent",
            proposalReview: "Proposal Review",
            negotiation: "Negotiation",
            decisionStage: "Decision Stage",
            closure: "Closure",
            followUp: "Follow-up",
            campaign: "Campaign",
            adSet: "Ad Set",
            ad: "Advertisement",
            inArchived: "Archived",
            deletedSelectedPerson: "Delete Selected People",
            sureDelSelectedPerson: "Are you sure you want to delete the selected people?",
            deletePerson: "Delete Person",
            sureDeletePerson: "Are you sure you want to delete this person?",
            phoneNumberNotAvailable: "Phone number not available",
            statusSucsUpdated: "Status updated successfully",
            statusUpdatedFailed: "An error occurred while updating status",
            archivedContact: "Archive contact",
            sureWantArchivePerson: "Are you sure you want to archive this person?",
            personArchived: "Person Archived",
            personArchivedHead: "Archiving operation failed",
            metaLeadChannels: "Meta Lead Channels",
            wpStartSpeech: "WhatsApp Chat Starter",
            pleaseSelectStartChat: "Please select the channel on which you want to start the chat:",
            phoneNumber: "Phone Number",
            phoneNumberDesc: "Country code with numbers only, no spaces",
            channelDesc: "Select the channel you want to start the chat on",
            pleaseSelectStartChatOn: "Please select the channel you want to start the chat on",
            notAuthorizedChannel: "You are not authorized to access this channel.",
            phoneNumberError: "Phone Number Error",
            chatStartError: "There was an error starting the chat. Please try again.",
            noRecordFailed: "No record found",
            metaLeadsChannel: "Meta Leads Channel",
            mlChannelDetails: "Meta Leads Channel Details",
            manageMlChannel: "Manage your Meta Leads",
            deleteMetaLeadsChannelInfo: "Are you sure you want to delete the Meta Leads channel?",
            contactPage: "Contact Page",
            addRouted: "Add Routed",
            otherEmailProviders: "Other Email Providers",
            visitorScreenNaming: "Visitor Screen Naming",
            enterCatalogTitle: "Enter Catalog Title...",
            passwordUpdate: "Update Password",
            showCenterScreen: "Show in the Center of the Screen",
            skipNow: "Skip Now",
            confirm: "Confirim",
            newTable: "New Table",
            actions: "Transactions",
            integrationsTrendyol: "Connect your Trendyol store and automatically respond to your customers' inquiries.",
            integrationsHoliday: "Integrate Holiday+ to provide hotels and rooms via chatbot!",
            integrationsTeamgram:
                "Transfer your customers from Supsis to Teamgram to streamline your customer management!",
            integrationsTicimax: "Send automated message to segmented ticimax members.",
            integrationsBitrix24: "Activate Bitrix24 API for enhanced chatbot experience to your ",
            integrationsIdeasoft: "Activate Ideasoft API for enhanced chatbot experience to your customers.",
            integrationsOpenAI:
                "Activate OpenAI Services - Chatbot AI Response - AI Assistant CoPilot - Chatbot AI Knowledge Base",
            integrationsSMSPostacell: "Activate sending SMS via PostaCELL SMS Provider.",
            integrationsMetaLeads:
                "Manage your Meta Leads via Supsis. Connect leads to Ticket or Chatbot or Live Support",
            integrationsZoho: "Integrate your business processes in Zoho CRM with Supsis.",

            forward: "Forward",
            trendyol: "Trendyol",
            packUpRequired: "Package Upgrade Required",
            upgradePack: "Upgrade Package",
            supsisMobilApp: "SUPSIS MOBİL APP",
            supsisMobilAppDesc: "IOS and Android App on the Market!",
            sendEmail: "Send Email",
            jumpToMessage: "Click to Jump to Message",
            doesntMatter: "Doesn't matter",
            designer: "Design",
            targetContacts: "Target Contacts",
            scheduler: "Scheduler",
            planAndTask: "Plan & Tasks",
            insights: "Insights",
            createRole: "Create Role",
            createSubject: "Create Subject",
            createUser: "Create User",
            blockManuel: "Block Manuel",
            showHide: "Show/Hide",
            contactSearch: "Contact Search",
            favorites: "Favorites",
            downloadAllData: "Download All Data",
            downloadThePage: "Download The Page",
            choosePoints: "Choose Points",
            channel: "Channel",
            createdAt: "Created At",
            action: "Action",
            searchChannel: "Search Channel",
            activeChannels: "Active Channels",
            deleteChannels: "Deleted Channels",
            selectChannel: "Select Channel",
            channelFilter: "Channel Filter",
            noConversationDesc: "Here you can see active chats and chats assigned to you.",
            forMe: "For Me",
            unAssigned: "Unassigned",
            agentDetails: "Agent Details",
            contactProperties: "Contact Properties",
            goToProfile: "Go to Profile",
            addNote: "Add Note",
            noPreferredAgent: "No Preferred Agent Yet",
            toPrefer: "Prefer",
            inChat: "In Chat",
            watching: "Watching",
            chatsTitle: "Chats",
            dealyTimeMaxValueError: "Delay time can be a maximum of 15",
            dealyTimeTypeError: "Delay Time Value Must Be a Number",
            passedTimeHm: "{hour} Hours {min} Minutes",
            passedTimeMs: "{min} Minutes {sec} seconds",
            passedTimeSc: "{sec} Seconds",
            translateMessage: "Your message has been translated by artificial intelligence.",
            toneChanged: "Message tone changed to {tone}",
            aiResponseAdded: "AI Response Added to Message",
            messageLonger: "Message Made Longer",
            grammarFixed: "Grammar Fixed",
            aiTranslate: "Translation",
            other: "Other",
            yourLanguage: "Your language",
            contactLanguage: "Contact Language",
            myLanguage: "My language",
            forwardToChatbot: "Forward to Chatbot",
            friendly: "Friendly",
            confident: "Confident",
            straightForward: "Straightforward",
            casual: "Casual",
            professional: "Professional",
            longSentence: "Long Sentence",
            changeTone: "Change Tone",
            fixGrammar: "Fix Grammar",
            aiResponse: "AI Response",
            templateButtonNote:
                "To ban contact, be careful to use the following texts on the ban button. Regardless of uppercase or lowercase letters",
            templateButtonTags: "#Send Message# | #Unsubscribe# | #Ban# | #Block#",
            dashboard: "Dashboard",
            adminReports: "Admin Reports",
            calendarModule: "Calendar Module",
            taskModule: "Task Management Module",
            maxUrlButtonMessage: "You can add a maximum of 2 URL buttons.",
            noPreferredDepartment: "No Preferred Department",
            searchForDepartment: "Search for Department",
            departmentAssignedToTheVisitor: "Select the department you want to assign to the visitor.",
            assignPreferredDepartment: "Assign Preferred Department",
            smsChannel: "SMS Channel: ",
            whatsappv2Channel: "Whatsapp V2 Channel: ",
            whatsappv1Channel: "Whatsapp V1 Channel: ",
            wBChannel: "Whatsapp Business Channel: ",
            messengerChannel: "Messenger Channel: ",
            instagramChannel: "Instagram Channel: ",
            allPlatforms: "All Platforms",
            cbStartMessage: "Chatbot Start Message",
            cbStartMessageDesc:
                "The first message entered by the user is automatically processed by the chatbot and directed to the relevant address.",
            messengerUserProfile: "Messenger User Profile",
            instagramUserProfile: "Instagram User Profile",
            noEventFound: "No Event Found",
            visitorMails: "Visitor Mails",
            visitorActions: "Visitor Actions",
            notVerified: "Not Verified",
            visitorEvents: "Visitor Events",
            assignedTasks: "Assigned Tasks",
            mails: "Mails",
            prefferedAgents: "Preferred Agents",
            createEvent: "Create Event",
            blockManagement: "Block Management",
            deleteUser: "Delete User",
            blocked: "Blocked",
            profiles: "Profiles",
            similiarProfiles: "Similar Profiles Found",
            ReplyAsAPm: "Reply as Private and Close",
            replyAsAComment: "Reply Comment and Close",
            messengerAddDesc: "Click on the Connect button below & login to your Facebook account.",
            instaAddPrivacyCheckDesc: "I read and agree to {Privacy} and {Terms and Conditions}",
            instaAddDesc5: "Click on the Connect button below & login to your Facebook account.",
            instaAddDesc4: "Register as a Facebook Developer",
            instaAddDesc3: "Ensure that the <b>'Allow access to messages'</b> toggle is switched on",
            instaAddDesc2: "Ensure that your Instagram professional account is connected to your Facebook page",
            instaAddDesc1: "Ensure that your Instagram account is an Instagram professional (Business) account.",
            selectedDepartment: "Selected Department",
            departmentForwardEnable: "Department Forwarding Rule Enabled",
            departmentForwardRule: "Department Forwarding Rule",
            departmentForwardDesc: "Choose which department the chats coming to the channel will be directed to.",
            channelName: "Channel Name",
            forwardToLiveAgents: " 👉 Forward to Live Agents",
            manageIgChannel: "Manage Your Instagram Channel",
            igDetail: "Instagram Detail",
            manageVisibilityDesc: "Manage who can see this channel visibility",
            selectAnIgAccount: "Select an Instagram Account to connect to Supsis",
            connectToInsta: "Connect to Instagram",
            connectToMetaLeads: "Connect to Meta Leads",
            deleteInstaChannelInfo: "Are you sure you want to delete the Instagram channel?",
            instagramChannels: "Instagram Channels",
            suspendedDescription: "Your account has been suspended due to unpaid invoices",
            onlyChatbot: "Only Chatbot",
            onlyAgents: "Only Agents",
            checkboxWarning: "This field is required to be checked",
            sendingAllow: "Sending",
            receiving: "Receiving",
            platform: "Platform",
            banModalTitle: "Visitor Ban Modal",
            selectDepartmentDesc: "Select the departments you want to change the visibility of",
            selectAgentDesc: "Select the agents you want to change the visibility of",
            selectDepartment: "Select Department",
            selectAgent: "Select Agent",
            visibleDepartments: "Visible Departments",
            visibleAgents: "Visible Agents",
            visibilityInfoCont: "All agents and departments can see this channel",
            editDepartmentVisibility: "Edit Department Permissions",
            editAgentVisibility: "Edit Agent Permissions",
            typeSTToSearch: "Type something to search for users",
            exportToCSV: "Export to CSV",
            clear: "Clear",
            usedSessionCount: "Used Session Count",
            maxSessionCount: "Maximum Session Count",
            leftSessionCount: "Remaining Session Count",
            planManagement: "Plan Management",
            maxAutomationTask: "Maximum Automation Task",
            teamChat: "Team Chat",
            templateNameIsNotValid: "Template Name Is Not Valid",
            relatedAdvertisement: "Related Advertisement",
            whatsappNumber: "Whatsapp number",
            createTask: "Create Task",
            integrationsWhatsappV1:
                "A WhatsApp Plan is required for seamless communication between Supsis and WhatsApp.",
            integrationsWhatsappV2: "You can easily share chat information between Supsis and WhatsApp.",
            integrationsWhatsappBusiness:
                "You can quickly and conveniently transmit chat information between Supsis and WhatsApp.",
            selectDays: "Select Days",
            addTime: "Add Time",
            instagramContactList: "Instagram Contact List",
            archiveAllRated: "Retrieve all chats with any ratings.",
            allChannels: "All channels",
            comment: "Comment",
            news: "What's New",
            conversation: "Team Chat",
            speechTermination: "End chat",
            noSystemMessage: "There are no messages in the system yet!",
            supsisCustomerService: "Customer services provided by Supsis,",
            supsisClickExperience: "You can try the experience by clicking.",
            customerPage: "Go to Customer Page",
            buttonTitle: "Button title",
            buttonType: "Button type",
            buttonSendMessage: "Send Message",
            buttonGoToBlock: "Go to block",
            buttonOpenUrl: "Open URL",
            buttonPhoneCall: "Phone Call",
            buttonOpenMoment: "Open Moment",
            buttonCloseChat: "Close Chat",
            buttonTransferChat: "Transfer Chat",
            buttonCreateTicket: "Create Ticket",
            deleteVisitor: "Are you sure you want to delete user? This operation cannot be undone.",
            deleteThread: "Are you sure you want to delete all mails? This operation cannot be undone.",
            deleteMail: "Are you sure you want to delete mail? This operation cannot be undone.",
            userProfile: "Profile",
            addCalendarEvent: "Event +",
            you: "You",
            apiIntegration: "Developer",
            generateToken: "Generate Token",
            copyToken: "Copy Token",
            dndBlocked: "File sending settings turned off.",
            labels: "Labels",
            noData: "No Data",
            color: "Color",
            titleColor: "Title Color",
            secondTitleColor: "Second Title Color",
            tag_name_indicator: "Tag Name",
            sendMessage: "Send Message",
            removeFromG: "Remove from the group",
            delChannel: "Are you sure you want to delete this channel?",
            new_name: "New Name",
            set_group_info: "Edit group information",
            shortcut_desc_num: "Switch between active chats with numeric digits",
            copilot_desc_num: "Allows you to open Copilot on the Chat Screen",
            typing_w_chat: "typing...",
            edit_group_info: "Edit Group Information",
            notif_sound: "Turn on Notification Sounds",
            notif_mute: "Mute Notifications",
            leave: "Leave",
            group: "Group",
            updateTag: "Update Tag",
            ordered_desc: "Assigns chats to representatives in order.",
            random_desc: "Assigns chats to representatives randomly.",
            Rrobin_desc:
                "Assigns chats to representatives in a round-robin fashion. (Prioritizes least busy representatives)",
            RrobinRev_desc:
                "Assigns chats to representatives in a reverse round-robin fashion. (Prioritizes most busy representatives)",
            algo_desc: "Select the algorithm for automatic chat assignment",
            algorithm: "Algorithm",
            os_browser: "Operating System and Browser",
            addTag: "Add Tag",
            tags: "Tags",
            searchRepresentative: "Search Representative",
            voting: "Voting",
            chatWidget: "Supsis Chat Widget",
            webhooks: "Webhooks",
            selectHooks: "Select Web Hooks",
            planRequired: "{integratable} Plan Required",
            allIntegrations: "All Integrations",
            disableAgentSystemMessages: "Hide agent system messages",
            disableAgentSystemMessagesDesc: "Hide Agent System Messages.",
            disableAutoTranslate: "Auto Translate",
            disableAutoTranslateDesc:
                "It automatically translates messages from different languages. So you can communicate with your customers more easily.",
            shouldAddMethod:
                "You must fill in the Payment Method and Billing Address field!\n No money will be withdrawn from your account.\n" +
                "At the end of the month, an invoice will be created according to your usage amount.",
            approveSelection: "Approve Selection",

            trialDaysEndSelectPlan: "Confirm Plan Selection",
            trialDaysEndSelectPlanDesc: "Your trial version is over. You need to confirm by selecting the plan below.",
            infoAboutAnnouncement: "Brief information about the announcement",
            announcement: "Announcement",
            newAnnouncementForm: "New Announcement Form",
            newAnnouncement: "New Announcement",
            announcements: "Announcements",
            languageSelection: "Language Selection",
            announcementTitle: "Announcement Title",
            infinitePlay: "Play continuously",
            newTicketSound: "New Ticket",
            vtippyDepartmentNotification: "Notification settings for messages from department chat",
            vtippyGroupNotification: "Notification settings for messages from created groups",
            vtippyAnnouncemenNotification: "Notification settings for new announcements",
            hideBubbleOnMobile: "Hide on mobile",
            cardInfos: "Card Infos",
            vtippyHideBubbleOnMobile: "Chat Bubble is hidden from mobile users.",
            deleteSystemLanguage: "Delete {code} language from the system",
            assignedChat: "Assigned Chat",
            CHAT: "Chat",
            check: "Check Box",
            systemStatus: "System Status",
            chatAssignedToUser: "New chat assigned",
            inactiveThresholdTime: "Inactive Chat Time (minute)",
            tippyInactiveThresholdTime:
                "If no message is sent within the given time, the chat is considered inactive. Enter the value (minutes). Must be range in 1min - 120min.",
            inactiveTerminateTime: "Inactive Chat Terminate Duration (minute)",
            tippyInactiveTerminateTime:
                "Inactive chat  will be terminated if it does not switch to active mode within a certain time. Enter the value (minutes). Must be range in 1min - 120min.",
            removePendingMessage: "Cancel message sending",
            disconnected: "Disconnected",
            visitorWriteEmptyChatTippy: "Customer can write to chat before agent connects.",
            visitorWriteEmptyChat: "Client can write without agent connected.",
            visitorConnectionEventSystemMessageEnabled: "Visitor connection status system messages enable",
            visitorConnectionEventSystemMessageEnabledTippy: "Visitor left and Visitor comeback system messages enable",
            openBubble: "Open Bubble",
            showHeaderImage: "Show Company Logo and Name",
            askQuestion: "Ask a question",
            locationPermsNeeded: "Location permissions are needed to use this feature",
            useMyLocation: "Use my location",
            acceptingChat: "Accepting chats",
            notAcceptingChat: "Not Accepting chats",
            blockBy: "Banned By",
            languageRemovalQuestion: "You are about to delete {code} language from the system!",
            loggedOut: "Logged out",
            vtippyNewVisitorNotification: "Audible notification for every new visitor to your website",

            vtippySelectnotification: "You can choose notification sound.",
            vtippyVoiceLevel: "you can adjust the volume",
            vtippyStartVoice: "Listen",
            vtippyInfiniteNotification:
                "If you are not active in the new Chats panel, it will continue to play. You can edit active-passive by clicking.",

            vtippyTranslateButton: "Translates the selected language to other languages",
            vtippyTranslateClearButton: "Cleans content in other languages.",
            vtippyTicketNotification: "Notification settings for every new ticket you receive",

            vtippyNewChatNotification:
                "You can select sound notification for new chats coming to the system and adjust the volume.",
            vtippyNewConversationNotification:
                "You can choose sound notification and adjust volume for when new incoming chats are assigned to you.",
            vtippyNewMessageNotification:
                "You can select notifications for incoming messages to your chats and adjust the volume.",
            vtippyPrivateMessageNotification:
                "You can select a notification for the incoming message to the team talk.",
            hideInactiveAgents: "Hide Inactive Agents",
            hideMinorValues: "Hide Minor Values",
            hashHintMessage: "You can quickly enter hashtag shortcuts with #hash",
            pmHintMessage: "Did you know that you can send a keyword private message?. eg pm: Hi",
            billingAddress: "Billing Address",
            addNewAddress: "Add New Address",
            adressTitle: "Address Title",
            address: "Address",
            shortcutHintMessage: "Did you know that you can send messages faster with shortcut messages?",
            switchBetweenConversations: "Did you know that you can quickly switch between chats with abc shortcuts?",
            atNameHintMessage: "Did you know you can quickly enter the visitor name with @name?",
            dndHintMessage: "You can upload files with drag and drop.",
            pasteFile: "you can send files.",
            atEmailHintMessage: "Did you know you can quickly enter the visitor mail with @mail?",
            pastePlainText: "Paste from clipboard as plain text",
            pressAndTalk: "Press and talk",
            agentActivities: "Agent Activities",
            listStatuses: "Statuses",
            newHASHContent: "#Add Hash",
            hash: "Hash Tag",
            hashText: "Hash Text",
            exampleHash: "order-tracking",
            notValidHash: "Must not contain spaces.",
            websiteChatWidgetIntegration: "Website Chat Widget Integration",
            videoCallEnabledDesc: "Activate to enable the video call feature.",
            videoCallEnabled: "Video Call Feature",
            audioCallDesc: "Activate to enable voice search feature.",
            audioCallEnabled: "Voice Search Feature",
            assignPreferredAgent: "Assign Preferred Agent",
            representativeAssignedToTheVisitor: "Select the preferred agent you want to assign to the visitor.",
            agentFileSendEnabledDesc: "Enables the ability to send files to delegates",
            agentFileSendEnabled: "Representatives Can Submit Files",
            visitorFileSendEnabledDesc: "Allows you to turn the visitors file sending feature on or off",
            visitorFileSendEnabled: "Visitors Can Submit Files",
            visitorAutoLogin: "Visitor Auto Login",
            visitorAutoLoginDesc: "Auto start chat when visitor click on chat bubble",
            agentVoiceRecordEnabledDesc: "Enables agents to record audio",
            agentVoiceRecordEnabled: "Agents Can Record Audio",
            visitorVoiceRecordEnabledDesc: "Enables visitors to record audio",
            visitorVoiceRecordEnabled: "Visitors Can Record Audio",
            startVideoCall: "Video call",
            startAudioCall: "Voice Call",
            visitorGDPRDeleteEnabledDesc: "Allows you to toggle the ability to delete all visitors information",
            visitorGDPRDeleteEnabled: "Visitors can delete all their information",
            visitorLocationEnabled: "Visitors can share location",
            visitorLocationEnabledDesc: "Allows visitors to turn location sharing on or off",
            customerLocationEnabled: "Representatives can share location",
            customerAutoMergeEnabled: "Automatically merges the same individuals",
            customerAutoMergeEnabledDesc:
                "This feature performs automatic merging to effectively bring together data related to the same individuals. This ensures that users with similar profiles are represented more consistently and orderly in data sets.",
            chatAiCopilot: "Chat AI Copilot",
            chatAiCopilotDesc: "Automatically Respond to Your Customers' Questions Using Chat AI Copilot",
            customerLocationEnabledDesc: "Allows representatives to turn location sharing on or off",
            thoesNotOwners: "Keep non-owners in the queue",
            thoesNotOwnersDesc: "Enable this feature to keep people who do not own the chat in the queue.",
            hideContactInfo: "Hide contact information",
            hideContactInfoDesc:
                "When you enable this feature, your customers' phone numbers and emails will be hidden from agents.",
            triggerAlreadyExists: "Trigger already exists",
            ticketStatusForm: "Ticket Status Form",
            statusFormTitle: "Ticket Status Title",
            allStatus: "All Statuses",
            triggers: "Triggers",
            trigger: "Trigger",
            noTrigger: "You Haven't Added Any Triggers Yet",
            triggerSkipLoginForm: "Login Form",
            triggerSkipLoginFormTrue: "Show Login Form",
            triggerSkipLoginFormFalse: "Skip Login Form and Go Directly to the Message",
            noContent: "no content",
            toCreate: "To create",
            clickTheButton: "click the button",
            triggerContent:
                "Type the description you want to appear in the modal that opens. You only need to write in one language and the translation into other languages is done automatically.",
            triggerDrag: "You can adjust the message duration by dragging or clicking the bar.",
            triggerNewCondition: "You can add a new condition with the button.",
            triggerNoConditionDescription1:
                "You can create the conditions you want from the options. If you do not create any conditions for any trigger, the first trigger will be active.",
            triggerNoConditionDescription2:
                "Only one of the triggers with the same conditions appears on the Visitor page.",
            triggerShowAndHide: "You can show or hide triggers whenever you want.",
            countryLanguage: "Country/Language",
            addTrigger: "Add Trigger",
            yesPlease: "Yes, please!",
            noThanks: "No, thanks.",
            firstAnswer: "Question Dialogue Confirm Answer",
            secondAnswer: "Question Dialogue Dismiss Answer",
            noTitle: "No Tittle",
            sumChat_MediaFile: "Media and Documents",
            importantWarning: "IMPORTANT WARNING!",
            images: "Images",
            URLS: "Links",
            files: "Files",
            noCondition: "No Condition! You can add Conditions by clicking the plus icon.",
            showTriggers: "Click to Show Triggers",
            showThisTrigger: "Click to Show This Trigger",
            hideTriggers: "Click to Hide Triggers",
            hideThisTrigger: "Click to Hide This Trigger",
            updateTrigger: "Update Trigger",
            conditions: "Conditions",
            messageDurationPerRow: "Message Duration Per Row",
            updateCompleted: "Update Completed",
            CatalogUpdatedSuccessfully: "Catalog Updated Successfully",
            integrateSupsiswithIntegratable: "Pass chat information between Supsis and {integratable} with ease.",
            installationOK: "Installed",
            dayTime: "Hour",
            weekDay: "Day of Week",
            spendTimePage: "Spent Time on Page",
            spendTimeSite: "Spent Time on Site",
            pageUrl: "Page URL",
            pageTitle: "Page Title",
            equal: "Equal",
            not_equal: "Not Equal",
            less_than: "Less Than",
            greater_than: "Greater Than",
            less_than_or_equal: "Less Than or Equal",
            greater_than_or_equal: "Greater Than or Equal",
            visitorName: "Visitor Name",
            seconds10: "10 seconds",
            seconds30: "30 seconds",
            minute1: "1 minute",
            minutes5: "5 minutes",
            minutes10: "10 minutes",
            minutes30: "30 minutes",
            hour1: "1 hour",
            hours2: "2 hours",
            hours4: "4 hours",
            hours8: "8 hours",
            hours12: "12 hours",
            hours24: "24 hours",
            maxCondition: "Max Condition",
            doYouWishToDeleteTrigger: "Do You Wish To Delete Trigger",
            contains: "Contains",
            not_contains: "Does Not Contain",
            chatLanguage: "Chat Language",
            translating: "Translating",
            buyWhatsapp: "Purchase WhatsApp integration",
            liveSupportStartingWait: "Starting Live Support, Please Wait",
            noConnection: "No Connection!",
            integrations: "Integrations",
            refundInvoiceSure: "Are you sure you want to return the invoice?",
            invoiceMarkedAsPaidSuccess: "Invoice has marked as paid successfully",
            invoiceMarkedAsPaidError: "Error, Invoice has not marked paid",
            deleteConfirm: "Do you want to delete this {object}?",
            markPaidConfirm: "Are you sure mark as paid this invoice?",
            addLink: "Link",
            startChatDesc: "Start Chat",
            selectStep: "Select a step:",
            addGOTO: "Go to",
            sendFastLink: "Send Fast Link",
            or: "Or",
            allTags: "All Tags",
            showDetail: "Show Detail",
            hideDetail: "Hide Detail",
            weLlSendPhone: "We'll Send to Your Phone",
            weLlSendEmail: "We'll Send to Your e-Mail",
            linkSentToPhone: "Link sent as sms",
            offerlinkSendToPhone: "We will send you the download link of our application via SMS.",
            offerlinkSendToMail: "We will send you the download link of our application via e-mail.",
            theEmail: "My Registered Email",
            differentEmail: "Another Different Email",
            linkSentToMailBox: "Link was sent to your mail adress",
            errorOccurred: "Error occured !",
            clickStoreIcon: "You can access the mobile application by clicking the icon suitable for your phone.",
            meetWithSupsis: "Would you like to meet our SUPSIS mobile application?",
            downloadMobileApps: "Download Mobile App",
            getApps: "Get Apps",
            info: "Information",
            conversationHistory: "Chat History",
            events: "Calendar Events",
            reservations: "Reservations",
            planInfoHeader: "Plan Information",
            planInformation: "Your plan is {selectedPlan} ({detailMaxAgentCount} Agent) ({freeAgent} Free Agent)",
            creditAvailable: "Your Agent credit available in your plan: ",
            upDownGradePlan: "If you want to upgrade/downgrade your plan, please",
            click: "Click",
            autoStartChat: "Automatic Chat Start",
            bubbleColor: "Chat Bubble Color",
            openFolder: "Open Folder",
            preDefined: "Themes",
            customIcon: "Install from your computer",
            theme: "Theme",
            themeSettings: "Theme Settings",
            chatThemeSettings: "Chat Theme Settings",
            bubbleSettings: "Chat Bubble Settings",
            inputHeightOfBubble: "Bubble Size",
            inputPixelsOfChatBubble: "Click to Edit Distances of Chat Bubble to Edges",
            modalTitleIsMarginAsPixelInfo: "Distances of Chat Bubble to Edges : ",
            inputPxOfXaxis: "Horizontal Position",
            inputPxOfYaxis: "Vertical Position",
            inputPxOfMobileXaxis: "(Mobil) Horizontal Position",
            inputPxOfMobileYaxis: "(Mobil) Vertical Position",
            animations: "Animations",
            preferredAnimation: "Preferred Animation",
            selectAnAnimation: "Select an Animation",
            inputOfBubbleMessage: "Add content to large chat bubbles.\n{contentOfChatBubble}",
            showChatBubbleOnlyLoggedUserToolTip:
                "It is the Setting to Hide the Chat Bubble Based on Login Status.Showed to all visitors in case Off.",
            showChatBubbleOnlyLoggedUser: "Show Bubble to Only Logged in User. (ideasoft)",
            helloDoUNeedHelp: "Hi, Do you need help?",
            bubbleIcon: "Chat Bubble Image",
            overrideMargins: "Customize Margins",
            autoHideBubble: "Hide Chat Bubble",
            vtippyAutoHideBubble: "Hides chat bubble when agents are offline",
            hideBubble: "Disable Chat Bubble",
            vtippyHideBubble: "Disables the chat bubble.",
            overrideMobileMargin: "Customize Margins for Mobile",
            vtippyMobileMargin: "Customize Margins for Mobile",
            isFabsActive: "Show Floating Action Button",
            isAlwaysActive: "Menu is always open",
            isAlwaysActiveDesc: "Would you like the chat bubble menu to always remain open in the web view?",
            bubbleOpenableMenu: "Chat Bubble Dropdown",
            vtippyIsFabsActive: "Setting of Show / Hide Floating Action Button",
            vtippyIsFabsAsIcon: "It is the setting of whether the icons will appear in the drop-down menu.",
            isFabsAsIcon: "Show Menu Icons.",
            setMarginAsPixel: "Set as pixel",
            returnDefaultMargins: "Default Margin Settings",
            deleteSite: 'Do you want to Delete the site " {siteName} " ?',
            deleteThisSite: "Delete the site",
            assetOversizeWithExt: "File size must be less than 10mb and in png,jpg format.",
            closeChat: "End Messaging",
            ticket: "Ticket",
            formStep: "Form Step",
            menuStep: "Menu Step",
            contentStep: "Content Step",
            menuTitle: "Menu Title",
            messageContent: "Message Content",
            goToLive: "Transfer to Representative",
            prevStep: "Return to Previous Step",
            button: "Button",
            addImage: "Image",
            addText: "Text",
            stepTitle: "Step Title",
            addTicket: "Ticket",
            formDescription: "Question",
            addInput: "Question",
            addRandomText: "Random Text",
            calendarPassedTimeMinSec: "{min} minute {sec} second {name}",
            calendarPassedTimeSec: "{hour} hour {min} minute {sec} second {name}",
            updateUserName: "Update Username",
            forgotPassword: "Forgot Password",
            osrFromMessageSaved: "Offline message saved.",
            requiredField: "This field is required.",
            nightModeOn: "Night Mode On",
            catalogMenu: "Menu",
            catalogContent: "Content",
            all: "All",
            allDepartments: "All Departments",
            preferredLanguage: "Preferred Language",
            kmkAutoDepartmentBind: "KMK Auto Deparment Find",
            kmkAutoDepartmentBindDesc: "Search Seller on KMK Customer Sites and set to login page as a department",
            visitorEmailUpdated: "Visitor email  updated",
            visitorEmailIsNotValid: "Visitor email is not valid",
            visitorNameUpdated: "Visitor name updated",
            clickToEdit: "Click to edit",
            addEmail: "+ Add Email",
            addFullname: "+ Add Fullname",
            partner: "Ref?",
            isIntegrated: "Integration?",
            agentCount: "Agent Count",
            closePreviewColors: "Close Theme Preview",
            previewColors: "Open Theme Preview",
            videoCalls: "Video Calls",
            filterLost: "Lost Chats",
            vtipyCustomLogin:
                "You can customize the information that will be requested in the login form when your visitors connect to the system.",
            vtipyLoginlessChat: "Visitor login form will be hidden. Visitor can connect to chat directly. ",
            loginlessChat: "Visitor Login Form",
            imageUrl: "Image Url",
            replied: "Replied",
            solved: "Solved",
            openImage: "Open Image",
            writeFeedback: "You can write your feedback about Supsis here.",
            feedbackFailed: "An error occurred while sending feedback.",
            feedbackSuccessful: "Feedback submission successful.",
            sendFeedback: "Send Feedback",
            errorReport: "You can give us feedback about the problems you have about the SUPSIS.",
            sendErrorFeedBack: "Give us feedback on the issue you are experiencing.",
            successImgUpload: "Your image has been uploaded successfully.",
            successImgDelete: "Image successfully deleted.",
            errorImgUpload: "An error occurred while uploading your image.",
            errorImgDelete: "An error occurred while deleting the image",
            chatBotEndStatics: "Chatbot Chat Success Rate",
            videoCallDist: "Video Call Distribution",
            departmentInfo: "Department Info",
            infoAboutDepartment: "Give brief information about the department",
            deleteDepartmentQuestion: "Do you really want to delete this department?",
            departmentDeleted: "Department Deleted",
            departmentTitle: "Department Title",
            updateDepartmentForm: "Department Update Form",
            newDepartmentForm: "New Department Form",
            department: "Department",
            newDepartment: "New Department",
            departmentSaved: "Department Saved",
            sameDepartment: "There is a department with the same name",
            sameValue: "There is a value with the same name!",
            sameRole: "There is a role with the same name!",
            sameTag: "There is a tag with this name!",
            departments: "Departments",
            chatTimingSettings: "Chat Timing Settings",
            assetOversize: "The size of the file you want to send should not exceed 2mb.",
            assetOversizeMB: "The size of the file you want to send should not exceed {mb}MB.",
            messageDeleted: "This message is deleted",
            filterLostChat: "Filter Lost Chats",
            filterClosedByAgent: "Filter Closed By Agent",
            filterVideoCall: "Video Call Filter",
            notificationText: "Supsis need permission to ",
            notificationTitle: "Notifications Off",
            deniedText:
                "Your notifications are closed, you need to turn on your notifications so that you do not miss your customers.",
            deniedTitle: "Click to Open Your Notifications!",
            deniedHeader: "In order not to miss your customers, you need to turn on your notifications!",
            showNotificationGuide: "Click for details",
            howToEnableNotification: "How Can I Enable Notifications",
            notificationOK: "Ok",
            notificationUnderstood: "Understood!",
            notificationCancel: "Cancel",
            howToEnableNotificationInstruction1: "Click on the lock icon in the address bar of the browser",
            howToEnableNotificationInstruction2: "If 'Notifications' is disabled in the Permissions section, enable it",
            howToEnableNotificationInstruction3:
                'If "Notifications" does not appear in the Permissions section, click on "Site Settings"',
            howToEnableNotificationInstruction4:
                'Turn on the "Notifications" permission from the "Permissions" section of the site settings page',
            checkPaymentMethod: "Please check your payment method",
            pushNotificationEnabled: "Great, Push notification enabled",
            pushNotificationDenied: "You have denied the notification permission",
            suspendedMessage: "Your account has been suspended",
            enableNotification: "Enable Desktop Notifications.",
            languageSettings: "Selected Language",
            problemsSound:
                "If you have problems with notifications,You can click lock image from your browser search box (Shown in Picture) click 'Site Settings' and change 'Sound ' to Allow",
            betweenRepresentative: "There is a new message from a Representative",
            desktopNotifications: "Desktop Notifications",
            notificationEnabled: "Supsis desktop notifications is enabled.",
            newMessageAlert: "You have a new message.",
            notificationDisable: "You can disable notification from Representative settings",
            newConversationAlert: "You have a new visitor.",
            chatBot: "ChatBot",
            ticketResponse: "Temsilcinin Yanıtı:",
            archived: "archive",
            chatbotChatCount: "CHATBOT",
            changeTitle: "Change Title",
            changeVisitorTitle: "Change Visitor Title",
            catalog: "Catalog Title",
            openTheCatalog: "Open Catalog",
            catalogNotOpen:
                "The catalog feature is disabled. You can turn on the catalog feature to support your customers with pre-prepared content.",
            showCatalogCategories: "Set whether catalog menu will show up on Chat bubble",
            showChatBot: "Set whether ChatBot will show up on Chat bubble",
            openCatalog: "Catalog Visibility",
            unreadMessages: "Unread Messages",
            personalFirstMsg: "Agent First Response Time Average (sec)",
            personalRating: "Staff Score Avg",
            soundSettings: "Notification Settings",
            newPrivateMessage: "Private Message",
            addNewGroup: "Create A New Group",
            teamChatTeam: "Team Messages",
            teamChatDm: "Dm Messages",
            teamChatDepartment: "Department Messages",
            teamChatGroup: "Group Messages",
            newMessage: "New Message",
            newConversation: "New Chat",
            newVisitor: "New Visitor",
            chatPosition: "Chat Position",
            bottomLeftCorner: "Bottom Left Corner",
            leftDocked: "Left Docked",
            bottomRightCorner: "Bottom Right Corner",
            rightDocked: "Right Docked",
            chatPositionSelect: "Choose Position",
            bottomLeft: "Bottom Left",
            left: "Left",
            cardNumber: "Card Number",
            cardType: "Card Type",
            skt: "ED",
            cvv: "CVV",
            saveCard: "Save Card",
            cardNameSurname: "Card Holder's Name and Surname",
            confidentialityAgreementCheck: "I Accept the Confidentiality Agreement",
            confidentialityAgreement: "Confidentiality Agreement",
            bottomRight: "Bottom Right",
            right: "Right",
            mailorname: "E-Mail or Name",
            fieldName: "Key Name",
            value: "Value",
            addSetting: "Add a Settings",
            globalSettings: "Global Settings",
            breaksByTime: "Break count by time",
            clPlaceholder: "Name that will appear on the customer form",
            target: "Load Test Address",
            duration: "Load Test Duration(sec)",
            arrivalCount: "Chat Count",
            bootMaxLife: "Chat Max Life Time(sec)",
            startLoadTest: "Start Load Test",
            noClusterInstanceFound: "There is no server",
            stopLoadTest: "Stop Load Test",
            integrationDesc: "Just add the one-line code below to your site.",
            integrationDemoCode: "Simple integration demo code",
            integrationWindow: "How Do I Integrate To My Site ?",
            notIntegrated: "Integration",
            help: "Help",
            notIntegratedDesc:
                "We noticed that you did not add the chat system to your site. When you integrate it into your site and start the first chat, you will complete the integration. Click for INTEGRATION SCRIPT",
            backToLogin: "Go Back To Login Screen",
            passwordlessLoginUnsuccessful: "Login is not successful.Url could be expired or used before",
            passwordlessLogin: "Login Without Password",
            loginWithEmail: "Login With Email",
            loginWithPassword: "Login With Password",
            enteringPasswordless: "Login Without Password...",
            toMainPath: "Redirect to Main Page",
            userRoleChanged: "Your permissions changed. You will be redirected to main page.",
            passwordChangeSuccess: "Your Password Changed Successfully  ",
            feedback: "Show Feedback",
            showFeedbackHistory: "Show messages that have been sent feedback",
            newSelfServiceSite: "New Self Service Site",
            subdomain: "Subdomain",
            rootUserEmail: "Email",
            rootUserName: "Name",
            newVersion: "New Version Available",
            closeLiveSupport: "Close Live Support",
            newVersionShort: "New Version",
            bannedWordRestrict: "Banned Word Blocking",
            ticketShow: "Allow Customers to Create Tickets",
            ticketShowDesc: "Enable the Ticket Creation Option in the Chat Menu",
            autoLoadIframe: "Live Traffic",
            autoLoadIframeDesc: "Auto Load Iframe , Pass All Visitor Traffic",
            bannedWordRestrictDesc:
                "When the Forbidden Word Blocking is turned on, representatives are prevented from typing the prohibited words defined in the system to the visitors.",
            agentDown: "Agent Down",
            delayChat: "Delayed Chat",
            tableSettingTippy: "You can change the information that will appear in the table.",
            tableSettings: "Table Settings",
            tableSettingsInfo:
                "You can change the information that will appear in the table. You can select 7 column at most",
            privateParametry: "Customized User Parameters",
            systemOperetor: "System Information",
            cityAndDistrict: "City/District",
            general: "General",
            availability: "Availability",
            home: "Home",
            successful: "Succesfull",
            forgetPasswordSent: "Reset password link email was sent , check your inbox",
            saturday: "Saturday",
            friday: "Friday",
            thursday: "Thursday",
            wednesday: "Wednesday",
            tuesday: "Tuesday",
            monday: "Monday",
            sunday: "Sunday",
            download: "Download File",
            calendarPassedTimeHour: "{name} for {hour} hour",
            calendarPassedTime: "{name} for {hour} hour {min} min",
            calendarPassedTimeMin: "{name} for {value} min",
            workScheduleOneDay: "{name}'s working schedule on {sDate}",
            workSchedule: "{name}'s working schedule between {sDate} - {eDate}",
            calendar: "Calendar",
            noRating: "There is no Rating to Show",
            rateDist: "Distribution of  Rates",
            distConversation: "Chat distribution by representatives",
            distributionConversa: "Scoring Distribution",
            distChatbotAgent: "Communication channels",
            distAgent: "Chatbot & Agent",
            distFugitive: "Missed Chat & Received Chat",
            distLive: "Live chat",
            distChatbot: "Chatbot",
            distComplex: "Chatbot + Live chat",
            distHandled: "Answered Chat",
            distMissed: "missed Chat",
            distWeb: "WebSite",
            distWhatsapp: "Whatsapp",
            distTelegram: "Telegram",
            distInstagram: "Instagram",
            totalWhatsappChatCount: "Whatsapp Chat Count",
            statsByTime: "Number of Chat by Time",
            selectRep: "Select a representative",
            allRepresentatives: "All Representatives",
            avgRating: "Rating Score({point}) ({count} Rating) ",
            avgFirstMessageTime: "Average Response Time",
            totalBreakTime: "System Break Time",
            totalBreakNum: "Break Count",
            averageConTime: "Average Chat Time",
            multiWpReportTitle: "Number of Multiple WhatsApp Chats",
            multiWpReport: "Multiple Whatsapp Chat Distribution",
            multiWpReportExplanation: "You Can See the Chat Amount of Your  Whatsapp Channels.",
            longestConTime: "Longest Chat Time",
            shortestConTime: "Shortest Chat Time",
            refresh: "Refresh",
            waitingReply: "Pending Messages",
            organizationName: "Organization Name",
            companySlogan: "Company Slogan",
            messageSentErr: "Message not send, Try again.",
            messageSent: "Message Sent.",
            openPrivateChat: "Open Representative Chat",
            escKey: "Hides active chat",
            archiveChatKey: "Allows you to join the chat at the bottom of the Archive Page.",
            chatCopilot: "Turns on Chat CoPilot",
            privateChat: "Inter-Agents Chat Panel",
            multiModeAlertDesc: 'SUPSIS is open in another window. Click "Use Here" to use SUPSIS in this window.',
            useHereText: "Use Here",
            brandVisibility: "SUPSIS brand label show up on chat bubble",
            focusInput: "Focus cursor active chat's input field ",
            send: "Send",
            notYet: "Not yet",
            sending: "Sending",
            onlyRepresentative: "Your message can seen only by representatives",
            yourMessage: "Your message",
            liveFabListDescription: "Live Support",
            messengerIntegrationDesc:
                "Chat with your customers via Facebook page, send automated messages with chatbot.",
            checkDepartmentToAgent: "Department where the online representative will be checked",
            ifAllOfflineStory: "Story to redirect if there is no online representative.",
            AssignMessagesToAgents: "Handle chats via live agents",
            firstChatbotAndAssign: "Handle chats via chatbots",
            hybridAssign:
                "If exists any live agent than on selected department  then handle  with live agents otherwise handle with chatbot.",
            ticketFabListDescription: "Ticket",
            whatsappFabListDescription: "Whatsapp",
            phoneFabListDescription: "Phone",
            emailFabListDescription: "E-mail",
            facebookFabListDescription: "Facebook",
            twitterFabListDescription: "Twitter",
            instagramFabListDescription: "Instagram",
            youtubeFabListDescription: "YouTube",
            linkedinFabListDescription: "Linkedin",
            telegramFabListDescription: "Telegram",
            typeYourChannelLink: "Type your {channelLink} channel link in this field.",
            typeYourAccountLink: "Type your {accountLink} account link in this field.",
            typeYourMessage: "Type your message here",
            typeYourMessageMail:
                "The message entered in this field will be sent by the Customer to the above mail address as the first message.",
            typeYourMessageDesc:
                "The message entered in this field will be sent by the Customer to the above phone number as the first message.",
            sendNumber: "Telephone number to send the message to: {path}",
            callNumber: "Phone number for your customer to call: {phoneNumber}",
            numberIsNotCorrect: "Missing number entered!!",
            emailIsNotCorrect: "E-mail Is Not Correct !",
            selectFab: "Select a Fab",
            notValid: "You can only enter letters. (Single character).e,d,f,z,a,x,c,v,w,t,n letters are invalid",
            forMacUsers: " Mac users can use  Control(⌃) shortcut",
            basePriceValue: "Base Price",
            basePriceDiscount: "Discount",
            basePriceCurrency: "Currency",
            customerDBEnabled: "Database Selection: Use Customer Database Server",
            customerDBDisabled: "Database Selection:  Use Supsis Database Server",
            mongoConnectionString: "Mongo Connection",
            whatsappBasePriceValue: "Whatsapp Base Price",
            whatsappPlusBasePriceValue: "Whatsapp Plus Base Price",
            instagramBasePriceValue: "Instagram Base Price",
            instagramPlusBasePriceValue: "Instagram Plus Base Price",
            clientAddress: "Client Address",
            customerClientAddress: "Customer Client Address",
            apiAddress: "Api Address",
            socketAddress: "Socket Address",
            backendAddress: "backend Address",
            panelLogoUrl: "Panel Logo Url",
            panelCustomCssUrl: "Panel Custom Css Url",
            customerLogoUrl: "Customer Logo Url",
            customerCssUrl: "Customer Css Url",
            siteAlias: "Site Alias",
            language: "Language",
            features: "Features",
            interactionPopularity: "Popularity of interactions",
            interactionCount: "Number of Interaction",
            uniqueUserCount: "Number of Unique User",
            allUserPercentage: "(%) Percent of All User",
            represantativeSettings: "Represantative Settings",
            documentTitle: "Supsis Document Form",
            supsisDocument: "Supsis Document",
            ApiDoc: "API Documentation",
            chatBalloonTehemeSettings: "Chat Balloon & Theme Settings",
            customLoginFormSettingsTitle: "Customize Visitor Login Form",
            addNewField: "Add New Field",
            editField: "Edit Field",
            typeHere: "Type the content here!",
            pco: "Cap. Uti. Rate",
            perPage: "/page",
            perPageInFilter: "Piece",
            noUserInfoFound: "No User Information Found",
            startFilter: "Start filter",
            showMyChats: "Show My Chats",
            showOnlineAgents: "Show Only Online Agents",
            showWaitingChats: "Show Waiting Chats",
            addNewStatus: "Add Status",
            newTitleContent: "New Title",
            newCTRLContent: "New CTRL Content",
            newALTContent: "New ALT Content",
            newTABContent: "New TAB Content",
            roleName: "Role Name",
            error: "Error",
            contentTitle: "Content Title",
            contentType: "Content Type",
            cannotMoveFullParent: "Cannot move this item",
            newSiteForm: "New Site Register Form",
            updateSiteForm: "Site Update Form",
            newBannedWordForm: "New Banned Word Register Form",
            updateBannedWordForm: "Banned Word Update Form",
            newWelcomeMessageForm: "New Welcome Message Register Form",
            updateWelcomeMessageForm: "System Message Update Form",
            newDefaultContentForm: "New Default Content Register Form",
            updateDefaultContentForm: "Default Content Update Form",
            newSubjectForm: "New Subject Register Form",
            updateSubjectForm: "Subject Update Form",
            showChatColorMeaning: "Chat Colors",
            showIntro: "Show Intro",
            options: "Options",
            resetPassword: "Reset Password",
            audioLevel: "Volume of audio alert",
            privateChatNotificationSound: "Notification sound",
            continue: "Continue",
            newRoleForm: "New Role Register Form",
            updateRoleForm: "Role Update Form",
            newRolePlaceHolder: "Click to new role",
            newUserForm: "New User Register Form",
            updateUserForm: "User Update Form",
            changeOSRForm: "Offline Change Message",
            tooltipOSRForm: "You can change the offline message.",
            newOSRForm: "Offline Support Form",
            newOSRMessages: "Add Offline Message",
            updateOSRForm: "Offline Update Form",
            osrTitle: "Title",
            osrTitleDescription: "You can add offline support form title",
            osrContent: "Content",
            osrContentDescription: "You can add offline support form content",
            hello: "Hello",
            cantProceedPayment: "Cause of we couldn't proceed payment",
            and: "and",
            suspendedPlan: " features are suspended",
            payNow: "PAY NOW",
            KeepUsingFeatures: "For Keep Using Your Features",
            date: "Date",
            startDate: "Start Date",
            finish: "Finish",
            start: "Start",
            search: "Search",
            endDate: "End Date",
            representative: "Representatives",
            representative_: "Representative",
            star: "Star",
            filter: "FILTER",
            reset: "RESET",
            dailyChatList: "Daily Chat List",
            dailyChatDuration: "Daily Chat Duration",
            chatDuration: "Chat Duration",
            dailyChatGraph: "daily Chat Graph",
            ok: "OK",
            cancel: "Cancel",
            chatCount: "Chat Count",
            shortest: "Shortest",
            longest: "Longest",
            average: "Average",
            count: "Count",
            averagePoint: "Average Point",
            pointDist: "Point Distribution",
            point: "Point",
            filters: "Filters",
            totalCustomer: "Total Customer",
            avResponseTime: "Average Reponse Time",
            breakDuration: "Break Duration",
            breakCount: "Break Count",
            lastLoginPlatform: "Platform",
            active: "Active",
            passive: "Passive",
            userForm: "User Form",
            sender: "Sender",
            profile: "Profile",
            name: "Name",
            number: "Number",
            username: "User name",
            email: "Email",
            password: "Password",
            oldPassword: "Old Password",
            newPassword: "New Password",
            passwordAtLeast: "Password (at least {num} character)",
            passwordRepeat: "Repeat Password",
            changePassword: "Change Password",
            status: "Status",
            enableState: "Active?",
            douYouWishToDeleteUser: "Dou you wish to delete this user?",
            userDeleted: "User Deleted",
            userSaved: "User saved.",
            oldPasswordError: "The old password is incorrect, please check.",
            chooseAnOption: "Please select a notification sound.",
            userVolumeUpdated: "Volume settings updated.",
            save: "Save",
            update: "Update",
            addNewMenu: "Add New Menu",
            addNewContent: "Add New Content",
            pleaseTitleEnter: "Please title enter",
            like: "Like",
            disLike: "Dislike",
            users: "Users",
            visitor: "Visitors",
            allContacts: "All Contacts",
            allUsers: "All Representatives",
            allSites: "All Domains",
            newUser: "New User",
            noNewUser: "There is no user yet.",
            noNewAdminUser: "There is no admin user yet.",
            noRoleFound: "There is no role yet.",
            noBannedWordFound: "There is no banned word yet.",
            noWelcomeMessageFound: "There is no system message yet.",
            noSubjectFound: "There is no subject yet.",
            noVisitorFound: "There is no visitor.",
            noContactFound: "There is no contact.",
            sendResponse: "Write a Response",
            delete: "Delete",
            noLiveSupportFound: "There is no visitor connect to live support",
            noLiveSupportFoundWithDepartment: "There is no chat belonging to the department",
            duplicate: "Duplicate",
            makeDefault: "Make Default",
            checkMore: "Check More",
            useReadyTemplates: "Use Ready Templates",
            useAITemplates: "Use GPT-4 AI Ready Templates",
            noRePresentativeFound: "There is no representative",
            noBannedVisitorFound: "There is no banned visitor yet.",
            removeBanDescription: "Remove ban",
            editThisItem: "Update this item",
            removeThisItem: "Remove this item",
            role: "Role",
            autoChatAssignLimit: "Auto Chat Assign Limit",
            chatAssignInfo: "-1 = System Default, 0 = No Assign, >0 = Assign as given value.",
            relatedDepartments: "Related Departments",
            subjectInfo: "If there is no selected subject, all subjects are allowed.",
            archive: "Archive",
            offlineSupportRequests: "Offline Supports",
            first: "First",
            last: "Last",
            query: "Start Searching",
            clean: "Clean",
            loading: "Loading",
            loadMore: "Load More",
            noMessage: "Is not any message",
            selectChat: "Pick a Chat",
            noMessageInChat: "There is no message in this chat",
            noMediaToShow: "No Media to Show",
            userInfo: "User Info",
            firstSeen: "First Seen",
            chatId: "Chat ID",
            visitorId: "Visitor ID",
            visitingPage: "Visiting Page",
            osAndBrowser: "Operating System & Browser",
            customerClientVersion: "Customer Client Version",
            visitorFeedback: "Visitor Feedback",
            notes: "Notes",
            nameSurname: "Name & Surname",
            chats: "Chats",
            bannedVisitors: "Banned Visitors",
            country: "Country",
            city: "City",
            cityDistrict: "City District",
            browser: "Browser",
            os: "Operating System",
            ipAddress: "IP Address",
            connectionDate: "Connection Date",
            transaction: "Transaction",
            banRemoved: "Ban Removed.",
            bannedWords: "Banned Words",
            newBannedWord: "New Banned Word",
            noBannedWord: "No banned word yet.",
            bannedWordForm: "Banned Work Form",
            word: "Word",
            bannedWordAndWordGroup: "Banned word / work group",
            doYouWishToDeleteBannedWord: "Dou you really wish to delete this banned word?",
            doYouWishToOfflineSupportRequest: "Dou you really wish to delete this message?",
            bannedWordSaved: "Banned word saved",
            deletedSuccessfully: "Deleted Successfully",
            deleteErrorMsg: "Error: It's not deleted, try again",
            socketError: "Socket connection error. Please refresh page and try again.",
            socketConnecting: "Connecting to server",
            offlineModeDescription: "System down, customers will not be able to access live support.",
            offlineModeSettingsDescription: "Check the Offline Mode feature in the settings menu.",
            offlineModeUser: "There must be at least one online representative in the system.",
            offlineModeMessage: "Offline Message",
            offlineMode: "Offline Mode",
            adminCannotConnectSocket: "Admin cannot connect to socket.",
            liveSupport: "Live Support",
            siteVisitors: "Site Visitors",
            visitors: "Visitors",
            mail: "Mails",
            thoseConnectedToLiveSupport: "Those who connected to live support",
            visitorHistory: "Visitor History",
            visitorHistoryDescription: "You can view and download visitor chat history.",
            privateMessage: "Private Message",
            addRepresentative: "Add Representative",
            forwardRepresentative: "Forward Representative",
            keyboardShortcuts: "Keyboard Shortcuts",
            chatColorMeanings: "Chat color meanings",
            connLostCheckInternet: "Connection lost, please check your internet connection.",
            wishToEndThisChat: "Dou you wish to end this chat?",
            defaultContents: "Templates",
            contents: "Contents",
            newDefaultContent: "New Default Content",
            title: "Title",
            shortcutChar: "Shortcut Character",
            pickOne: "Pick one",
            writeSomething: "Write a character (a-z|0-9)",
            letterSequence: "Letter Sequence",
            exampleText: "Example: soc -> soccer",
            anyChar: "Any character",
            shorcutKey: "Shortcut Key",
            content: "Content",
            shortcutName: "Shortcut Name",
            type: "Type",
            shortcut: "Shortcut",
            defaultContentForm: "Default Content Form",
            titleContentForm: "Ready Content Header",
            deleteContentQuestion: "Do you really wish delete this Default Content?",
            defaultContentDeleted: "Default Content deleted",
            defaultContentSaved: "Default Content saved.",
            contentMoved: "Content Moved.",
            yourEmail: "Email Address",
            yourName: "Your Name and Surname",
            login: "Login",
            lostPassword: "Forgot Password",
            multipleSession: "You are signed in elsewhere.",
            notAuthorizedToDisplayPage: "You are not authorized to see this page!",
            permissions: "Permissions",
            newPermission: "New Permission",
            permissionForm: "Permission Form",
            displayTitle: "Display Title",
            key: "Key",
            keyToUseInSystem: "Key value to use in the system",
            deletePermissionQuestion: "Do you really wish to delete this permission?",
            permissionDeleted: "Permission deleted.",
            permissionSaved: "Permission Saved.",
            newRole: "New Role",
            selectARole: "Select a Role",
            yes: "Yes",
            no: "No",
            fullAuth: "Full Authorization",
            roleDeleted: "Role deleted.",
            roleSaved: "Role saved.",
            roleForm: "Role Form",
            roles: "Roles",
            settings: "Settings",
            selectTopic: "Select Department",
            autoCallTransfer: "Auto Call Transfer",
            customerTyping: "Customer typing",
            typing: "Typing",
            agentTyping: "Representative typing",
            disconnectTime: "Max Reconnection Time (sec)",
            tippyDissconnectTime: "When a chat inactive after how many seconds chat will end.",
            queueNumberVisibleFeature: "Show Queue Number to Visitor",
            privateChatEnabled: "Show The Chat Between Representatives",
            delayedTalkTime: "Delay Time (sec)",
            employeeAverageChatCount: "Average chat number for employee chat rate",
            customerDownTimeWhenRepExit: "Customer downtime when representative leaves (sn.)",
            autoAssignLimit: "Auto Assign Limit",
            wasted: "Chat Lost Time (sec)",
            settingFormWrong: "Form data is wrong, try again after check it",
            settingsSaved: "Settings saved.",
            settingsCannotSaved: "Settings Cannot Be Saved",
            noAuthorization: "No Authorization",
            warningBadInput: "It is recommended to enter a number between 0 and 70.",
            warning: "WARNING!",
            warningBadInputMarginY: "Warning About Vertical Margin Input ⚠️",
            warningBadInputMarginX: "Warning About Horizontal Margin Input ⚠️",
            warningBadInputBubbleSize: "Warning About Chat Bubble Input ⚠️",
            delayTime: "Delay Time (sec)",
            sites: "Sites",
            newSite: "New Site",
            noSiteYet: "There is no site yet.",
            siteAddress: "Site Address",
            turnBack: "Return Back",
            customerRepLimit: "Customer Representative Limit",
            siteSaved: "Site saved.",
            siteSaveError: "An error occured during creating site",
            subjects: "Subjects",
            newSubject: "New Subject",
            noSubject: "No subject yet.",
            subject: "Subject",
            subjectTitle: "Subject Title",
            description: "Description",
            infoAboutSubject: "Information about subject",
            deleteSubjectQuestion: "Do you really wish to delete this subject?",
            subjectDeleted: "Subject deleted.",
            subjectSaved: "Subject saved.",
            welcomeMessages: "System Messages",
            newWelcomeMessages: "New Welcome Message",
            noWelcomeMessage: "No System Message.",
            welcomeMessageContent: "System message content",
            makeChoice: "Make a choice...",
            welcomeMessage: "Welcome Message",
            repLoggedIn: "Representative logged in",
            loginMessage: "Log in message",
            message: "Message",
            deleteWelcomeMessageQuestion: "Do you really wish to delete this system message?",
            welcomeMessageDeleted: "System message deleted",
            welcomeMessageSaved: "System message saved.",
            welcomeMessageForm: "System Message Form",
            noRep: "There is no representative yet.",
            addChat: "Add Chat",
            forwardChat: "Forward Chat",
            ago: "ago",
            repName: "Representative Name",
            lastOnline: "Last Connection/Online time",
            lastStatusChange: "Last Status Change",
            activeChat: "Active Chat",
            userMaxCapacity: "Max Chat Capacity",
            noActiveChat: "No active chat",
            watch: "WATCH",
            join: "JOIN",
            open: "OPEN CHAT",
            directMessage: "PRIVATE MESSAGE",
            block: "BLOCK",
            transactions: "Transactions",
            informations: "Informations",
            visitStart: "Visit Start",
            fullName: "Fullname",
            waitChatTime: "Waiting/Chatting Time",
            blockUserConfirm: "Do you want to block this user?",
            messaging: "Messaging",
            hideChat: "Hide Chat",
            block_: "Block",
            privateMessage_: "Private Message",
            assignRep: "Assign Representative",
            joinChat: "Join Chat",
            forwardRep: "Forward",
            leaveChat: "Leave Chat",
            endChat: "End Chat",
            translatedTextDescription: "Amazon translated this message {from} -> {to}.",
            autoTranslate: "Auto Translate",
            translateThisMessage: "Translate this message",
            autoTranslateDetectedDesc:
                "Visitor language is {visitorLanguage}. Click Here to Activate Automatic Translation",
            on: "on",
            off: "off",
            copy: "Copy",
            prevChats: "Previous Chats",
            noShortCut: "No shortcut",
            leaveChartConfirm: "Dou you really wish to leave the chat?",
            endChatConfirm: "Dou you wish to end the chat?",
            endConversation: "End Chat",
            onlyOneRep: "You are the only representative in this chat!",
            chatList: "Chat List",
            chatBar: "Chat Bar",
            unreadTitle: "Unread",
            visitorLeftTitle: "Visitor Left",
            activeChatTitle: "Active Chat",
            autoAssignedTitle: "Auto Assigned Chat",
            watchModeTitle: "Watch Mode",
            lostChat: "Representative Connection Lost",
            chatWidthDelay: "Chat with Delay",
            repChatWidthDelay:
                "When there is no active representative in the system or all of our representatives full due to high traffic, chat background will be green  ",
            repLostConn: "If customer representative has lost connection, chat background will be pink.",
            unreadMsg: "If there are unread messages, the background will be light blue.",
            visitorLeftChat: "If the visitor left the chat, the background becomes dark gray.",
            activeChatMsg: "Background is green if chat is active",
            autoAssignMsg:
                "The background becomes mustard if assigned by automatic assignment and the chat is not looked further",
            watchModeMsg: "If turned on in playback mode, the background becomes red",
            online: "Online",
            beRightBack: "Away",
            away: "Away",
            busy: "Busy",
            offline: "Offline",
            logout: "Log out",
            forWindows: "For Windows",
            forMac: "For Mac",
            nextChatFromActive: "Switch from active to next chat",
            previousChatFromActive: "Switch from active to previous",
            hideActiveChat: "Hide active chat",
            closeActiveChat: "Close active chat",
            firsthiddenChat: "Join most waited customer's chat",
            firstChatWaiting: "Switch to waiting chat",
            previousOpenedChat: "Regardless of the order, skip to the previously opened chat",
            historyDetails: "History Details",
            chat: "Chat",
            chatNotFound: "Chat Not Found.",
            dataNotFound: "No Data Found.",
            visitorInfo: "Visitor Info",
            timeSpent: "TimeSpent",
            noActiveVisitors: "No active visitors",
            totalConnected: "Chat Count",
            missedChat: "Missed Chat Count",
            workTime: "Work Time",
            closedChatCount: "Closed Chat",
            activeConvo: "Active chat",
            notAnswered: "Not yet answered",
            delayedConvo: "Delayed",
            leavingRep: "Leaving representative",
            staffRate: "Staff Working Rate",
            select: "Dropdown Menu",
            fullname: "Full Name",
            text: "Text",
            numeric: "Number",
            phone: "Phone",
            optionsPlaceholder: "Option value",
            selectField: "Click if you want to add a dropdown menu",
            fullnameField: "Click if you want to add a full name field.",
            textField: "Click if you want to add a text field.",
            labelField: "Click if you want to add a description field.",
            numericField: "Click if you want to add a numeric field.",
            phoneField: "Click if you want to add a phone field.",
            departmentField: "Click if you want to add a department field.",
            emailField: "Click if you want to add a email field.",
            visible: "Visible",
            required: "Required",
            label: "Comment",
            customLoginAlert: "Your Login Form must contain least one  visible field.",
            atLeastOneLanguage: "You must feel at least one language",
            requiredFieldField: "This field is required",
            notRequiredField: "This field is not required",
            visibleField: "This field is visible",
            notVisibleField: "This field does not appear in the form.",
            connectServer: "You are connected to the server",
            disconnectServer: "You are not connected to the server",
            liveChatOff: "Live chat is off",
            visitorScreen: "Visitor Screen",
            viewOnTheSite: "View On The Page",
            viewOnTheSiteTippy: "Click Here To See How Your Changes Hold Up.",
            showHint: "Show Hint",
            dontShowHint: "Don't Show Hint",
            liveChatOn: "Live chat is on",
            nightModeOff: "Night mode off",
            doubleClickEdit: "Double click or press the edit button to edit.",
            edit: "Edit",
            deleteField: "Delete",
            arrow_upward: "Arrow Upward",
            arrow_downward: "Arrow Downward",
            newCatalogCategory: "New Catalog Category",
            childCreate: "Double click to create a new child",
            updateCatalogCategoryFrom: "Update Catalog Category Form",
            newCatalogCategoryFrom: "New Catalog Category Form",
            catalogCategoryMenu: "Add catalog category menu",
            catalogCategoryLeaf: "Add catalog category submenu",
            catalogCategoryName: "Catalog category name",
            newCatalogContentFrom: "New Catalog Content Form",
            catalogContentName: "Catalog content name",
            catalogCategorySaved: "Catalog category saved",
            catalogCategoryDeleted: "Catalog category deleted",
            catalogCategoryRate: "Content Rate",
            catalogContentFeature: "Catalog Content feature",
            vtipyAudioLevel: "Used to mute or unmute notification sounds.",
            vtipyOrganizationName: "You can change the organization name and update it.",
            vtipyBrandVisibility: "Supsis is the setting whether the tag can be displayed in the chat bubble.",
            vtipyBrandVisibilityForced: "Only ProPlan users can change!!",
            vtipyClientDefault: "You can change the agent page language here.",
            vtipyCustomerClientDefault: "You can change the language of the customer (Chat) page here.",
            vtipyVisitorPreferredLang: "The customer can select the spoken language on the (Chat) page.",
            vtipyCustomerClientLanguageDetect: "You can change the language of the customer (Chat) page here.",
            vtipySelectTopic: "Automatic assignments to existing representatives in the selected department occur.",
            vtipyAutoCallTransfer: "Automatically assigns waiting calls to available agents.",
            vtipyCustomerTyping:
                "It allows you to see what the customer wrote on the chat screen on the representative chat screen.",
            vtipyAgentTyping: "It give information when representative typing to customer in chat buble",
            vtipyQueueNumberVisibleFeature:
                "When representatives are busy, it shows customers who want to connect, in what order they are.",
            vtipyPrivateChatEnabled: "Shows the inter-agent chat panel.",
            vtipyDelayedTalkTime:
                'If no delegates are connected to the chat during this time, it will be labeled \\ "Delayed Chat \\',
            vtipyOfflineMode: "Allows you to put the system in offline mode.",
            vtipyAutoAssignLimit:
                "It determines how many customers (chat) will be assigned to the representative automatically.",
            vtipyCustomerDownTimeWhenRepExit: "Customer idle time when the representative exits (sec.)",
            tippyDisconnectTime: "The chat close time after disconnect the customer (sec).",
            changeSettings: "Change Global Settings",
            totalBg: "TOTAL CHATS",
            activeBg: "YOUR CHATS",
            watchBg: "WATCH",
            waitingBg: "QUEUE CHATS",
            lateBg: "MOST WAITING CHATS",
            freeBg: "FREE",
            maxCapacityBg: "MAX CAPACITY",
            addNewSettings: "Add a New Global Settings",
            darkMode: "Dark Mode",

            clientDefault: "Panel default language",
            customerClientDefault: "Customer client default language",
            customerClientLanguageDetect: "Customer Client Language Auto Detect",
            visitorPreferredLang: "Let the customer choose the spoken language",
            preferredThemeColor: "Preferred Theme Color For Client Chat Screen",
            detail: "Detail",
            supportUs: "Contact Us (Live Support)",
            langSetting: "Language Setting",
            changeLang: "Change Language",
            fontSizeSetting: "Screen Zoom Setting",
            changeLangDesc: "Changes application language to {code}",
            trLang: "Turkish",
            enLang: "English",
            fieldRequired: "{field} field is required",
            selectALanguage: "Select a Language",
            selectATheme: "Select a Theme",
            responseForm: "Response Form",
            clientRequestInfo: "Client Request Info",
            createdDate: "Created Date",
            descMessage: "Messages",
            new: "New",
            selectAllPermission: "Select All",
            catalogCategories: "Catalog",
            copiedClipboard: "Copied to clipboard",
            changeLogo: "Change Logo",
            changePhoto: "Change the Photo",
            addPhoto: "Add a Photo",
            seePhoto: "See The Photo",
            deletePhoto: "Delete the Photo",
            organizationLogo: "Organization Logo",
            changePlan: "Change Plan",
            close: "Close",
            vtipyUploadLogo:
                "By uploading your company logo from this area, you can use your own logo in customer emails and customer pages.",
            tagName: "Tag Name",
            tagDescription: "Label Description",
            tagColor: "Label Color",
            userInformations: "User Informations",
            incomingChat: "Incoming Chat",
            support: "Support",
            team: "Team",
            groups: "Groups",
            newConversationStarted: "New converstaion started",
            allHistoryLoaded: "All history loaded",
            chatCreator: "Chat Creator",
            enterGroupTitle: "Enter group title",
            requiredTitle: "Title cannot be empty",
            requiredChannel: "Channel name cannot be empty",
            next: "Next",
            selectPeople: "Select people",
            textLimitAlertMessage:
                "The character limit in WhatsApp is 19 characters and beyond this limit it will not be displayed. However, on the web, texts exceeding the 19-character limit are automatically moved to the next line and displayed.",
        },
        telegram: {
            typeInTelegramToken: "Type In Telegram Token",
            token: "Token",
            telegram: "Telegram",
            telegramTokenTitle: "Telegram Supsis Integration",
            telegramAlertForm: "You can get telegram bot token from",
            telegramAlertTitle: "Do you really want to delete the token?",
            telegramAlertText: "The token will be lost permanently!",
        },
        wp: {
            sendAgain: "Send Again",
            shippingDetails: "Shipping Details",
            importContactsFromFile: "Import Contacts From File",
            chatStarted: "Chat Started",
            chatNotStarted: "Chat Not Started",
            contactSelected: "contact selected",
            startChatWithAnyNo: "Start Chat with Any Number",
            toLittleChar: "Missing number !",
            typeInANumberDesc: "Type in number to starting chat with:",
            wpPlusAndLicenceRequired: "Whatsapp Plus Plan and Licence Required.",
            wpPlusAndLicenceRequiredDesc:
                "Before you can start chats with numbers that are not registered in your contacts, you must upgrade your whatsapp plan and get a license..",
            chatStartingWait: "Chat starting, Please wait",
            whatsapp: "Whatsapp",
            agreement: "Agreement",
            purchase: "Purchase",
            activating: "Whatsapp Service Activation",
            authenticating: "QR Code Authentication",
            ready: "Ready",
            enableFeature: "Enable Whatsapp Feature",
            readAndAgree: "I have read and agree",
            subscribe: "Subscribe",
            subscribed: "Subscribed",
            toEnableWpDescription: "To enable Whatsapp Features , click on the button below.",
            waitForWpActivationDescription:
                "Your whatsapp account service is activating. Please wait for a while. It takes about 10-30seconds.",
            greatWpActivatedDescription: "Great, Your whatsapp account service is activated!",
            unsubscribe: "Unsubscribe",
            planDetails: "Features",
            sendReceiveMessage: "Send & Receive Text Messages",
            sendReceiveImage: "Send & Receive Image Files",
            sendReceiveAudio: "Send & Receive Audio Files",
            sendReceiveGif: "Send & Receive GIF Files",
            startChat: "Start Chat on Supsis",
            supsisFunctionality: "Useful Supsis Chat Functionality",
            onePhoneMultiAgent: "One Phone and Multiple Agents",
            basicIntegration: "Basic Integration and Zero Configuration",
            activationTitle: "To activate whatsapp integration on supsis:",
            wpIntegrationInstruction1: "Open WhatsApp on your phone",
            wpIntegrationInstruction2: "Tap Menu or Setting. Click Linked Devices",
            wpIntegrationInstruction3: "Point your phone to this screen to capture the code",
            qrGeneratingWait: "QR Code Generating please wait...",
            pleaseContinueToWaitUntilCompleted:
                "After the QR Code is verified, it will automatically switch to the completed field. Please wait...",
            authenticatingWait: "Authenticating, please wait...",
            unsubscribeWpInetgration: "Unsubscribe Whatsapp Integration",
            unsubscribeIGIntegration: "Unsubscribe Instagram Integration",
            wpBack: "Back",
            terminatelWpInetgration: "When clicked the 'Unsubscribe' button, your whatsapp integration will terminate",
            cancelWpInetgration: "Do you want to cancel whatsapp integration?",
            terminatelIGIntegration: "When clicked the 'Unsubscribe' button, your instagram integration will terminate",
            cancelIGIntegration: "Do you want to cancel instagram integration?",
            startChatWp: "Start Chat",
            purchaseHeader: "Supsis-Whatsapp Integration Purchase",
            wpServices: "Whatsapp Service",
            wpServicesIntegrationCompleted: "Your whatsapp integration is completed. You can now use the service.",
            purchasePaymentDescription:
                "Whatsapp Feature billed month-to-month. Your whatsapp service will be activated after you accept subscription.",
            wpIntegrationFeatures: "Whatsapp Integration Features",
            saveChanges: "Save Changes",
            contactList: "Contact List",
            broadcast: {
                broadcast: "Broadcast",
                detail: "Broadcast Detail",
                customer: "Customer",
                phoneNumbers: "Contact Numbers",
                showMore: "Show More",
                groupName: "Group Name",
                messages: "Messages",
                status: "Status",
                usageCost: "Usage Cost",
                sendingTime: "Sending Time",
                progress: "Progress",
                groupDetail: "Group Detail",
                messagesPerContact: "Messages Per Contact",
                successRatio: "Success Ratio",
            },
            messages: "Messages",
            broadcastRequests: "Broadcast Requests",
            customerGroups: "Customer Groups",
            messageTemplates: "Message Templates",
            plans: "Plans",
            wpIntegrationRequired: "Whatsapp Integration Required",
            wpRequiredIntegrationDescription:
                "Sorry, the page you visited will be activated when integrate your whatsapp.",
            integrateWp: "Let's go, Integrate Whatsapp",
            active: "Active",
            archived: "Archived",
            createBroadcastMessage: "Create Broadcast Message",
            title: "Title",
            description: "Description",
            createdAt: "Created At",
            numbers: "Numbers",
            actions: "Actions",
            action: "Action",
            createCustomerGroup: "Create a custom customer group",
            search: "Search",
            name: "NAME",
            contacts: "Contacts",
            noContactFound: "No Contact Found",
            broadcastTitle: "Give a title your broadcast.",
            recipients: "Recipients",
            selectRecipients: "Select Recipients",
            writeYourMessage: "Write your message.",
            schedule: "Schedule",
            scheduleNowOrLater: "Schedule now or later",
            summary: "Summary",
            cancel: "Cancel",
            send: "Send",
            sending: "Sending",
            deleteCustomerGroup: "Are you sure delete this customer group? {name}",
            customerGroupDeleting: "Customer group deleting ...",
            customerGroupDeletingSuccess: "Customer group deleted successfully",
            customerGroupDeletingError: "Error while deleting customer group",
            wpPlusRequired: "Whatsapp Plus Plan Required.",
            broadcastMessageArchived: "Broadcast Message as archived",
            broadcastMessageNotArchived: "Broadcast Message is not archived",
            groupNameSearch: "Type Customer Group Name",
            groupNameDesc: "Customer group name identify your customer groups",
            save: "Save",
            number: "NUMBER",
            addColumn: "Add Column",
            addColumnDesc: "Add a column to table",
            addNewContact: "Add New Contact",
            addNewContactDesc: "Add a contact to table",
            importFile: "Import From File",
            importFileDesc: "Import contacts from excel or csv file",
            contactAdded: "Contact added",
            updateCustomerGroup: "Updating customer group...",
            updateCustomerGroupSuccess: "Customer group updated successfully",
            sendBroadcastMessage: "Send Broadcast Message",
            columnName: "Column Name",
            columnType: "Column Type",
            defaultValue: "Default Value",
            setDefaultValue: "Set the default value to exists  contacts",
            age: "Age",
            location: "Location",
            gender: "Gender",
            selectContactFile: "Select Contact File",
            selectContactCsvOrExcel: "Select a CSV or EXCEL file.",
            importConfiguration: "Import Configuration",
            customizeFile: "Customize your import configuration.",
            sendMessageTo: "Who do you want to send the message to?",
            allContact: "All Contact",
            messageTypes: "Message Types",
            whenSendMessage: "When do you want to send the message to?",
            instantlyRightNow: "Instantly Right Now",
            completed: "Completed",
            scheduleFuture: "Schedule for a future date",
            messageDesc: "Your message will be sent instantly to all the recipients",
            messageSendAt: "Your message will be sent to all the recipients at",
            estimatedPrice: "Estimated Price",
            estimatedTime: "Estimated Time",
            now: "Now",
            tenMinute: "10 Minute",
            cancelled: "Cancelled",
            failed: "Failed",
            running: "Running",
            queued: "Queued",
            scheduled: "Scheduled",
            noNumberAdded: "No Numbers Added",
            csvOrExcelFile: "CSV or Excel File",
            broadcastMessagesToContactFile: "Broadcast Messages to Contact List",
            broadcastMessageTemplates: "Broadcast Message Templates",
            messageFlow: "Message Flow",
            textMessageSupport: "Text Message Support",
            imageMessageSupport: "Image Message Support",
            spamPreventions: "Spam Preventions",
            includesAllBasicPlans: "Includes all in Basic Plan",
            chatbotIntegration: "Chatbot Integration",
            messageToNewNumbers: "Message to New Numbers",
            broadcastMessageToEveryone: "Broadcast Messages to Everyone",
            personalizedBroadcastMessage: "Personalized Broadcast Messages",
            customerGroupSegmentation: "Customer Group Segmentation",
            scheduleBroadcastMessage: "Schedule Broadcast Message",
            locationMessageSupport: "Location Message Support",
            advancedSpamPreventions: "Advanced Spam Preventions",
            whatsappPlans: "Whatsapp Plans",
            selectBestPlan: "Choose the plan that suits you",
            comingSoon: "Coming Soon...",
            selectFile: "Select a file",
            created: "Created",
            message: "Message",
        },
        ig: {
            instagram: "Instagram",
        },
        ticket: {
            instagramComments: "Instagram Comments",
            messengerComments: "Messenger Comments",
            trendyolComments: "Trendyol Comments",
            ticketSelection: "Ticket Selected",
            bulkClose: "Bulk Close",
            igComment: "Instagram Comment",
            igMentioned: "Instagram Mentioned",
            incomingReqChatbot: "Incoming Requests with Chatbot",
            incomingReqWebForm: "Incoming Requests with Web Form",
            incomingReqAutomation: "Incoming Requests with Automation",
            thisPersonEmailAnswered: "This person wants to be answered by email",
            thisPersonWpAnswered: "This person is waiting for an answer via WhatsApp.",
            clickStartWpChat: "Click to start WhatsApp chat",
            requestProgress: "Request Progress",
            requestMessage: "Request Message",
            clickAddMailAddress: "Click to add mail address",
            sendReplyCloseTicket: "Send Reply and Close Ticket",
            closeTicket: "Close Ticket",
            selectEmailSender: "Select Email Sender",
            withEmailWillNotRecievice:
                "You will not be able to receive replies to the mail when sending with this mail address!",
            deleteCommentAndClose: "Delete comment and close",
            sendReplyAndClose: "Send Reply and Close",
            startChatWp: "Start WhatsApp Chat",
            sureWantToDeleteTicket: "Are you sure you want to delete a ticket?",
            bulkDeleteConfirmation: "Bulk Delete Confirmation",
            selectedTicketSucsDelete: "Selected tickets were deleted successfully.",
            thereErrorDeletingTicket: "An error occurred while deleting tickets.",
            deleteConfirm: "Confirm Deletion",
            sureDeleteTicket: "Are you sure you want to delete this ticket?",
            ticketSucsDelete: "Ticket deleted successfully.",
            represantiveSucsAppoint: "The agent has been successfully assigned.",
            ticketClosedSucs: "Ticket closed successfully.",
            ticketCloureFailed: "Ticket closure failed.",
            unprocessed: "Unprocessed",
            pleaseSelectValidStatus: "Please select a valid status.",
            ticketStatusBeenUpdatd: "Ticket Status has been updated.",
            doYouWantCloseTicket: "Do you want to close the ticket?",
            ticketWillMarkedClosed: "Ticket will be marked as closed and archived.",
            errorUpdatingTicketFailed: "An error occurred while updating ticket status.",
            igCommentDeleteIgPost: "Instagram comment has been deleted from your IG post.",
            igCommentHideChange: "Instagram comment hide status has been changed.",
            pleaseChooseRepresent: "Please select a representative.",
            selectedTicketSucsDelegated: "Selected tickets were delegated successfully.",
            errorOccuredDuringDelegation: "An error occurred during the delegation process.",
            bulkTicketClosing: "Bulk Ticket Closing",
            sureWantCloseTicket: "Are you sure you want to close the ticket?",
            selectedTicketSucsClosed: "The selected tickets were closed successfully.",
            thereErrorClosingTicket: "An error occurred while closing tickets.",
            changeFilterTicketPage: "Change the filters on the Tickets page.",
            nameOfFilter: "Name of the filter.",
            filterValue: "Filter value",
            deletesSelectedTickets: "Deletes selected tickets",
            idTicketBeDelete: "The IDs of the tickets to be deleted (selected ticket IDs or all listed ticket IDs).",
            assignsAgentSelectedTickets: "Assigns an agent to the selected tickets",
            idTicketBeAssigned: "The IDs of the tickets to be assigned (selected ticket IDs or all listed ticket IDs)",
            idAgentAssigned: "ID of the agent to be assigned",
            changesStatusSelectedTicket: "Changes the status of selected tickets",
            idTicketWhoseStatus:
                "The IDs of the tickets whose status will be changed (selected ticket IDs or all listed ticket IDs)",
            newStatus: "New Status",
            selectedTicketsSucsUpdated: "The status of the selected tickets was updated successfully.",
            errorWhileChangingStatus: "An error occurred while changing the status of tickets.",
            thisPageVoiceAssistant: "This page has a voice assistant.",
            hello: "Hello!",
            voiceAssistantContent: `Did you know that there is an <strong>AI Assistant</strong> to help you on this page?
                You can try the following methods to use the assistant:`,
            commandHoldingDownTheKey: "You can give a command by holding down the key combination and speaking.",
            topRightContent: "top right corner",
            clickOnTheIcon: "You can launch the assistant by clicking on the icon.",
            sampleVoiceCommands: "Sample Voice Commands:",
            showMyTickets: "Show my tickets",
            showMeZeynepsOpenTicket: "Show Zeynep's open tickets today.",
            deleteTicketsScreen: "Delete tickets on the screen",
            assignLastTicketAli: "Assign the last ticket to Ali.",
            changeStatusAllTicket: "Change the status of all tickets to done.",
            setStatusTicketsScreen: "Set the status of tickets on the screen to .......",
            assignUserTicketScreen: "Assign the tickets on the screen to the user .....",
            assignFirstTicket: "Assign the first ticket to me.",
            showIgTickets: "Show last month's Instagram tickets.",
            makeChoice: "Make selection",
            makeAssignment: "Make assignment",
            tickets: "Tickets",
            instagramTickets: "Instagram Tickets",
            facebookTickets: "Facebook Tickets",
            trendyolTickets: "Trendyol Tickets",
            automationTickets: "Automation Tickets",
            supsisFormTickets: "Supsis Form Tickets",
            columnSettings: "Column Settings",
            ticketField: "Ticket Field",
            contactPropertyFields: "Contact Property Fields",
            ticketFilterList: {
                archivedRequests: "Archived Requests",
                comingFromFacebook: "Coming from Facebook",
                comingFromInstagram: "Coming from Instagram",
                unassignedOpenRequests: "Unassigned Open Requests",
                openRequests: "Open Requests",
                requestsOpenedThisWeek: "Requests Opened This Week",
                specialList: "Special List",
                creationDate: "Creation Date",
                supsisFromTheForm: "Supsis From The Form",
                fromTrendyol: "From Trendyol",
                comesWithAutomation: "Comes With Automations",
                label: "Label",
                status: "Status",
                subject: "Subject",
                email: "Email",
                name: "Name",
                phone: "Phone",
                type: "Type",
                assignedUser: "Assigned User",
            },
            appointingRepresentative: "Appoint a representative",
            ticketTagFilter: "Ticket Filter Tag",
            ticketEmails: "Ticket Forwarding Email List",
            save: "Save",
            delete: "Delete",
            transactions: "Options",
            noEmailTicketNotifications: "There is no data",
            emailIsNotValid: "Email is not valid",
            emailNotificationDeleted: "Item deleted successfully",
            emailNotificationDeleteError: "An error occurred",
            tagFilterRequired: "Ticket Filter Tag Required, Use *(wildcard) tag for all tickets",
            emailsRequired: "Forwarding Emails must not be null",
            emailNotificationCreated: "Ticket Forwading Rule Created",
            emailNotificationCreateError: "An error occurred",
            ticketForwarding: "Ticket Email Forwarding",
            ticketTagFilterDesc:
                "It uses the ticket topics you used in the chatbot design to filter the tickets. You can write a different tag and press enter to add it. If you select the '*' tag it will select all tickets",
            ticketEmailsDesc:
                "Email list to which tickets will be forwarded. You can add the addresses of the representatives in the system by selecting them. You can also add non-system email/s.",
            ticketList: "Ticket Forwarding Rules",
            ticketTagFilterPlaceHolder: "Ticket filter, select '*' for all",
            ticketEmailsPlaceHolder: "Forwarding email list",
        },
        theme: {
            opacity: "Opacity",
            headerColor1: "Hader Section Color 1",
            headerColor1A: "Hader Section Opacity 1",
            headerColor2: "Header Section Color 2",
            headerColor2A: "Header Section Opacity 2",
            backgroundColor: "Background Color 1",
            backgroundColorA: "Background Opacity 1",
            backgroundColor2: "Background Color 2",
            backgroundColor2A: "Background Opacity 2",
            textColor: "Text Color",
            errorTheme: "Error Color",
            bubbleBackground: "Representative bubble color",
            bubbleVisitorBackground: "Customer bubble color",
            bubbleBackgroundA: "Representative bubble opacity",
            bubbleVisitorBackgroundA: "Customer bubble opacity",
            bubbleText: "Representative text color",
            bubbleVisitorText: "Customer text color",
            textFormColor: "Form color",
            selectCustom: "Select Custom Theme",
            headerColorSecond: "Header Top Color",
            headerColorFirst: "Title Bottom Color",
            backgroundColorFirst: "Background Top Color",
            formColor: "Form Text Color",
            buttonColor: "Button Color",
            backgroundColorSecond: "Background Bottom Color",
            chatBotButtonText: "Chatbot Font Color",
            chatBotButtonColor: "Chatbot Button Color",
        },
        billing: {
            billingContactInfo: "Billing contact information updated successfully.",
            defaultRootEmail: "Default: Basic email",
            invoiceEmailAddress: "Invoice Email Address",
            invoiceSettings: "Invoice Settings",
            popular: "Popular",
            selectedPlan: "Selected Plan",
            editPlan: "Edit Plan",
            removePlan: "Remove Plan",
            showPlan: "Show Plan",
            hiddenPlan: "Hide Plan",
            contactSales: "Contact Sales",
            showLess: "Show less",
            more: "More",
            selectTransactionType: "Select transaction type",
            walletLogs: "Wallet Logs",
            addBalance: "Add Balance",
            availableBalance: "Available Balance",
            appsumoPack: "Appsumo Package",
            updatePlan: "Update Plan",
            createPlan: "Create Plan",
            freePack: "Free Package",
            instantFee: "Instant Fee Will Be Charged",
            planSequence: "Plan Sequence",
            requiredCodes: "Number of Codes Required",
            subHeading: "Sub Heading",
            featureKey: "Feature Key",
            customerKey: "Customer Key",
            monthlyPrice: "Monthly Price",
            monthlyNonDiscounted: "Monthly Non-Discounted Price (Non-functional Display)",
            twoYearDiscount: "2 Year Discount",
            yearDisccount: "Annual Discount",
            sixMonthDiscount: "6 Month",
            threeMonthDiscount: "3 Month",
            features: "Properties",
            sessionCount: "Session Count",
            subType: "Subscription Type",
            skipTrialVersion: "Skip Trial Version",
            skipTrialVersionDesc:
                "You can skip the trial version and continue by selecting the appropriate package for your business. If you skip the trial version, this action cannot be undone.",
            skipStep: "Skip This Step",
            switchToPay: "Switch to Pay",
            forward: "Forward",
            pleaseFillInCard: "Please fill in the card information!",
            fillInTheBillingAddress: "Please fill in the billing address information!",
            cardNumberWrong: "Card Number is Wrong!",
            pleaseConfirmTheUser: "Please confirm the user agreement.",
            pleaseCheckYourCard: "Please check your card and information.",
            site: "Site",
            period: "Period",
            billStatus: "Bill Status",
            totalPrice: "Total Price + VAT",
            depotMoneyWallet: "Deposit to Wallet",
            threeMonthly: "3 Monthly",
            sixMonthly: "6 Monthly",
            twoYearly: "2 Years",
            forever: "Forever",
            extraPackage: "Extra Package",
            teamPackage: "Team Packages",
            adventPackage: "Advantageous Packages",
            cupponError: "The coupon code is incorrect or expired.",
            enterYourCard: "Please enter your Credit Card",
            invalidCard: "Invalid credit card, Payment Not Received",
            calculateThis: "Calculate for:",
            adventageousPackage: "Advantageous package discounts!",

            cupponApplied: "Coupon successfully applied",
            subStart: "Subscription Started",
            subSuccessStart: "Your subscription has started successfully.",
            success: "Successful",
            succesDesc: "Successfully created subscription.",
            successDesc: "Your feature has been successfully activated.",
            maxNumber: "Maximun number of representatives to speak",
            currentAmountDetails: "Dettagli dell'importo attuale",
            endOfMonthForecastDetails: "Dettagli della previsione di fine mese",
            totalAmount: "Total Amount",
            vatAmount: "VAT Amount (20%)",
            totalAmountIncludingVAT: "Total Amount Including VAT",
            hideDetails: "Hide Details",
            createInvoice: "Create Invoice",
            reimbursementMade: "Reimbursement Made",
            invalidInvoice: "Invalid Invoice",
            balanceTopUp: "Whatsapp Balance Deposit",
            paidSuccesfully: "The invoice was paid successfully.",

            paymentFailed: "The invoice payment process failed.",
            areYouSurePaid: "Are you sure you want to make this invoice marked as paid?",
            invoiceMarkedPaid: "The invoice has been marked as paid.",
            invoiceMarkedFailed: "An error occurred and the invoice could not be marked as paid.",
            areYouSoreRefundInvoice: "Are you sure you want to process a refund for this invoice?",
            youMustFillInEmpty: "You must fill in all blank spaces.",
            createdNewInvoice: "New Invoice was created successfully.",
            createdNewInvoiceFailed: "An error occurred while creating the invoice.",
            invoiceUpdated: "The invoice amount was updated successfully...",
            invoiceUpdatedFailed: "There was a problem updating the invoice.",
            plans: "Plans",
            companyName: "Company Name",
            compony: "Company",
            person: "Person",
            invoiceAddressInfo: "Invoice Address Information",
            idNo: "Turkish ID",
            taxOffice: "Tax Office",
            taxNumber: "Tax Number",
            packageCanNotDownSupsis:
                "Your package cannot be downgraded. Please delete or deactivate several of your Agents to downgrade your package.",
            packageCanNotDownWp:
                "Your package cannot be downgraded. Please delete a few of your Whatsapp Channels to downgrade your package.",
            packageCanNotDownWPBussiness:
                "Your package cannot be downgraded. Please delete a few of your Whatsapp Business Channels to downgrade your package.",
            chooseYourPlan: "Choose Plan",
            numberOfRepresentatives: "Number of Representatives",
            numberOfChannels: "Number of Channels",
            wpNumberOfChannels: "Number of Whatsapp Channels",
            igNumberOfChannels: "Number of Instagram Channels",
            msNumberOfChannels: "Number of Messenger Channels",
            cancelIt: "Cancel it",
            activePlan: "Active Plan",
            activate: "Activate",
            noTransition: "No Transition",
            daysLater: "Days Latter",
            payBack: "Pay Back",
            paid: "Paid",
            unPaid: "Unpaid",
            editPrice: "Edit Price",
            payNow: "Pay Now",
            youAreCurrentlyOnTrial: "You are currently on trial. You can skip the trial now to see exclusive packages.",
            youAreCurrentlyLimited: "You are currently limited by the system because your packages are unconditional.",
            youHaveOneRepresentative: "You have one representative.",
            deactivateOrDeleteYourPiece: "Deactivate or delete your Piece Representative or buy a representative.",
            youHaveOneWhatsappQRChannel: "You have one Whatsapp QR channel.",
            deleteYourWhatsAppQR: "Delete your Whatsapp QR channel or buy a channel.",
            youHaveAWhatsappBusiness: "You have one Whatsapp Business channel.",
            deleteYourWhatsapp: "Delete your Whatsapp Business channel or buy a channel.",
            youHaveAnInstagram: "You have an Instagram channel.",
            deleteYourInstagram: "Delete your Instagram channel or buy a channel.",
            youHaveAMessenger: "You have one Messenger channel.",
            deleteYourMessenger: "Delete your Messenger channel or purchase a channel.",
            additionalPackages: "Additional Packages",
            availablePackages: "Available Packages",
            buyNow: "Buy Now",
            invoiceInformation: "Invoice Information",
            invoiceAddress: "Invoice Address",
            invoiceType: "Invoice Type",
            review: "Review",
            viewDetails: "View Details",
            addNewAddress: "Add New Address",
            enterYourBillingAddress: "Enter Your Billing Address",
            selectPlan: "Select Plan",
            paymentStatus: "Payment Status",
            amount: "Amount",
            invoiceID: "Invoice ID",
            expected: "Expected..",
            currentAmount: "Current Amount",
            monthlyEstimatedAmount: "Monthly Estimated Amount",
            creationDate: "Creation Date",
            invoiceStatus: "Invoice Status",
            invoicePeriod: "Invoice Period",
            newPaymentMethod: "New Payment Method",
            channelCount: "Channel Count",
            remainingTime: "Remaining Time",
            chatbotLimit: "Chatbot Limit",
            free: "Free",
            maxChatbotSession: "Maximum Chatbot Sessions",
            buyIt: "Buy It",
            renewalDate: "Renewal Date",
            monthly: "Monthly",
            yearly: "Yearly",
            packagePeriod: "Package Period",
            packageType: "Package Type",
            packageManagement: "Package Management",
            invoiceManagement: "Invoice Management",
            futureInvoice: "Future Invoice",
            pastInvoices: "Past Invoices",
            creditCard: "Credit card",
            invoice: "Invoice",
            mustBeUpgradePlanForChatBot: "To activate the ChatBot feature, you must switch to the Pro Plan!",
            incorrect: "Incorrect",
            cardInfo: "Card Info",
            billingDetails: "Billing Details",
            firstPreferredCard: "Set as Primary Card",
            primary: "Primary",
            addCardIyzico:
                "You do not have a registered card. In order to pay your monthly usage fees, you need to add a card. The payment system is provided by iyzico.",
            billingPlanSettings: "Billing & Invoice",
            startWith: "{cardFamily} card starts with {binNumber}",
            paymentMethod: "Payment Method",
            billingDate: "Billing Date",
            isPaid: "Is Paid?",
            billingHistory: "Invoice History",
            markPaid: "Mark as Paid",
            paymentDate: "Payment Date",
            pay: "Pay",
            newInvoice: "Create Invoice",
            updateBilling: "Update Billing Detail",
            updateCard: "Change Credit Card",
            paymentBilling: "Payment Method & Billing Details",
            price: "Price",
            billingAddress: "Billing Address",
            billingCity: "City",
            billingCountry: "Country",
            contactName: "Billing Contact Name",
            expireMonth: "Expire Month",
            expireYear: "Expire Year",
            cardNumber: "Card Number",
            cardHolderName: "Card Holder Name",
            cardAlias: "Card Alias",
            identityNumber: "Identity Number",
            name: "Name",
            surname: "Surname",
            email: "Email",
            addCard: "Add Card",
            update: "Update",
            cancel: "Cancel",
            save: "Save",
            saving: "Saving",
            noInvoiceFound: "There is no invoice",
            year: "Year",
            updating: "Updating...",
            newInvoiceForm: "New Invoice Create Form",
            error: "Error",
            transactions: "Options",
            paymentMethodAdded: "Payment method has successfully added",
            paymentMethodAddError: "Payment method has not added, An error occurred",
            creditCardChanged: "Credit card has successfully changed ",
            errorOccurred: "An error occurred , try again",
            billingDetailUpdated: "Billing detail has successfully updated",
            invoiceCreated: "Invoice has successfully created",
            paymentSuccess: "Payment successfully , thank you",
            paymentFail: "Payment fail, try again",
            billingAddressChanged: "Billing address has successfully changed ",
            hidePlan: "Hide Plan",
            informationShopping:
                "Your payment information, billing information, credit card information are controlled by Shopify.",
            trialTimeInformation:
                "Trial ends {dayCount} days after. If you do not enter a payment method until the expiry of this period, you will be automatically switched to the FREE PLAN by the system.",
            trialTimeInformationShort: "Trial: Last {dayCount} Day",
            currentPlanLabel: "Current Plan: {planName} ({agentCount} Agent)",
            changeCancelPlan: "Change/Cancel Plan",
            oneAgent: "Agent",
            agent: "Agent",
            yourCurrentPlan: "Current Plan",
            month: "Month",
            billedMonthToMonth: "(billed month-to-month)",
            selectAgentCount: "Select Agent Count",
            selectFreePlan: "Select Free Plan",
            planDetails: "Plan Details",
            multiAgent: "(Multi Agent)",
            selectProPlan: "Select Pro Plan",
            foreverFree: "Forever Free",
            websiteIntegration: "Website Integration",
            websiteIntegrationUnlimited: "Website Integration",
            ChatBotUnlimited: "ChatBot",
            videoCallUnlimited: "Video Call",
            multiAgentUpTo: "Multi Agent (up to {agentCount} Agent)",
            audioCallUnlimited: "Audio Call",
            screenSharingUnlimited: "Screen Sharing",
            fileTransferUnlimited: "File Transfer",
            autoChatAssignerUnlimited: "Auto Chat Assigner",
            multiLanguageTranslationUnlimited: "Auto Translate",
            detailedReporting: "Reporting",
            days30TrialsAvailable: "30-days trials available",
            limitedArchiveLookupLastMo: "Limited Archive Lookup (Last {monthCount}-mo)",
            fullCustomizationUnlimited: "Customization",
            planUpdated: "Great, your plan is updated.",
            planUpdating: "Your Plan is Updating...",
            planUpdatingDescription: "Please wait during your plan updating",
            done: "Done",
            freePlanUpdated: "Your plan updated as a Free Plan. (Max Agent Credit: 1)",
            proPlanUpdated: "Your plan updated as a PRO Plan. (Max Agent Credit: {agentCount})",
            canNotDwnGrade:
                "Cannot downgrade your plan from PRO {agentCountFirst} Agent(s) to {valNewPlnToUppr} {agentCountSecond}. Your agent credits in use.  ",
            deleteWarning: "You must delete or disable {valDif} Agent(s)",
            warnMessage: "Selected plan must be different than current plan",
            add: "Add",
            cancelYourPlan: "Cancel Your Plan",
            upgradeYourPlan: "Upgrade Your Plan",
            downgradeYourPlan: "Downgrade Your Plan",
            agree: "AGREE",
            disagree: "DISAGREE",
            invoices: "Invoices",
            priceIntervals: "Price Interval",
            selectSiteAlias: "Select or Enter Site Name",
            selectPriceInterval: "Select or Enter Price Interval",
            isRefunded: "Is Refunded?",
            invoiceId: "Invoice No",
            siteId: "Site No",
            createdDate: "Created Date",
            failCount: "Number of Failed Payment Fetch Attempts",
            failDate: "Failed Payment Date",
            Dashboard: "Dashboard",
            Agents: "Agents",
            Integration: "Integration",
            Settings: "Settings",
            Contacts: "Contacts",
            Domain: "Domain",
            lastActivity: "Last Activity",
            basePrice: "Base Price",
            packagePrice: "Package Price",
            whatsappPrice: "Whatsapp Price",
            realtimeVisitorCount: "Real Time Visitor",
            suspend: "Suspend",
            partner: "Partner",
            plan: "Plan",
            trialDay: "Trial Days",
            mobile: "Mobile",
            webSite: "Web Site",
            websiteOrigins: "Web Site Origin",
            ownerName: "Owner Name",
            ownerEmailAddress: "Owner Email",
            discount: "Discount",
            daysLeft: "Days Left",
            newTrialPopUp: "How Many Days Should the New Trial Period Be?",
            newWpPricePopUp: "How Much Is The New Whatsapp Fee?",
            newIGPricePopUp: "How Much Is The New Instagram Fee?",
            newBasePricePopUp: "How Much Is The New Base Price?",
            siteInfoUpdated: "Site Information Updated",
            siteInfoNotUpdated: "Site Information Not Updated",
            siteInfoNotUpdatedErr: "Error Occured! Site Information Not Updated.",
        },
        tour: {
            closeChat: "Close Chat",
            ticket: "Ticket",
            formStep: "Form Step",
            menuStep: "Menu Step",
            contentStep: "Content Step",
            menuTitle: "Menu Title",
            messageContent: "Message Content",
            goToLive: "Connect Representative",
            stats: "STATISTICS PANEL",
            settings: "SETTINGS",
            status: "STATUS",
            prevStep: "Previous Step",
            nextStep: "Next Step",
            finish: "Finish",
            skip: "Skip",
            skip2: "Skip, I know system",
            startTour: "Start Tour",
            firstTimeIntro:
                "You are entering the system for the first time, I want to introduce the application if you allow",
            hi: "Hi",
            welcomeTo: "Welcome to Supsis Live Support",
            statsPanel:
                "It is the status bar showing the total and active chat numbers that are waiting instantly with the system..",
            sidebarMenu: "MENU",
            sidebarMenuContent: "You can switch between pages here.",
            representativePrivateMessage: "INTER-REPRESENTATIVE CHAT PANEL",
            representativePrivateMessageContent: "You can see private chats between agents here.",
            helpMenu: "HELP MENU",
            helpMenuContent: "You can find help information about the system here..",
            settingsMenu: "SETTINGS MENU",
            settingsMenuContent: "You can do the language, night mode and screen magnification steps here..",
            startChat: "Start Chat",
            profileMenu: "PROFILE MENU",
            profileMenuContent: "You can change your availability and set your agent settings here..",
            visitorsTab: "Visitors",
            visitorsTabContent: "You can see visitors here.",
            visitorTabHistory: "Visitor History",
            visitorTabHistoryContent: "You can see the visitor history here.",
            representativeTab: "Representatives",
            representativeTabContent: "You can see the representatives here.",
            liveSupport: "Live support",
            liveSupportContent: "You can see the number of customers receiving Live Support here..",
            siteVisitors: "Site Visitors",
            siteVisitorsContent: "You can see the number of site visitors here.",
            tableSettings: "Table Settings",
            tableSettingsContent: "You can show or hide columns in the table here.",
            watchModeButton: "Viewer Button",
            watchModeContent: "You can join here as a viewer mode and you can only view what is posted.",
            popoverInfo: "Visitor Details",
            popoverInfoContent: "It gives information about the visitor.",
            popoverButton: "Advanced Chat Settings",
            popoverButtonContent:
                "You can open the chat, send a message directly to the representative or block the visitor.",
            openChat: "Join Chat Button",
            openChatContent: "You can open the chat here",
            pagination: "Paging Menu.",
            paginationContent: "You can increase the number of pages here.",
            changeLang: "Can change system language",
            changeTheme: "Can switch dark and light theme",
            changeStatus: "Can change your availability status",
            logout: "Can logout system from here",
            chatwindow: {
                chatWindowActionButtons: "CHAT WINDOW ACTION BUTTONS",
                chatPanelActions: "CHAT PANEL ACTIONS",
                otherPanels: "OTHER PANELS",
                chatColorButton: "Show meaning of chat bar colors",
                keyboardShortcutButton: "Show keybpard shortcuts functions",
                hideButton: "Minimize current chat without exit",
                closeButton: "Force close and exit from current chat",
                ellipsisButton:
                    "More actions of chat. Minimize,close, Ban Visitor , Send Private Message , Assign Representative",
                userInfoWidget: "Show detail of owner visitor of current chat user",
                preparedContentWidget:
                    "Prepared Message Templates Widget, can select fastly insert a message template to current chat ",
                chatHistoryWidget: "If there are  some chat history of current visitor , can view them",
                chatWindowSettingsButtons: "TALK WINDOW SETTINGS BUTTON",
                settingsButton: "You can block chat, forward, confidential message and assign delegates.",
                chatBarButton:
                    "Here you can block active chat, send a private message to the agent and leave the chat..",
            },
        },
        adminUser: {
            newAdminUserForm: "New Admin User Register Form",
            updateAdminUserForm: "Admin User Update Form",
            adminUsers: "Admin Users",
            newAdminUser: "New Admin User",
            noAdminUser: "No Admin Users Yet",
            adminUserName: "Admin User Name",
        },
        report: {
            incomingMessages: "Incoming Messages",
            outgoingMessages: "Outgoing Messages",
            customerCount: "Customer Count",
            mailCount: "Mail Count",
            answered: "Answered",
            unanswered: "Unanswered",
            selectaChannel: "Select a Channel",
            sentMails: "Sent Mails",
            sentMailCount: "Sent Mail Count",
            ticketDistribution: "Ticket Distribution",
            selectWorkflow: "Select Your Workflow",
            distributionOfTasks: "Distribution of Tasks",
            mostMissioned: "Most Missioned",
            leastTasked: "Least Tasked",
            totalNumberTasks: "Total Number of Tasks",
            errorFetchingTask: "Error receiving task data:",
            pipelinePhase: "Pipeline Phase",
            status: "Status",
            numberOfTasks: "Number of Tasks",
            insufficientData: "Not Enough Data",
            hourly: "(Hourly)",
            hourlyAverage: "Hourly Average",
            hourlyMax: "Hourly Maximum",
            hourlyMin: "Hourly Minimum",
            totalAmount: "Total Amount",
            averageAmount: "Average Amount",
            minAmount: "Minimum Amount",
            maxAmount: "Maximum Amount",
            siteCount: "site Count",
            agentCount: "Agent Count",
            channelsTimeSeries: "Channels Time Series",
            channelPies: "Channel Pies",
            pieView: "Pie Chart",
            topVisitorCountry: "Top Visitor Country",
            websiteTrafficByCountry: "Website Traffic by Country",
            visitorCount: "Visitor Count",
            websiteVisitorTraffic: "Website Visitor Traffic",
            websiteTraffic: "Website Traffic",
            author: "Author",
            topWorstComments: "Top Worst Comments",
            topBestComments: "Top Best Comments",
            topComments: "Top Comments",
            noComment: "No Comments Yet",
            minWaitingTime: "Minimum Waiting Time",
            maxWaitingTime: "Maximum Waiting Time",
            averageWaitTime: "Average Waiting Time",
            waitTime: "Bekleme Süresi (Saniye)",
            agentWaitDurationTitle: "Agent Wait Duration TimeSeries",
            incomingMessage: "Incoming Message(s)",
            outgoingMessage: "Outgoing Message(s)",
            totalSpent: "Total Spent",
            avgSpent: "Average Spent",
            totalPayment: "Total Payment",
            walletStatus: "Wallet Status",
            walletBalanceStatus: "Wallet Balance Status",
            messageTraffic: "Message Traffic",
            breakCount: "Break Count",
            agentBreakTime: "Agent's Break Counts ☕",
            agentWorkTimeCalendar: "Agent Work Time Calendar",
            agentStatusHour: "Agent's Statusses (In Hour Unit)",
            agentActivity: "Agent Activity",
            noEnoughtData: "Not Enough Data",
            averageFirstResponse: "Average First Response Time",
            slowestResponser: "Slowest Responder",
            fastestResponder: "Fastest Responder",
            firstAnswerTimeSec: "First Message Time (in Seconds)",
            firstAnswerByAgent: "First Message Time by Agent",
            averageSolutionTime: "Average Solution Time",
            slowestSolver: "Slowest Solver",
            fastestSolver: "Fastest Solver",
            averageChat: "Average Chat",
            leastChatReceiver: "Least Chat Receiver",
            mostChatRecipients: "Most Chat Recipients",
            averageTicket: "Average Ticket",
            leastTicketReceiver: "Least Ticket Least",
            mostTicketRecipients: "Most Ticket Recipients",
            resolveTime: "Resolution Time (min)",
            resolveTimeByUser: "Chat Resolution Time by User (in minutes)",
            chatResolveTimeByAgent: "Chat Resolution Time by Agents",
            chatDistByHandleType: "Chat Distribution by Handler",
            chatDistByHandDesc: "How many chats were handled by agents, chatbots, and hybrid?",
            chatCountsByHandleType: "Chat Counts by Handle Type",
            missed: "Missed",
            chatDistByAnsDesc: "How many chats were answered or missed?",
            chatCountsByAns: "Chat Counts by Answer",
            chatCountByPlatform: "Chat Counts by Platform",
            chatDistByPDesc: "How many chats came to which platform?",
            chatDistByPlatform: "Chat Distribution by Platform",
            ticketCountByUser: "Ticket Counts by Agents",
            ticketCountByStatus: "Ticket Counts by Response Status",
            user: "User",
            saveAsImage: "Save as Image",
            fullScreen: "Full Screen",
            download: "Download",
            tableView: "Table View",
            chartView: "Chart View",
            chatDistByUsers: "Chat Distribution by Agents",
            chatCountsByUsers: "Chat Counts by Agents",
            minDuration: "Minimum Duration",
            maxDuration: "Maximum Duration",
            totalDurationByAgent: "Total Session Duration by Agent",
            averageDurationByAgent: "Average Session Duration by Agent",
            totalDurationByCB: "Total Session Duration by Chatbot",
            averageDurationByCB: "Average Session Duration by Chatbot",
            viewUnitAs: "View Unit As",
            hybrid: "Hybrid",
            handledBy: "Handled By",
            sessionDurationOverall: "Overall Session Duration",
            allChannels: "All Channels",
            sessionsDurationOverall: "Overall Session Durations",
            sessionsOverall: "Overall Sessions",
            calendarEvents: "Calendar Events",
            reservationEvents: "Reservation Events",
            incomingMails: "Incoming Mails",
            incomingMailCount: "Incoming Mail Count",
            reservation: "Reservation",
            event: "Event",
            reservationEventCount: "Reservation Event Count",
            eventCount: "Event Counts",
            channelBreakdown: "Channel Breakdown",
            websiteAnalysis: "Website Analysis",
            customerSatisfaction: "Customer Satisfaction",
            teamBreakAnalysis: "Team Work / Break Analysis",
            dailyAgentActivity: "Daily Agent Activity",
            agentPerformance: "Agent Performance",
            chatDistributions: "Chat Distributions",
            contactDistributions: "Contact Distributions",
            users: "Users",
            segmentTimeseries: "Segment Time Series",
            segmentsOverall: "Segments Overall",
            unmatchRatio: "Unmatch Ratio",
            totalMatchCount: "Total Match Count",
            totalUnmatchCount: "Total Unmatch Count",
            matchRatio: "Match Ratio",
            matched: "Matched",
            trainingOverall: "Training Overall",
            trainingStatusTimeseries: "Training Status Time Series",
            duration: "Duration",
            totalSessionDuration: "Total Session Duration",
            averageSessionDuration: "Average Session Duration",
            second: "Second",
            minute: "Minute",
            hour: "Hour",
            aggregateAs: "Aggregate as",
            chatbotSessionDurationOverall: " Overall Chatbot Session Duration",
            ratingTimeSeries: "Rating Time Series",
            chatCountTimeseries: "Chat Count Time Series",
            notRated: "Not Rated",
            totalRatingCount: "Total Rating Count",
            averageRating: "Average Rating",
            weightedAverageRating: "Weighted Average Rating",
            rate: "Rateing",
            ratingOverall: "Customer Ratings Overall",
            session: "Session",
            total: "Total",
            average: "Average",
            max: "Maximum",
            min: "Minimum",
            sessionCount: "Session Count",
            uniqueUsers: "Unique Users",
            viewAs: "View as:",
            overall: "Overall",
            detailReport: "Detailed Report",
            dailyReports: "Daily Reports",
            pointBasedReports: "Point Based Reports",
            personDateBasedPointReport: "Person and Date Based Point Report",
            personDateBasedReport: "Person and Date Based Report",
            personBasedReport: "Person Based Reports",
            personAndDateBasedGraph: "Person and Date Based Graph",
            noReport: "No Report",
            reports: "Reports",
            totalBar: "Total",
            ticketCount: "Ticket Count",
        },
        stats: {
            total: "Number of  all  open chats",
            active: "Number of   assigned active chats to you",
            waiting: "Number of visitors waiting for a representative to enter",
            late: "Number of visitors waiting more than a certain period",
            free: "Number of free visitors waiting for the new representative to enter",
            pco: "[Capacity Utilization Rate] Rate of work load of active representative chat capacity",
            maxCapacity: "Maximum number of chat that the system can assign representatives without waiting",
            chatbot: `Number of active chat with chatbot`,
        },
        time: {
            lastYear: "Last Year",
            thisYear: "This Year",
            last3Months: "Last 3 Months",
            last7: "Last 7 Days",
            today: "Today",
            yesterday: "Yesterday",
            lastWeek: "Last Week",
            currentWeek: "This Week",
            currentMonth: "This Month",
            lastMonth: "Last Month",
            last30Day: "Last 30-day",
            allTime: "All Times",
            custom: "Custom Date",
        },
        fastWizard: {
            generalColors: "General Colors",
            tellUsMore: "Tell us more , so we can personalize your experience",
            moreInfo: "More Info",
            display: "Display",
            availability: "Availability",
            preview: "Preview",
            installCode: "Install Code",
            previous: "Previous",
            setupSupsisLiveChat: "Setup SUPSIS LIVE Chat ",
            continue: "Next Step",
            completeInitialize: "Complete Setup",
            completedMessage: "SUPSIS Live Chat Setup Successfully  Completed.",

            websiteIntegration: "Your website address to integrate supsis live chat",

            customizeLiveChat: "Customize Your Live Chat",
            createBrandedExperience: "Create a branded chat experience for your visitors.",
            chatColor: "Chat Color",
            chooseChatColor: "Choose an accent color.",
            chatBubble: "Chat Bubble",
            selectBubble: "Select a chat bubble",
            chatBubbleColor: "Chat Bubble Color",
            selectChatBubbleColor: "Select a chat bubble color",
            customSelection: "Custom Selection:",

            chatAvailability: "Chat Availability",
            onlineSupportVisitorTime: "When are you online to support your visitors?",
            channelAvailability: "Channel Availability",
            availability724: "Chat is available 7/24",
            basedOnTeam: "Based on Team Member Status",
            basedOnTeamExplanation: "Chat will appear online when at least 1 member is set to available",
            customHours: "Custom Business Hours",
            customHoursExplanation: "Configure your business hours",
            customHoursTimezone: "Timezone:",
            customHoursFrom: "From:",
            customHoursTo: "To:",
            customHoursAddHours: "+Add Hours",

            previewDesktop: "Desktop",
            previewIpad: "Ipad",

            installationAndInstructions: "Installation & Instructions",
            installationTrackingCode: "Install the tracking code on your website",

            installationTrackingCodePlease:
                "Please paste the code in accordance with the instructions below, just before the end of the {bodyTag} tag on any page where you want to enable SUPSIS Live chat.",
            installationInstructionsJavascript:
                " Paste the integration code given above in the {bodyTag} tag just before the closing.",
            installationInstructionsCopy: "Copy",
            installationInstructionsCoppyMessage: "Integration script copied to clipboard",
            installationInstructionsShopify1: "1. Login to your Shopify panel",
            installationInstructionsShopify2:
                "2. Go to Online Store > Themes > Actions drop-down menu under Current Theme > Edit code > theme.liquid",
            installationInstructionsShopify3:
                "3. Place paste the integration code given above just before the  {bodyTag}  tag at the end of the theme.liquid script.",
            installationInstructionsIdeaSoft1: "1. Login to your dealer panel.",
            installationInstructionsIdeaSoft2: "2. Go to Settings -> SEO -> Search Engine Services.",
            installationInstructionsIdeaSoft3:
                '3. Select "Site Verification with Meta Tag" from the Tracking Code section.',
            installationInstructionsIdeaSoft4:
                "4. Copy and paste the integration code above into the opened box and save.",
            installationInstructionsIdeaSoft5:
                '5. Inside Settings -> Optimizations click to "Clear Cache" button. Thus integration is completed.',
            installationInstructionsWordPress1: "1. Login to your WordPress admin panel",
            installationInstructionsWordPress2: "2. Go to Appearance > Theme Editor",
            installationInstructionsWordPress3:
                "3. Under Theme Files (far right), find the Theme Footer (footer.php) and select it",
            installationInstructionsWordPress4:
                "4.Paste the integration code above before the {bodyTag} tag at the bottom.",
            installationInstructionsWordPress5: "5. Click Update File to save changes",
            installationInstructionsOpenCart1: "1. Login to your Opencart admin panel",
            installationInstructionsOpenCart2: "2. Go to Design > Theme Editor",
            installationInstructionsOpenCart3: "3. Select 'common' folder and open 'header.twig' file.",
            installationInstructionsOpenCart4:
                "4.Paste the integration code above before the {headTag} tag at the bottom.",
            installationInstructionsOpenCart5: "5. Click save button.",
            installationInstructionsTicimax1: "1. Login to your Ticimax administration panel",
            installationInstructionsTicimax2: "2. Open Design > Design > Header Footer Design settings",
            installationInstructionsTicimax3: "3. Click the 'Source' button in the logo design section.",
            installationInstructionsTicimax4: "4. Paste the integration code above below the HTML code.",
            installationInstructionsEticaretteyim1: "1. Login to your Eticaretteyim administration panel",
            installationInstructionsEticaretteyim2:
                "2. Just Name SUPSIS from Plugins > Generate HTML > and Copy the Code.",
            installationInstructions: "Instructions",
            installationVerify: "Verify Your Website Installation of Supsis",
            installationVerifyChecking: "Checking",
            installationVerifyCheck: "Check",
            installationVerifyCheckingStatus: "Checking SUPSIS integration status on {website}",
            installationCheckingStatusMessageYes: "Great, SUPSIS is integrated to {website} website !!",
            installationCheckingStatusMessageNo:
                "SUPSIS is not currently integrated with {website} website. You can complete your integration process now or later.",

            vtippyPreferredLanguage: "Preferred Language",
        },
        akinon: {
            typeOrSelectSKU: "Type or select SKU",
            akinonUserId: "Akinon User Id",
            userEmail: "User Email",
            userEmailDesc: "Type or select user email...",
            send: "Send",
            selectCity: "Select City",
            city: "City",
            selectState: "Select State",
            state: "State",
            useMap: "Use Map",
            chooseAddress: "Choose Address",
            selectCountry: "Select Country",
            country: "Country",
            productIdDesc: "Type or select product...",
            productId: "Product Id",
            userIdDesc: "Type Akinon user id...",
            productSKU: "Product SKU",
            latitudeDesc: "Type or select target location latitude...",
            longitudeDesc: "Type or select target location longitude...",
            orderNumber: "Your order number",
            orderDesc: "Type order number...",
            longitude: "Longitude",
            latitude: "Latitude",
        },
        headBar: {
            source: "Source",
            label: "Label",
            completed: "Completed?",
            Email: "E-mail",
            phone: "Phone",
            name: "Name",
            date: "Date",
            subject: "Subject",
            situation: "Situation",
            representative: "Representative",
            transactions: "Transactions",
        },
        login: {
            loginTitle1: "Welcome to",
            loginTitle2: "SUPSIS",
            email: "Your email adress",
            emailPlaceholder: "Please enter your e-mail address.",
            emailError: "Please Enter Valid Email",
            password: "Your password",
            passwordLogin: "Password Free Login",
            passwordAndLogin: "Login with Password",
            passwordNew: "Reset My Password",
            loginAnd: "Or",
            passwordPlaceholder: "Please enter your password.",
            loginMemory: "Remember this device",
            passwordForget: "I forgot my password",
            passwordNewAgain: "New Password",
            passwordNewAgainTwo: "New Password Repeat",
            passwordNewAgainPlaceholder: "Please enter your new password.",
            passwordNewAgainPlaceholderTwo: "Please re-enter your new password.",
            login: "Login",
            loginFooter: "Or, Sign In With Email",
            emailLogin: "Sign in with Email",
        },
        settings: {
            ipAddress: "My IP Address",
            whiteList: "Secure IP List",
            whiteListAdd: "Add Safe IP",
            whiteListDeletedSuccessfully: "Access Control deleted successfully",
            whiteListDeletedFailed: "Access Control failed to delete",
            whiteListAddedSuccessfully: "Access Control added successfully",
            whiteListAddedFailed: "Access Control failed to add",
            deleteWhiteListTitle: "Are you sure you want to delete this access control?",
            talkSettings: "Chat Settings",
            talkSubtitles: "Manage Your Chat Settings",
            dateAndTime: "Date and Time",
            actor: "Actor",
            event: "Event",
            accessControl: "Access Control",
            organizationLongName: "Organization Long Name",
            visitorNewDesc: "You can use the new version of the visitor theme.",
            transactionType: "Transaction Type",
            priorBalance: "Previous Balance",
            nextBalance: "Next Balance",
            amount: "Amount",
            phoneNumber: "Phone Number",
            profileInfoRemoved: "Profile information removed.",
            newValueUpdated: "New Value Updated.",
            balanceToTransferred: "Balance to be transferred",
            availableBalance: "Available Balance",
            balanceReceived: "Balance Received",
            totalBalance: "Total Balance",
            paymentCard: "Payment Card",
            wpPhoneNumber: "Whatsapp Phone Number",
            wpSendingMessage: "Whatsapp Sending First Message",
            auditlogs: "Audit Logs",
            myaccount: "My Account",
            notifications: "Notifications",
            company: "Company",
            features: "Features",
            general: "General",
            chat: "Chat",
            timings: "Timings",
            wallet: "Wallet",
            language: "Language",
            "bubble-settings": "Bubble Settings",
            "bubble-actions": "Bubble Actions",
            "theme-settings": "Theme Settings",
            visitorLoginForm: "Visitor Login Form",
            visitorAttribute: "Visitor Profile Information",
            timing_settings: "Chat Timing Settings",
            auto_assign: "Auto Chat Assign",
            availability: "Availability",
            "website-integration": "Website Integration",
            General: "General",
            Chat: "Chat",
            Timings: "Timings",
            Integration: "Integration",
            developer: "Developer",
            visitorNew: "Visitor Transition to New Design",
            companySubtitles: "Manage your company information.",
            featuresSubtitles: "Manage the smart features of Supsis.",
            languageSubtitles: "Manage your language settings.",
            bubbleSettings: "Bubble Settings",
            bubbleSettingsSubtitles: "Manage your bubble settings.",
            bubbleActionsSubtitles: "Manage your bubble actions.",
            chatThemeSettingsSubtitles: "Manage your chat theme settings.",
            visitorLoginFormSubtitles: "Manage your visitor login form settings.",
            chatTimingSettingsSubtitles: "Manage your chat timing settings.",
            webSiteIntegrationSubtitles: "Manage your website integration settings.",
            apiAccessTitle: "API Access",
            apiAccessSubtitles: "Manage your API access settings.",
            youTubeActionForm: "Add Your Youtube Channel",
            linkedinActionForm: "Add Your Linkedin Account",
            telegramActionForm: "Add Telegram Account",
            facebookActionForm: "Add Your Facebook Page",
            tiwitterActionForm: "Add Your Twitter Page",
            instagramActionForm: "Add Your Instagram Page",
            liveSupportDescription: "Open a live chat with your customers",
            ticketDescription: "Create a ticket for your customers",
            whatsappDescription: "Let your customers reach you via Whatsapp",
            phoneDescription: "Let your customers reach you via phone",
            emailDescription: "Let your customers reach you via email",
            facebookDescription: "Let your customers reach you via Facebook",
            twitterDescription: "Let your customers reach you via Twitter",
            instagramDescription: "Let your customers reach you via Instagram",
            youtubeDescription: "Let your customers reach you via Youtube",
            linkedinDescription: "Let your customers reach you with LinkedIn",
            telegramDescription: "Let your customers reach size with Telegram",
            whatsappModalTitle: "Whatsapp Transaction Form",
            whatsappModalDescription: "Please fill out the form below to connect your Whatsapp account.",
            phoneModalTitle: "Phone Transaction Form",
            phoneModalDescription: "Please fill out the form below to connect your phone account.",
            emailModalTitle: "E-mail Transaction Form",
            emailModalDescription: "Please fill out the form below to connect your e-mail account.",
            facebookModalTitle: "Facebook Transaction Form",
            facebookModalDescription: "Please fill out the form below to connect your Facebook account.",
            twitterModalTitle: "Twitter Transaction Form",
            twitterModalDescription: "Please fill out the form below to connect your Twitter account.",
            instagramModalTitle: "Instagram Transaction Form",
            instagramModalDescription: "Please fill out the form below to connect your Instagram account.",
            youtubeModalTitle: "Youtube Transaction Form",
            youtubeModalDescription: "Please fill out the form below to connect your Youtube account.",
            linkedinModalTitle: "LinkeIn Transaction Form",
            linkedinModalDescription: "Please fill out the form below to link your LinkedIn account.",
            telegramModalTitle: "Telegram Transaction Form",
            telegramModalDescription:
                "Enter your Telegram profile link in the form below to link your Telegram Account",
            instagramAlertTitle: "Instagram Integration Required",
            instagramAlertDesc: "Sorry, the page you visited will be activated when you integrate your Instagram.",
            instagramActivateText: "Let's go, Integrate Instagram",
            remove: "Remove",
            edit: "Edit",
            connected: "Connected",
            add: "Add",
            themeDescription: "Manage your theme settings.",
            fontDescription: "Manage your font settings.",
            isFabsAsIcon: "Show Menu Icon Texts.",
            chatBubbleTextSetting: "Chat Bubble Text Setting",
            textOnChatBubble: "You can adjust the text settings that will appear on the Chat Bubble.",
            textToAppearOnChatBubble: "Text to Appear on Chat Bubble",
            newVisitorProfileInformation: "New Visitor Profile Information",
            newVisitorProfileInformationDescription: "Adds new value to visitor profile information",
            create: "Create",
            newAdd: "Add New",
            toInform: "To inform",
            toInformDescription: "You can match the values you add on this page with the visitor login form.",
            showVisitor: "Show Visitor",
            label: "Label",
            text: "Text",
            email: "Mail",
            phone: "Phone",
            number: "Number",
            url: "URL",
            date: "Date",
            dropdown: "Dropdown",
            languageTimeZone: "Language and Region",
            timeZoneTitle: "Region & Time Zone",
            timeZoneDescription: "Region and time zone settings",
        },
        userInfoWidget: {
            userInformation: "User information",
            fullName: "Name and surname",
            newValue: "New Value",
            newProfileInfo: "New Profile Info",
            affiliatedRepresentatives: "Representatives",
            preferredAgents: "Preferred Agent(s)",
            labels: "Labels",
            agentNotes: "Agent Notes",
            newNote: "New Note",
            note: "Note",
            available: "There are notes available.",
            systemInformation: "System Information",
            speechID: "Chat ID",
            customerVersion: "Customer Version",
            IPAddress: "IP Address",
            pageVisited: "Page Visited",
            systemAndBrowser: "Operating System & Browser",
            countryAndLanguage: "Country and language",
            clickToEdit: "Edit Click inside the post",
            adsYouAreInterestedIn: "Ads You Are Interested In",
            detail: "Detail",
            adsTitle: "Title",
            adUrl: "Ad URL",
            sourceID: "Source ID",
            resourceType: "Resource Type",
            adsBody: "Content",
            adsCreateDate: "Creation Date",
            adsUpdateDate: "Update Date",
        },
        newWizartV2: {
            generalSettings: "General Settings",
            themeSettings: "Theme Settings",
            representativeWorkingHours: "Representative Working Hours",
            preview: "Preview",
            setup: "Setup",
            formStepTitle: "Give us more information so we can personalize your experience",
            supsisEntergation: "Where will you use Supsis on your website?:",
            goToNextStep: "Take Next Step",
            readytemplate: "Use Ready Color Template",
            customSettings: "Custom Settings",
            customerMessageView: "Customer message View",
            backcgroundColor: "Background Color",
            textColor: "Font Color",
            agentMessageView: "Agent Message View",
            workingHours: "What time intervals do you provide services to your visitors?",
            continuousService: "Continuous Service",
            continuousServiceDescription: "The chat bubble is always active. Even if you are not in the system.",
            vote: "Make your choice",
            representativeWorking: "Representative Working Hours",
            representativeWorkingDescription:
                "The chat appears online when at least 1 agent is online. If there is no online representative, it will appear as offline.",
            computer: "Computer",
            tablet: "Tablet",
            uploadTrackingCodeToYourWebsite: "Upload Tracking Code to Your Website",
            password: "Установить новый пароль",
        },
        whatsappChannel: {
            whatsappTitleV1: "Whatsapp V1 Channels (QR)",
            whatsappTitleV2: "Whatsapp V2 Channels (QR)",
            channelName: "Channel",
            phoneNumber: "Phone Number",
            forwardToChatbot: "Forward to Chatbot",
            forwardingChatbotOrLiveAgent: "Forwarding (Chatbot or Live Agent)",
            addChannel: "Add Channel",
            newWhatsappChannel: "New WhatsApp Channel",
            newWhatsappChannelDescription: "Create a new WhatsApp channel by scanning the QR code",
            editWhatsappChannel: "Edit WhatsApp Channel",
            editWhatsappChannelDescription: "Edit WhatsApp channel",
            whatsappChannel: "WhatsApp Channel",
            deleteWhatsappChannelDescription: "Are you sure you want to delete this channel?",
            whatsappIntegration: "WhatsApp Integration",
            deleteChannel: "Delete Channel",
            restartChannel: "Restart Channel",
            wantRestartChannel: "Do you want to restart the channel?",
            deleteSMSChannelDescription: "Are you sure you want to delete the SMS channel?",
            smsChannel: "SMS Channel",
            maxChannelCount: "You Cannot Create More than One SMS Channel!",
            smsModalText:
                "Our integration with modern communication solutions gives you the opportunity to send SMS easily and effectively. Remove boundaries in communication, connect directly with your customers!",
            smsModalBtn: "Click to Open SMS Channel...",
            postaCellDetail: "PostaCell Channel Detail",
        },
        noPermission: "You do not have permission to perform this operation. Please contact your manager.",
        mail_integration_detail: {
            title: "Mail Detail",
            integration: "Integration",
            sender: "Sender Mail",
            signature: "Signature",
            inbox: "Inbox",
            medias: "Media",
            visibility: "Visibility",
            settings_group: "Settings",
            contacts: "Contacts",
        },
        whatsapp_business_api: {
            userVisibility: "User Visibility",
            userVisibilityDesc:
                "The channels that users can access depend on their role and the visibility settings of the channel. Users with the Full Admin or root role can see all channels. If a channel's visibility settings are empty, the channel is public. However, if the channel is defined for specific users or departments, only those users or department members can see the channel.",
            searchTemplate: "Search template...",
            forwardToChatbot: "Inoltra al chatbot",
            forwarding: "Inoltro (Chatbot o Agente dal vivo)",
            forwardLiveAgents: "👉 Inoltra al supporto dal vivo",
            forwardingToDepartment: "Inoltro al reparto",
            selectDepartment: "Seleziona reparto",
            createWbChannel:
                "Per creare un canale Whatsapp Business, è necessario acquistare un pacchetto Whatsapp Business. Puoi accedere immediatamente a pacchetti convenienti.",
            wbCreateChannelMax: "Hai raggiunto il limite di creazione del canale Whatsapp Business. Massimo",
            wbContinue:
                "Puoi creare un canale Whatsapp Business. Per continuare, aggiorna il tuo pacchetto o elimina alcuni dei tuoi canali Whatsapp Business.",
            chatInitiatorTemplate: "Modello di avvio chat",
            selectChatInitiatorTemplate: "Seleziona il modello di avvio della chat.",
            dailyUsageReport: "Rapporto di utilizzo giornaliero",
            freeChat: "Chat gratuita",
            paidChat: "Chat a pagamento",
            templateMessage: "Messaggio modello",
            outgoingSession: "Sessione in uscita",
            incomingSession: "Sessione in arrivo",
            totalCost: "Costo totale",
            allOptNumbers: "Tutti i numeri opt-in.",
            startChat: "Inizia chat",
            lastMessageDate: "Data ultimo messaggio",
            sureDeleteTemplate: "Sei sicuro di voler eliminare questo modello?",
            manageWhoChannelChat: "Gestisci chi può vedere queste chat di canale",
            profileImageDesc: "This will be the WhatsApp screenshot of your business",
            bussinesDescription: "Business Description",
            descOfWork: "Description of your business in a few words (Maximum 512 Characters)",
            accountStatus: "Account Status",
            dockerStatus: "Docker Status",
            phoneQuality: "Phone Quality",
            customersOrDay: "Customers/Day",
            messagingLimit: "Messaging Limit",
            canSendMessage: "Message Can Be Sent",
            officialDetails: "Official Details",
            officialDetailsDesc:
                "These addresses will always be shown in the profile section to users who chat with you on WhatsApp. After editing, we will send them to WhatsApp for approval.",
            addressLine: "Address Line",
            stateIfApplic: "State (if applicable)",
            zipCodeOrPostCode: "Zip Code/Postal Code",
            selectCountry: "Select Country",
            selectBussVertical: "Select Business Area",
            saveInfo: "Save Information",
            active: "Active",
            banned: "Banned",
            low: "Low",
            medium: "Medium",
            high: "High",
            connected: "Connected",
            disConnected: "Disconnected",
            flagged: "Flagged",
            pending: "Pending",
            restricted: "Restricted",
            unknown: "Unknown",
            available: "Available",
            limited: "Limited",
            blocked: "Blocked",
            success: "Success",
            successDesc: "Your profile information was successfully updated.",
            wabaOverview: "WABA Health Overview",
            manageChannelDetail: "Manage your channel information",
            wpBussChannelDetail: "Whatsapp Business Channel Detail",
            manageWpBussChannel: "Manage your Whatsapp business channel",
            channelName: "Channel Name",
            phoneNumberE164: "Phone Number (E164 Format)",
            phoneNumberE164Place: "Phone Number (E164 Format). e.g. 908501234455",
            channelUpdatedSucs: "Channel updated successfully",
            faieldUpdateChannel: "Failed to update channel",
            title: "Whatsapp Business API Channels",
            integration: "Integration",
            detail: "Detail",
            visibility: "Visibility",
            templates: "All Template Messages",
            settings_group: "Setting",
            template_message_group: "Template Messages",
            chat_initiator_template: "Chat Initiator Template",
            contacts: "Contacts",
            numbers: "Numbers",
            all_contacts: "All Contacts",
            new_template: "Create new Template",
            broadcast_group: "Broadcast",
            broadcast_requests: "Broadcast Requests",
            customer_groups: "Customer Groups",
            businessChannelDetail: "Whatsapp Business Channel Detail",
            wallet: "Wallet",
            postacellMessage: "Send SMS",
            postacellAllMessage: "Send Bulk SMS",
            message_group: "Message",
            createNewTemplate: "Create a new template message",
            templateName: "Template name",
            templateNameDesc: "Give a name to your message template.",
            templateInfo: "Template İnformation",
            viewTemplates: "View templates",
            templateNameRules: "Template name can only include lowercase letters, numbers, and underscores.",
            category: "Category",
            categoryDesc: "Select what type of template you want to create",
            categoryUtility: "Utility",
            categoryUtilityDesc: "Send utility information such as account updates, order updates, alerts, and more.",
            categoryMarketing: "Marketing",
            categoryMarketingDesc:
                "Send promotional offers, product offers, and more to increase awareness and engagement.",
            categoryAuth: "Authentication",
            categoryAuthDesc: "Send codes for your customers to access their accounts.",
            optional: "Optional",
            languageDesc: "Select the language in which your template message will be sent",
            header: "Header",
            headerRules: "Add a 60-character header to your message. Only one variable is supported in the header.",
            headerOptionMedia: "Media",
            headerOptionText: "Text",
            none: "None",
            headerType: "Header Type",
            headerText: "Header Text",
            body: "Body",
            bodyRules: "Enter text in the language you selected for your message",
            addVariable: "Add Variable",
            variables: "Variables",
            variable: "Variable",
            defaultVariableName: "Default Variable Name",
            defaultVariableToolTip:
                "Your variable appears in the template with this name. <br><br> Additionally, this value is sent as the default in case of other situations.",
            selectATemplate: "Select a Message Template",
            variableSettings: "Variable settings",
            example: "Example",
            footer: "Footer",
            footerDesc: "Add a 60-character footer to your message. Variables are not supported in the footer.",
            buttons: "Buttons",
            buttonType: "Button Type",
            buttonTypeReply: "Reply",
            submit: "Save",
            submitting: "Submitting",
            addButton: "Add Button",
            rejectWhatsapp: "Rejected by Whatsapp.",
            approvedWhatsapp: "Approved by Whatsapp.",
            pendingWhatsapp: "Pending Approval",
            daily_usages: "Daily Usages",
        },
        multi_whatsapp_api: {
            profile: "Profile",
            integration: "Integration",
            detail: "Detail",
            visibility: "Visibility",
            templates: "Template",
            settings_group: "Settings",
            template_message_group: "Template Messages",
            new_template: "New Template",
            broadcast_group: "Broad Cast",
            broadcast_requests: "Broad Cast Request",
            customer_groups: "Customer Groups",
            chat_initiator_template: "Chat İnitiator Template",
            contacts: "Contacts",
            numbers: "Numbers",
            all_contacts: "All Contacts",
        },
        archive: {
            destroyedBy: {
                agent: "Agent",
                visitor: "Visitor",
                system: "System",
                chatbot: "Chatbot",
            },
        },
        upgradeMessages: {
            ticket: "Even if you are offline, your requests are recorded instantly with artificial intelligence and chatbot. Always keep your customers satisfied!",
            tasks: "Easily manage your tasks and projects. Collaborate with your team and deliver projects on time!",
            calendar:
                "Easily plan your appointments and meetings. Stay in sync with your team and manage your time more efficiently!",
            mail_integration:
                "Easily manage your emails. Strengthen communication with your customers and improve collaboration!",
            team_integration:
                "Communicate faster and more effectively with your team. Enhance collaboration and ensure timely project delivery!",
            webhook_integration: "Connect your applications using Webhook integration and simplify data exchange!",
            whatsapp_v2:
                "Improve communication with your customers through WhatsApp integration for faster and more efficient communication!",
            whatsapp:
                "Enhance communication with your customers using WhatsApp integration for faster and more effective communication!",
            whatsapp_business_api:
                "Take advantage of WhatsApp Business API to communicate with your customers more efficiently and effectively!",
            instagram: "Engage with your customers more effectively using Instagram integration!",
            messenger: "Communicate with your customers easily via Messenger integration!",
            sms_postacell: "Communicate quickly and effectively with your customers using SMS integration!",
            ready_contents: "Ready Contents help you communicate with your customers faster and more effectively.",
            automation: "Automate your workflows to save time and manage tasks more efficiently!",
            form: "Use the Form Builder to streamline customer interactions, collect valuable information, and enhance collaboration!",
            customer_tables: "Create custom tables and manage customer information efficiently!",
            trendyol:
                "Enhance communication with your customers through Trendyol integration for seamless interaction!",
            access_control: "Protect your data and prevent unauthorized access with access control features!",
            upgrade: "Upgrade My Subscription",
            upgradeFeature: "Buy Additional Package",
            featureNotAvailable: "feature not available.",
            usageLimitExceeded: "Usage limit exceeded.",
            maxAgentCount: "Upgrade your plan to serve more customers by adding additional agents.",
            maxTriggerCount: "Upgrade your plan to create more interactions by adding additional triggers.",
            visitorStartChat: "Upgrade your plan to initiate chats with visitors who haven't interacted before.",
            voiceCalling: "Upgrade your plan to communicate more effectively with customers through voice calls.",
            videoCalling: "Upgrade your plan to communicate more effectively with customers through video calls.",
            fileAndVoiceMessage: "Upgrade your plan to send files and voice messages to your customers.",
            autoTranslation: "Upgrade your plan to serve more customers with automatic message translation.",
            telegramEntegration: "Upgrade your plan to enable Telegram integration.",
            chatCopilot: "Upgrade your plan to provide better service with AI-powered Chat Copilot.",
            calenderEntegration:
                "Upgrade your plan to synchronize with other applications through calendar integration.",
            mailEntegration: "Upgrade your plan to manage emails more effectively and improve customer communication.",
            smsEntegration: "Upgrade your plan to reach customers faster with SMS integration.",
            ticketSystem: "Upgrade your plan to manage customer requests more efficiently with a ticket system.",
            taskManagementEntegration: "Upgrade your plan to streamline workflows with task management integration.",
            webhookEntegration: "Upgrade your plan to synchronize with other applications via webhook integration.",
            readyContents: "Upgrade your plan to enhance customer communication with ready-made content.",
            automationEntegration: "Upgrade your plan to streamline workflows with automation integration.",
            customerTablesEntegration:
                "Upgrade your plan to manage customer data more effectively with customer tables.",
            formEntegration: "Upgrade your plan to manage customer requests more efficiently using forms.",
            maxFormLimit: "Upgrade your plan to create more forms and manage customer requests more effectively.",
            maxFormFieldLimit: "Upgrade your plan to add more form fields and manage customer requests efficiently.",
            maxCustomerTableCount: "Upgrade your plan to add more customer tables.",
            maxCustomerTableFieldCount: "Upgrade your plan to add more customer table fields.",
            maxCustomerTableViewCount: "Upgrade your plan to save more customer table views.",
            maxCustomerTableRecordCount: "Upgrade your plan to add more customer table records.",
            maxAutomationButton: "Upgrade your plan to add more automation blocks.",
            automationTimerBase: "Upgrade your plan to use automation timers.",
            automationEventBase: "Upgrade your plan to use automation events.",
            automationWebhookBase: "Upgrade your plan to use automation webhooks.",
            automationButtonBase: "Upgrade your plan to use automation buttons.",
            liveScore: "Upgrade your plan to enable live monitoring.",
            multipleChatWindow: "Upgrade your plan to open multiple chat windows simultaneously.",
            maxTaskWorkflowLimit: "Upgrade your plan to add more task workflows.",
            maxTaskColumnLimit: "Upgrade your plan to add more task columns.",
            maxTaskRowLimit: "Upgrade your plan to add more task rows.",
            maxDepartmentLimit: "Upgrade your plan to add more departments.",
            maxRoleLimit: "Upgrade your plan to add more roles.",
            maxReadyContentsLimit: "Upgrade your plan to add more ready-made content.",
            excelDownload: "Upgrade your plan to enable Excel download functionality.",
            customerGroup: "Upgrade your plan to utilize customer group features.",
            maxMailCount: "Upgrade your plan to send more emails.",
            maxWhatsappChannel: "Upgrade your plan to add more WhatsApp channels.",
            maxBusinessWhatsappChannel: "Upgrade your plan to add more WhatsApp Business channels.",
            maxInstagramChannel: "Upgrade your plan to add more Instagram channels.",
            maxMessengerChannel: "Upgrade your plan to add more Messenger channels.",
            maxTelegramChannel: "Upgrade your plan to add more Telegram channels.",
            maxTrendyolChannel: "Upgrade your plan to add more Trendyol channels.",
            maxMetaLeadChannel: "Upgrade your plan to add more Meta Lead channels.",
        },
    },
};

export default messagesEN;
